export interface ParameterSheetMappingEntry { intro2SeriesName: string; intro2ModelKey: string; }
export const PARAMETER_SHEET_MODEL_MAPPING: Record<string, ParameterSheetMappingEntry> = {
  "AS10010": { intro2SeriesName: "AS", intro2ModelKey: "100-10" },
  "AS100100": { intro2SeriesName: "AS", intro2ModelKey: "100-100" },
  "AS10020": { intro2SeriesName: "AS", intro2ModelKey: "100-20" },
  "AS100202": { intro2SeriesName: "AS", intro2ModelKey: "100-20-2" },
  "AS10030": { intro2SeriesName: "AS", intro2ModelKey: "100-30" },
  "AS100302": { intro2SeriesName: "AS", intro2ModelKey: "100-30-2" },
  "AS10040": { intro2SeriesName: "AS", intro2ModelKey: "100-40" },
  "AS100402": { intro2SeriesName: "AS", intro2ModelKey: "100-40-2" },
  "AS10050": { intro2SeriesName: "AS", intro2ModelKey: "100-50" },
  "AS100502": { intro2SeriesName: "AS", intro2ModelKey: "100-50-2" },
  "AS10060": { intro2SeriesName: "AS", intro2ModelKey: "100-60" },
  "AS100602": { intro2SeriesName: "AS", intro2ModelKey: "100-60-2" },
  "AS10070": { intro2SeriesName: "AS", intro2ModelKey: "100-70" },
  "AS10080": { intro2SeriesName: "AS", intro2ModelKey: "100-80" },
  "AS10090": { intro2SeriesName: "AS", intro2ModelKey: "100-90" },
  "AS100902": { intro2SeriesName: "AS", intro2ModelKey: "100-90-2" },
  "AS10100": { intro2SeriesName: "AS", intro2ModelKey: "10-100" },
  "AS10110": { intro2SeriesName: "AS", intro2ModelKey: "10-110" },
  "AS10120": { intro2SeriesName: "AS", intro2ModelKey: "10-120" },
  "AS10130": { intro2SeriesName: "AS", intro2ModelKey: "10-130" },
  "AS10140": { intro2SeriesName: "AS", intro2ModelKey: "10-140" },
  "AS10150": { intro2SeriesName: "AS", intro2ModelKey: "10-150" },
  "AS10160": { intro2SeriesName: "AS", intro2ModelKey: "10-160" },
  "AS10170": { intro2SeriesName: "AS", intro2ModelKey: "10-170" },
  "AS10180": { intro2SeriesName: "AS", intro2ModelKey: "10-180" },
  "AS10190": { intro2SeriesName: "AS", intro2ModelKey: "10-190" },
  "AS1020": { intro2SeriesName: "AS", intro2ModelKey: "10-20" },
  "AS10200": { intro2SeriesName: "AS", intro2ModelKey: "10-200" },
  "AS10210": { intro2SeriesName: "AS", intro2ModelKey: "10-210" },
  "AS10220": { intro2SeriesName: "AS", intro2ModelKey: "10-220" },
  "AS10230": { intro2SeriesName: "AS", intro2ModelKey: "10-230" },
  "AS10240": { intro2SeriesName: "AS", intro2ModelKey: "10-240" },
  "AS10250": { intro2SeriesName: "AS", intro2ModelKey: "10-250" },
  "AS1030": { intro2SeriesName: "AS", intro2ModelKey: "10-30" },
  "AS1040": { intro2SeriesName: "AS", intro2ModelKey: "10-40" },
  "AS1050": { intro2SeriesName: "AS", intro2ModelKey: "10-50" },
  "AS1060": { intro2SeriesName: "AS", intro2ModelKey: "10-60" },
  "AS1070": { intro2SeriesName: "AS", intro2ModelKey: "10-70" },
  "AS1080": { intro2SeriesName: "AS", intro2ModelKey: "10-80" },
  "AS1090": { intro2SeriesName: "AS", intro2ModelKey: "10-90" },
  "AS1100": { intro2SeriesName: "AS", intro2ModelKey: "1-100" },
  "AS1110": { intro2SeriesName: "AS", intro2ModelKey: "1-110" },
  "AS1120": { intro2SeriesName: "AS", intro2ModelKey: "1-120" },
  "AS1130": { intro2SeriesName: "AS", intro2ModelKey: "1-130" },
  "AS1150": { intro2SeriesName: "AS", intro2ModelKey: "1-150" },
  "AS1170": { intro2SeriesName: "AS", intro2ModelKey: "1-170" },
  "AS120": { intro2SeriesName: "AS", intro2ModelKey: "1-20" },
  "AS1210": { intro2SeriesName: "AS", intro2ModelKey: "1-210" },
  "AS12100": { intro2SeriesName: "AS", intro2ModelKey: "12-100" },
  "AS12110": { intro2SeriesName: "AS", intro2ModelKey: "12-110" },
  "AS12120": { intro2SeriesName: "AS", intro2ModelKey: "12-120" },
  "AS12130": { intro2SeriesName: "AS", intro2ModelKey: "12-130" },
  "AS12140": { intro2SeriesName: "AS", intro2ModelKey: "12-140" },
  "AS12150": { intro2SeriesName: "AS", intro2ModelKey: "12-150" },
  "AS12160": { intro2SeriesName: "AS", intro2ModelKey: "12-160" },
  "AS12170": { intro2SeriesName: "AS", intro2ModelKey: "12-170" },
  "AS12180": { intro2SeriesName: "AS", intro2ModelKey: "12-180" },
  "AS12190": { intro2SeriesName: "AS", intro2ModelKey: "12-190" },
  "AS1220": { intro2SeriesName: "AS", intro2ModelKey: "12-20" },
  "AS12200": { intro2SeriesName: "AS", intro2ModelKey: "12-200" },
  "AS1230": { intro2SeriesName: "AS", intro2ModelKey: "1-230" },
  "AS1240": { intro2SeriesName: "AS", intro2ModelKey: "12-40" },
  "AS1250": { intro2SeriesName: "AS", intro2ModelKey: "1-250" },
  "AS1260": { intro2SeriesName: "AS", intro2ModelKey: "12-60" },
  "AS1270": { intro2SeriesName: "AS", intro2ModelKey: "1-270" },
  "AS1280": { intro2SeriesName: "AS", intro2ModelKey: "12-80" },
  "AS1290": { intro2SeriesName: "AS", intro2ModelKey: "12-90" },
  "AS130": { intro2SeriesName: "AS", intro2ModelKey: "1-30" },
  "AS1300": { intro2SeriesName: "AS", intro2ModelKey: "1-300" },
  "AS13010": { intro2SeriesName: "AS", intro2ModelKey: "130-10" },
  "AS130100": { intro2SeriesName: "AS", intro2ModelKey: "130-100" },
  "AS13020": { intro2SeriesName: "AS", intro2ModelKey: "130-20" },
  "AS130201": { intro2SeriesName: "AS", intro2ModelKey: "130-20-1" },
  "AS13030": { intro2SeriesName: "AS", intro2ModelKey: "130-30" },
  "AS130301": { intro2SeriesName: "AS", intro2ModelKey: "130-30-1" },
  "AS13040": { intro2SeriesName: "AS", intro2ModelKey: "130-40" },
  "AS130402": { intro2SeriesName: "AS", intro2ModelKey: "130-40-2" },
  "AS13050": { intro2SeriesName: "AS", intro2ModelKey: "130-50" },
  "AS13060": { intro2SeriesName: "AS", intro2ModelKey: "130-60" },
  "AS13070": { intro2SeriesName: "AS", intro2ModelKey: "130-70" },
  "AS13080": { intro2SeriesName: "AS", intro2ModelKey: "130-80" },
  "AS13090": { intro2SeriesName: "AS", intro2ModelKey: "130-90" },
  "AS1330": { intro2SeriesName: "AS", intro2ModelKey: "1-330" },
  "AS1350": { intro2SeriesName: "AS", intro2ModelKey: "1-350" },
  "AS1360": { intro2SeriesName: "AS", intro2ModelKey: "1-360" },
  "AS140": { intro2SeriesName: "AS", intro2ModelKey: "1-40" },
  "AS150": { intro2SeriesName: "AS", intro2ModelKey: "1-50" },
  "AS1510": { intro2SeriesName: "AS", intro2ModelKey: "AS15-10" },
  "AS15100": { intro2SeriesName: "AS", intro2ModelKey: "AS15-100" },
  "AS15110": { intro2SeriesName: "AS", intro2ModelKey: "AS15-110" },
  "AS15120": { intro2SeriesName: "AS", intro2ModelKey: "AS15-120" },
  "AS15130": { intro2SeriesName: "AS", intro2ModelKey: "AS15-130" },
  "AS15140": { intro2SeriesName: "AS", intro2ModelKey: "AS15-140" },
  "AS15150": { intro2SeriesName: "AS", intro2ModelKey: "AS15-150" },
  "AS15160": { intro2SeriesName: "AS", intro2ModelKey: "AS15-160" },
  "AS15170": { intro2SeriesName: "AS", intro2ModelKey: "AS15-170" },
  "AS15180": { intro2SeriesName: "AS", intro2ModelKey: "AS15-180" },
  "AS1520": { intro2SeriesName: "AS", intro2ModelKey: "AS15-20" },
  "AS1530": { intro2SeriesName: "AS", intro2ModelKey: "AS15-30" },
  "AS1540": { intro2SeriesName: "AS", intro2ModelKey: "AS15-40" },
  "AS1550": { intro2SeriesName: "AS", intro2ModelKey: "AS15-50" },
  "AS1560": { intro2SeriesName: "AS", intro2ModelKey: "AS15-60" },
  "AS1570": { intro2SeriesName: "AS", intro2ModelKey: "AS15-70" },
  "AS1580": { intro2SeriesName: "AS", intro2ModelKey: "AS15-80" },
  "AS1590": { intro2SeriesName: "AS", intro2ModelKey: "AS15-90" },
  "AS160": { intro2SeriesName: "AS", intro2ModelKey: "1-60" },
  "AS16010": { intro2SeriesName: "AS", intro2ModelKey: "160-10" },
  "AS160101": { intro2SeriesName: "AS", intro2ModelKey: "160-10-1" },
  "AS16020": { intro2SeriesName: "AS", intro2ModelKey: "160-20" },
  "AS160201": { intro2SeriesName: "AS", intro2ModelKey: "160-20-1" },
  "AS160202": { intro2SeriesName: "AS", intro2ModelKey: "160-20-2" },
  "AS16030": { intro2SeriesName: "AS", intro2ModelKey: "160-30" },
  "AS160301": { intro2SeriesName: "AS", intro2ModelKey: "160-30-1" },
  "AS160302": { intro2SeriesName: "AS", intro2ModelKey: "160-30-2" },
  "AS16040": { intro2SeriesName: "AS", intro2ModelKey: "160-40" },
  "AS160401": { intro2SeriesName: "AS", intro2ModelKey: "160-40-1" },
  "AS160402": { intro2SeriesName: "AS", intro2ModelKey: "160-40-2" },
  "AS16050": { intro2SeriesName: "AS", intro2ModelKey: "160-50" },
  "AS160502": { intro2SeriesName: "AS", intro2ModelKey: "160-50-2" },
  "AS16060": { intro2SeriesName: "AS", intro2ModelKey: "160-60" },
  "AS16070": { intro2SeriesName: "AS", intro2ModelKey: "160-70" },
  "AS16100": { intro2SeriesName: "AS", intro2ModelKey: "AS16-100" },
  "AS16110": { intro2SeriesName: "AS", intro2ModelKey: "AS16-110" },
  "AS16120": { intro2SeriesName: "AS", intro2ModelKey: "AS16-120" },
  "AS16130": { intro2SeriesName: "AS", intro2ModelKey: "AS16-130" },
  "AS16140": { intro2SeriesName: "AS", intro2ModelKey: "AS16-140" },
  "AS16150": { intro2SeriesName: "AS", intro2ModelKey: "AS16-150" },
  "AS16160": { intro2SeriesName: "AS", intro2ModelKey: "AS16-160" },
  "AS16170": { intro2SeriesName: "AS", intro2ModelKey: "AS16-170" },
  "AS1620": { intro2SeriesName: "AS", intro2ModelKey: "AS16-20" },
  "AS1630": { intro2SeriesName: "AS", intro2ModelKey: "AS16-30" },
  "AS1640": { intro2SeriesName: "AS", intro2ModelKey: "AS16-40" },
  "AS1650": { intro2SeriesName: "AS", intro2ModelKey: "AS16-50" },
  "AS1660": { intro2SeriesName: "AS", intro2ModelKey: "AS16-60" },
  "AS1670": { intro2SeriesName: "AS", intro2ModelKey: "AS16-70" },
  "AS1680": { intro2SeriesName: "AS", intro2ModelKey: "AS16-80" },
  "AS1690": { intro2SeriesName: "AS", intro2ModelKey: "AS16-90" },
  "AS170": { intro2SeriesName: "AS", intro2ModelKey: "1-70" },
  "AS180": { intro2SeriesName: "AS", intro2ModelKey: "1-80" },
  "AS190": { intro2SeriesName: "AS", intro2ModelKey: "1-90" },
  "AS19010": { intro2SeriesName: "AS", intro2ModelKey: "190-10" },
  "AS19020": { intro2SeriesName: "AS", intro2ModelKey: "190-20" },
  "AS19030": { intro2SeriesName: "AS", intro2ModelKey: "190-30" },
  "AS19040": { intro2SeriesName: "AS", intro2ModelKey: "190-40" },
  "AS19050": { intro2SeriesName: "AS", intro2ModelKey: "190-50" },
  "AS19060": { intro2SeriesName: "AS", intro2ModelKey: "190-60" },
  "AS19070": { intro2SeriesName: "AS", intro2ModelKey: "190-70" },
  "AS19080": { intro2SeriesName: "AS", intro2ModelKey: "190-80" },
  "AS2010": { intro2SeriesName: "AS", intro2ModelKey: "AS20-10" },
  "AS20100": { intro2SeriesName: "AS", intro2ModelKey: "AS20-100" },
  "AS20110": { intro2SeriesName: "AS", intro2ModelKey: "AS20-110" },
  "AS20120": { intro2SeriesName: "AS", intro2ModelKey: "AS20-120" },
  "AS20140": { intro2SeriesName: "AS", intro2ModelKey: "AS20-140" },
  "AS2020": { intro2SeriesName: "AS", intro2ModelKey: "AS20-20" },
  "AS20202": { intro2SeriesName: "AS", intro2ModelKey: "AS20-20-2" },
  "AS2030": { intro2SeriesName: "AS", intro2ModelKey: "AS20-30" },
  "AS2040": { intro2SeriesName: "AS", intro2ModelKey: "AS20-40" },
  "AS2050": { intro2SeriesName: "AS", intro2ModelKey: "AS20-50" },
  "AS2060": { intro2SeriesName: "AS", intro2ModelKey: "AS20-60" },
  "AS2070": { intro2SeriesName: "AS", intro2ModelKey: "AS20-70" },
  "AS2080": { intro2SeriesName: "AS", intro2ModelKey: "AS20-80" },
  "AS2090": { intro2SeriesName: "AS", intro2ModelKey: "AS20-90" },
  "AS2100": { intro2SeriesName: "AS", intro2ModelKey: "2-100" },
  "AS2110": { intro2SeriesName: "AS", intro2ModelKey: "2-110" },
  "AS2120": { intro2SeriesName: "AS", intro2ModelKey: "2-120" },
  "AS2130": { intro2SeriesName: "AS", intro2ModelKey: "2-130" },
  "AS2140": { intro2SeriesName: "AS", intro2ModelKey: "2-140" },
  "AS2150": { intro2SeriesName: "AS", intro2ModelKey: "2-150" },
  "AS2160": { intro2SeriesName: "AS", intro2ModelKey: "2-160" },
  "AS2170": { intro2SeriesName: "AS", intro2ModelKey: "2-170" },
  "AS2180": { intro2SeriesName: "AS", intro2ModelKey: "2-180" },
  "AS2190": { intro2SeriesName: "AS", intro2ModelKey: "2-190" },
  "AS220": { intro2SeriesName: "AS", intro2ModelKey: "2-20" },
  "AS2200": { intro2SeriesName: "AS", intro2ModelKey: "2-200" },
  "AS2210": { intro2SeriesName: "AS", intro2ModelKey: "2-210" },
  "AS2220": { intro2SeriesName: "AS", intro2ModelKey: "2-220" },
  "AS2230": { intro2SeriesName: "AS", intro2ModelKey: "2-230" },
  "AS2240": { intro2SeriesName: "AS", intro2ModelKey: "2-240" },
  "AS2250": { intro2SeriesName: "AS", intro2ModelKey: "2-250" },
  "AS2260": { intro2SeriesName: "AS", intro2ModelKey: "2-260" },
  "AS2270": { intro2SeriesName: "AS", intro2ModelKey: "2-270" },
  "AS2280": { intro2SeriesName: "AS", intro2ModelKey: "2-280" },
  "AS2290": { intro2SeriesName: "AS", intro2ModelKey: "2-290" },
  "AS230": { intro2SeriesName: "AS", intro2ModelKey: "2-30" },
  "AS2300": { intro2SeriesName: "AS", intro2ModelKey: "2-300" },
  "AS2310": { intro2SeriesName: "AS", intro2ModelKey: "2-310" },
  "AS2320": { intro2SeriesName: "AS", intro2ModelKey: "2-320" },
  "AS240": { intro2SeriesName: "AS", intro2ModelKey: "2-40" },
  "AS250": { intro2SeriesName: "AS", intro2ModelKey: "2-50" },
  "AS260": { intro2SeriesName: "AS", intro2ModelKey: "2-60" },
  "AS270": { intro2SeriesName: "AS", intro2ModelKey: "2-70" },
  "AS280": { intro2SeriesName: "AS", intro2ModelKey: "2-80" },
  "AS290": { intro2SeriesName: "AS", intro2ModelKey: "2-90" },
  "AS3100": { intro2SeriesName: "AS", intro2ModelKey: "3-100" },
  "AS3110": { intro2SeriesName: "AS", intro2ModelKey: "3-110" },
  "AS3120": { intro2SeriesName: "AS", intro2ModelKey: "3-120" },
  "AS3140": { intro2SeriesName: "AS", intro2ModelKey: "3-140" },
  "AS3160": { intro2SeriesName: "AS", intro2ModelKey: "3-160" },
  "AS3180": { intro2SeriesName: "AS", intro2ModelKey: "3-180" },
  "AS320": { intro2SeriesName: "AS", intro2ModelKey: "3-20" },
  "AS3200": { intro2SeriesName: "AS", intro2ModelKey: "3-200" },
  "AS3210": { intro2SeriesName: "AS", intro2ModelKey: "32-10" },
  "AS32100": { intro2SeriesName: "AS", intro2ModelKey: "32-100" },
  "AS321002": { intro2SeriesName: "AS", intro2ModelKey: "32-100-2" },
  "AS32101": { intro2SeriesName: "AS", intro2ModelKey: "32-10-1" },
  "AS32110": { intro2SeriesName: "AS", intro2ModelKey: "32-110" },
  "AS32120": { intro2SeriesName: "AS", intro2ModelKey: "32-120" },
  "AS32130": { intro2SeriesName: "AS", intro2ModelKey: "32-130" },
  "AS32140": { intro2SeriesName: "AS", intro2ModelKey: "32-140" },
  "AS32150": { intro2SeriesName: "AS", intro2ModelKey: "32-150" },
  "AS32160": { intro2SeriesName: "AS", intro2ModelKey: "32-160" },
  "AS32170": { intro2SeriesName: "AS", intro2ModelKey: "32-170" },
  "AS3220": { intro2SeriesName: "AS", intro2ModelKey: "3-220" },
  "AS32202": { intro2SeriesName: "AS", intro2ModelKey: "32-20-2" },
  "AS3230": { intro2SeriesName: "AS", intro2ModelKey: "32-30" },
  "AS32302": { intro2SeriesName: "AS", intro2ModelKey: "32-30-2" },
  "AS3240": { intro2SeriesName: "AS", intro2ModelKey: "3-240" },
  "AS32402": { intro2SeriesName: "AS", intro2ModelKey: "32-40-2" },
  "AS3250": { intro2SeriesName: "AS", intro2ModelKey: "3-250" },
  "AS32502": { intro2SeriesName: "AS", intro2ModelKey: "32-50-2" },
  "AS3260": { intro2SeriesName: "AS", intro2ModelKey: "3-260" },
  "AS32602": { intro2SeriesName: "AS", intro2ModelKey: "32-60-2" },
  "AS3270": { intro2SeriesName: "AS", intro2ModelKey: "32-70" },
  "AS32702": { intro2SeriesName: "AS", intro2ModelKey: "32-70-2" },
  "AS3280": { intro2SeriesName: "AS", intro2ModelKey: "3-280" },
  "AS32802": { intro2SeriesName: "AS", intro2ModelKey: "32-80-2" },
  "AS3290": { intro2SeriesName: "AS", intro2ModelKey: "32-90" },
  "AS32902": { intro2SeriesName: "AS", intro2ModelKey: "32-90-2" },
  "AS330": { intro2SeriesName: "AS", intro2ModelKey: "3-30" },
  "AS3300": { intro2SeriesName: "AS", intro2ModelKey: "3-300" },
  "AS3320": { intro2SeriesName: "AS", intro2ModelKey: "3-320" },
  "AS3340": { intro2SeriesName: "AS", intro2ModelKey: "3-340" },
  "AS3360": { intro2SeriesName: "AS", intro2ModelKey: "3-360" },
  "AS340": { intro2SeriesName: "AS", intro2ModelKey: "3-40" },
  "AS350": { intro2SeriesName: "AS", intro2ModelKey: "3-50" },
  "AS360": { intro2SeriesName: "AS", intro2ModelKey: "3-60" },
  "AS370": { intro2SeriesName: "AS", intro2ModelKey: "3-70" },
  "AS380": { intro2SeriesName: "AS", intro2ModelKey: "3-80" },
  "AS390": { intro2SeriesName: "AS", intro2ModelKey: "3-90" },
  "AS4100": { intro2SeriesName: "AS", intro2ModelKey: "4-100" },
  "AS4110": { intro2SeriesName: "AS", intro2ModelKey: "4-110" },
  "AS4120": { intro2SeriesName: "AS", intro2ModelKey: "4-120" },
  "AS4130": { intro2SeriesName: "AS", intro2ModelKey: "4-130" },
  "AS4140": { intro2SeriesName: "AS", intro2ModelKey: "4-140" },
  "AS4150": { intro2SeriesName: "AS", intro2ModelKey: "4-150" },
  "AS4160": { intro2SeriesName: "AS", intro2ModelKey: "4-160" },
  "AS4170": { intro2SeriesName: "AS", intro2ModelKey: "4-170" },
  "AS4180": { intro2SeriesName: "AS", intro2ModelKey: "4-180" },
  "AS4190": { intro2SeriesName: "AS", intro2ModelKey: "4-190" },
  "AS420": { intro2SeriesName: "AS", intro2ModelKey: "4-20" },
  "AS4200": { intro2SeriesName: "AS", intro2ModelKey: "4-200" },
  "AS4210": { intro2SeriesName: "AS", intro2ModelKey: "4-210" },
  "AS4220": { intro2SeriesName: "AS", intro2ModelKey: "4-220" },
  "AS4230": { intro2SeriesName: "AS", intro2ModelKey: "4-230" },
  "AS4240": { intro2SeriesName: "AS", intro2ModelKey: "4-240" },
  "AS4250": { intro2SeriesName: "AS", intro2ModelKey: "4-250" },
  "AS4260": { intro2SeriesName: "AS", intro2ModelKey: "4-260" },
  "AS4270": { intro2SeriesName: "AS", intro2ModelKey: "4-270" },
  "AS4280": { intro2SeriesName: "AS", intro2ModelKey: "4-280" },
  "AS4290": { intro2SeriesName: "AS", intro2ModelKey: "4-290" },
  "AS430": { intro2SeriesName: "AS", intro2ModelKey: "4-30" },
  "AS4300": { intro2SeriesName: "AS", intro2ModelKey: "4-300" },
  "AS440": { intro2SeriesName: "AS", intro2ModelKey: "4-40" },
  "AS450": { intro2SeriesName: "AS", intro2ModelKey: "4-50" },
  "AS4510": { intro2SeriesName: "AS", intro2ModelKey: "45-10" },
  "AS45100": { intro2SeriesName: "AS", intro2ModelKey: "45-100" },
  "AS45101": { intro2SeriesName: "AS", intro2ModelKey: "45-10-1" },
  "AS45110": { intro2SeriesName: "AS", intro2ModelKey: "45-110" },
  "AS45120": { intro2SeriesName: "AS", intro2ModelKey: "45-120" },
  "AS45130": { intro2SeriesName: "AS", intro2ModelKey: "45-130" },
  "AS4520": { intro2SeriesName: "AS", intro2ModelKey: "45-20" },
  "AS45202": { intro2SeriesName: "AS", intro2ModelKey: "45-20-2" },
  "AS4530": { intro2SeriesName: "AS", intro2ModelKey: "45-30" },
  "AS45302": { intro2SeriesName: "AS", intro2ModelKey: "45-30-2" },
  "AS4540": { intro2SeriesName: "AS", intro2ModelKey: "45-40" },
  "AS45402": { intro2SeriesName: "AS", intro2ModelKey: "45-40-2" },
  "AS4550": { intro2SeriesName: "AS", intro2ModelKey: "45-50" },
  "AS45502": { intro2SeriesName: "AS", intro2ModelKey: "45-50-2" },
  "AS4560": { intro2SeriesName: "AS", intro2ModelKey: "45-60" },
  "AS45602": { intro2SeriesName: "AS", intro2ModelKey: "45-60-2" },
  "AS4570": { intro2SeriesName: "AS", intro2ModelKey: "45-70" },
  "AS45702": { intro2SeriesName: "AS", intro2ModelKey: "45-70-2" },
  "AS4580": { intro2SeriesName: "AS", intro2ModelKey: "45-80" },
  "AS45802": { intro2SeriesName: "AS", intro2ModelKey: "45-80-2" },
  "AS4590": { intro2SeriesName: "AS", intro2ModelKey: "45-90" },
  "AS460": { intro2SeriesName: "AS", intro2ModelKey: "4-60" },
  "AS470": { intro2SeriesName: "AS", intro2ModelKey: "4-70" },
  "AS480": { intro2SeriesName: "AS", intro2ModelKey: "4-80" },
  "AS490": { intro2SeriesName: "AS", intro2ModelKey: "4-90" },
  "AS5110": { intro2SeriesName: "AS", intro2ModelKey: "5-110" },
  "AS5120": { intro2SeriesName: "AS", intro2ModelKey: "5-120" },
  "AS5140": { intro2SeriesName: "AS", intro2ModelKey: "5-140" },
  "AS5160": { intro2SeriesName: "AS", intro2ModelKey: "5-160" },
  "AS5190": { intro2SeriesName: "AS", intro2ModelKey: "5-190" },
  "AS520": { intro2SeriesName: "AS", intro2ModelKey: "5-20" },
  "AS5202": { intro2SeriesName: "AS", intro2ModelKey: "5-20-2" },
  "AS5210": { intro2SeriesName: "AS", intro2ModelKey: "5-210" },
  "AS5230": { intro2SeriesName: "AS", intro2ModelKey: "5-230" },
  "AS5250": { intro2SeriesName: "AS", intro2ModelKey: "5-250" },
  "AS5260": { intro2SeriesName: "AS", intro2ModelKey: "5-260" },
  "AS5290": { intro2SeriesName: "AS", intro2ModelKey: "5-290" },
  "AS5320": { intro2SeriesName: "AS", intro2ModelKey: "5-320" },
  "AS5360": { intro2SeriesName: "AS", intro2ModelKey: "5-360" },
  "AS550": { intro2SeriesName: "AS", intro2ModelKey: "5-50" },
  "AS560": { intro2SeriesName: "AS", intro2ModelKey: "5-60" },
  "AS570": { intro2SeriesName: "AS", intro2ModelKey: "5-70" },
  "AS590": { intro2SeriesName: "AS", intro2ModelKey: "5-90" },
  "AS6410": { intro2SeriesName: "AS", intro2ModelKey: "64-10" },
  "AS64101": { intro2SeriesName: "AS", intro2ModelKey: "64-10-1" },
  "AS6420": { intro2SeriesName: "AS", intro2ModelKey: "64-20" },
  "AS64202": { intro2SeriesName: "AS", intro2ModelKey: "64-20-2" },
  "AS6430": { intro2SeriesName: "AS", intro2ModelKey: "64-30" },
  "AS64302": { intro2SeriesName: "AS", intro2ModelKey: "64-30-2" },
  "AS6440": { intro2SeriesName: "AS", intro2ModelKey: "64-40" },
  "AS64402": { intro2SeriesName: "AS", intro2ModelKey: "64-40-2" },
  "AS6450": { intro2SeriesName: "AS", intro2ModelKey: "64-50" },
  "AS64502": { intro2SeriesName: "AS", intro2ModelKey: "64-50-2" },
  "AS6460": { intro2SeriesName: "AS", intro2ModelKey: "64-60" },
  "AS6470": { intro2SeriesName: "AS", intro2ModelKey: "64-70" },
  "AS6480": { intro2SeriesName: "AS", intro2ModelKey: "64-80" },
  "AS8100": { intro2SeriesName: "AS", intro2ModelKey: "8-100" },
  "AS8110": { intro2SeriesName: "AS", intro2ModelKey: "8-110" },
  "AS8120": { intro2SeriesName: "AS", intro2ModelKey: "8-120" },
  "AS8130": { intro2SeriesName: "AS", intro2ModelKey: "8-130" },
  "AS8140": { intro2SeriesName: "AS", intro2ModelKey: "8-140" },
  "AS8150": { intro2SeriesName: "AS", intro2ModelKey: "8-150" },
  "AS8160": { intro2SeriesName: "AS", intro2ModelKey: "8-160" },
  "AS8170": { intro2SeriesName: "AS", intro2ModelKey: "8-170" },
  "AS8180": { intro2SeriesName: "AS", intro2ModelKey: "8-180" },
  "AS8190": { intro2SeriesName: "AS", intro2ModelKey: "8-190" },
  "AS820": { intro2SeriesName: "AS", intro2ModelKey: "8-20" },
  "AS8200": { intro2SeriesName: "AS", intro2ModelKey: "8-200" },
  "AS8210": { intro2SeriesName: "AS", intro2ModelKey: "8-210" },
  "AS8220": { intro2SeriesName: "AS", intro2ModelKey: "8-220" },
  "AS830": { intro2SeriesName: "AS", intro2ModelKey: "8-30" },
  "AS840": { intro2SeriesName: "AS", intro2ModelKey: "8-40" },
  "AS850": { intro2SeriesName: "AS", intro2ModelKey: "8-50" },
  "AS860": { intro2SeriesName: "AS", intro2ModelKey: "8-60" },
  "AS870": { intro2SeriesName: "AS", intro2ModelKey: "8-70" },
  "AS880": { intro2SeriesName: "AS", intro2ModelKey: "8-80" },
  "AS890": { intro2SeriesName: "AS", intro2ModelKey: "8-90" },
  "AS9010": { intro2SeriesName: "AS", intro2ModelKey: "90-10" },
  "AS90101": { intro2SeriesName: "AS", intro2ModelKey: "90-10-1" },
  "AS9020": { intro2SeriesName: "AS", intro2ModelKey: "90-20" },
  "AS90202": { intro2SeriesName: "AS", intro2ModelKey: "90-20-2" },
  "AS9030": { intro2SeriesName: "AS", intro2ModelKey: "90-30" },
  "AS90302": { intro2SeriesName: "AS", intro2ModelKey: "90-30-2" },
  "AS9040": { intro2SeriesName: "AS", intro2ModelKey: "90-40" },
  "AS90402": { intro2SeriesName: "AS", intro2ModelKey: "90-40-2" },
  "AS9050": { intro2SeriesName: "AS", intro2ModelKey: "90-50" },
  "AS9060": { intro2SeriesName: "AS", intro2ModelKey: "90-60" },
  "AS9070": { intro2SeriesName: "AS", intro2ModelKey: "90-70" },
  "CDL101": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-1(60hz)" },
  "CDL1010": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-10" },
  "CDL10100": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-100" },
  "CDL1012": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-12(60hz)" },
  "CDL10120": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-120" },
  "CDL1014": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-14(60hz)" },
  "CDL1016": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-16(60hz)" },
  "CDL1017": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-17(60hz)" },
  "CDL102": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-2(60hz)" },
  "CDL1020": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-20" },
  "CDL103": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-3(60hz)" },
  "CDL1030": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-30" },
  "CDL104": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-4(60hz)" },
  "CDL1040": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-40" },
  "CDL105": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-5(60hz)" },
  "CDL1050": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-50" },
  "CDL106": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-6(60hz)" },
  "CDL1060": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-60" },
  "CDL107": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-7(60hz)" },
  "CDL1070": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-70" },
  "CDL108": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-8(60hz)" },
  "CDL1080": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-80" },
  "CDL109": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-9(60hz)" },
  "CDL1090": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-90" },
  "CDL110": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-10(60hz)" },
  "CDL1100": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-100" },
  "CDL111": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-11(60hz)" },
  "CDL1110": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-110" },
  "CDL112": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-12(60hz)" },
  "CDL1120": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-120" },
  "CDL113": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-13(60hz)" },
  "CDL1130": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-130" },
  "CDL115": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-15(60hz)" },
  "CDL1150": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-150" },
  "CDL117": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-17(60hz)" },
  "CDL1170": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-170" },
  "CDL119": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-19(60hz)" },
  "CDL1190": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-190" },
  "CDL12": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-2(60hz)" },
  "CDL120": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-20" },
  "CDL12010": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-10" },
  "CDL120101": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-10-1(60hz)" },
  "CDL12020": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20" },
  "CDL120201": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-1" },
  "CDL120202": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-2" },
  "CDL12030": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30" },
  "CDL120301": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-1" },
  "CDL120302": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-2" },
  "CDL12040": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40" },
  "CDL120401": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-1" },
  "CDL120402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-2" },
  "CDL12050": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50" },
  "CDL120501": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-1" },
  "CDL120502": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-2" },
  "CDL12060": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60" },
  "CDL120601": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-1" },
  "CDL120602": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-2" },
  "CDL12070": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70" },
  "CDL120701": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-1" },
  "CDL120702": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-2" },
  "CDL121": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-21(60hz)" },
  "CDL1210": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-210" },
  "CDL12100": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-100" },
  "CDL1212": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-12(60hz)" },
  "CDL12120": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-120" },
  "CDL1214": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-14(60hz)" },
  "CDL12140": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-140" },
  "CDL12160": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-160" },
  "CDL12180": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-180" },
  "CDL122": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-2(60hz)" },
  "CDL1220": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-20" },
  "CDL123": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-23(60hz)" },
  "CDL1230": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-230" },
  "CDL124": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-4(60hz)" },
  "CDL1240": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-40" },
  "CDL125": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-25(60hz)" },
  "CDL1250": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-250" },
  "CDL126": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-6(60hz)" },
  "CDL1260": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-60" },
  "CDL127": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-7(60hz)" },
  "CDL1270": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-270" },
  "CDL128": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-8(60hz)" },
  "CDL1280": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-80" },
  "CDL1290": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-90" },
  "CDL13": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-3(60hz)" },
  "CDL130": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-30" },
  "CDL1300": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-300" },
  "CDL1330": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-330" },
  "CDL1360": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-360" },
  "CDL14": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-4(60hz)" },
  "CDL140": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-40" },
  "CDL15": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-5(60hz)" },
  "CDL150": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-50" },
  "CDL15010": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10" },
  "CDL150101": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10-1" },
  "CDL15020": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20" },
  "CDL150201": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-1" },
  "CDL150202": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-2" },
  "CDL15030": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30" },
  "CDL150301": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-1" },
  "CDL150302": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-2" },
  "CDL15040": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40" },
  "CDL150401": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-1" },
  "CDL150402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-2" },
  "CDL15050": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50" },
  "CDL150501": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-1" },
  "CDL150502": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-2" },
  "CDL15060": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60" },
  "CDL150601": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-1" },
  "CDL150602": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-2" },
  "CDL151": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-1(60hz)" },
  "CDL1510": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-10(60hz)" },
  "CDL1512": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-12(60hz)" },
  "CDL152": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-2(60hz)" },
  "CDL153": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-3(60hz)" },
  "CDL154": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-4(60hz)" },
  "CDL155": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-5(60hz)" },
  "CDL156": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-6(60hz)" },
  "CDL157": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-7(60hz)" },
  "CDL158": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-8(60hz)" },
  "CDL159": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-9(60hz)" },
  "CDL16": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-6(60hz)" },
  "CDL160": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-60" },
  "CDL1610": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-10(60hz)" },
  "CDL16100": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-100" },
  "CDL16120": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-120" },
  "CDL16140": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-140" },
  "CDL16160": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-160" },
  "CDL162": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-2(60hz)" },
  "CDL1620": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-20" },
  "CDL1621": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-2/1(60hz)" },
  "CDL163": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-3(60hz)" },
  "CDL1630": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-30" },
  "CDL164": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-4(60hz)" },
  "CDL1640": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-40" },
  "CDL165": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-5(60hz)" },
  "CDL1650": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-50" },
  "CDL166": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-6(60hz)" },
  "CDL1660": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-60" },
  "CDL167": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-7(60hz)" },
  "CDL1670": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-70" },
  "CDL168": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-8(60hz)" },
  "CDL1680": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-80" },
  "CDL17": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-7(60hz)" },
  "CDL170": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-70" },
  "CDL18": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-8(60hz)" },
  "CDL180": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-80" },
  "CDL19": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-9(60hz)" },
  "CDL190": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-90" },
  "CDL20010": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10" },
  "CDL20010A": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-A" },
  "CDL20010B": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-B" },
  "CDL20020": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20" },
  "CDL200202A": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2A" },
  "CDL200202B": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2B" },
  "CDL20020A": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-A" },
  "CDL20020B": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-B(60hz)" },
  "CDL20030": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30" },
  "CDL200302A": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2A" },
  "CDL200302B": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2B" },
  "CDL20030A": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A" },
  "CDL20030AB": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A-B" },
  "CDL20030B": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-B" },
  "CDL20040": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40" },
  "CDL200402A": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2A" },
  "CDL200402B": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2B" },
  "CDL20040A": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-A" },
  "CDL201": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-1(60hz)" },
  "CDL2010": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-10" },
  "CDL20100": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-100" },
  "CDL20120": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-120" },
  "CDL20140": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-140" },
  "CDL20170": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-170" },
  "CDL202": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-2(60hz)" },
  "CDL2020": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-20" },
  "CDL203": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-3(60hz)" },
  "CDL2030": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-30" },
  "CDL204": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-4(60hz)" },
  "CDL2040": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-40" },
  "CDL205": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-5(60hz)" },
  "CDL2050": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-50" },
  "CDL206": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-6(60hz)" },
  "CDL2060": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-60" },
  "CDL207": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-7(60hz)" },
  "CDL2070": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-70" },
  "CDL208": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-8(60hz)" },
  "CDL2080": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-80" },
  "CDL211": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-11(60hz)" },
  "CDL2110": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-110" },
  "CDL213": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-13(60hz)" },
  "CDL2130": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-130" },
  "CDL215": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-15(60hz)" },
  "CDL2150": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-150" },
  "CDL218": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-18(60hz)" },
  "CDL2180": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-180" },
  "CDL22": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-2(60hz)" },
  "CDL220": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-20" },
  "CDL2220": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-220" },
  "CDL2260": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-260" },
  "CDL23": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-3(60hz)" },
  "CDL230": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-30" },
  "CDL24": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-4(60hz)" },
  "CDL240": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-40" },
  "CDL25": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-5(60hz)" },
  "CDL250": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-50" },
  "CDL26": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "CDL260": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-60" },
  "CDL27": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-7(60hz)" },
  "CDL270": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-70" },
  "CDL29": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-9(60hz)" },
  "CDL290": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-90" },
  "CDL310": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-10(60hz)" },
  "CDL3100": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-100" },
  "CDL311": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-11(60hz)" },
  "CDL3110": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-110" },
  "CDL312": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-12(60hz)" },
  "CDL3120": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-120" },
  "CDL313": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-13(60hz)" },
  "CDL3130": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-130" },
  "CDL315": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-15(60hz)" },
  "CDL3150": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-150" },
  "CDL317": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-17(60hz)" },
  "CDL3170": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-170" },
  "CDL319": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-19(60hz)" },
  "CDL3190": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-190" },
  "CDL32": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-2(60hz)" },
  "CDL320": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-20" },
  "CDL321": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-21(60hz)" },
  "CDL3210": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-210" },
  "CDL32100": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-100" },
  "CDL321002": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-100-2" },
  "CDL32101": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-10-1" },
  "CDL32110": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-110" },
  "CDL321102": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-110-2" },
  "CDL32120": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-120" },
  "CDL321202": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-120-2" },
  "CDL32130": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-130" },
  "CDL321302": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-130-2" },
  "CDL32140": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-140" },
  "CDL321402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-140-2" },
  "CDL32150": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150" },
  "CDL321502": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150-2" },
  "CDL32160": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160" },
  "CDL321602": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160-2" },
  "CDL3220": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20" },
  "CDL32202": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20-2" },
  "CDL323": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-23(60hz)" },
  "CDL3230": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-230" },
  "CDL32302": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-30-2" },
  "CDL3240": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-40" },
  "CDL32402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-40-2" },
  "CDL325": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-25(60hz)" },
  "CDL3250": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-250" },
  "CDL32502": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-50-2" },
  "CDL3260": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60" },
  "CDL32602": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60-2" },
  "CDL3270": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-270" },
  "CDL32702": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-70-2" },
  "CDL3280": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-80" },
  "CDL32802": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-80-2" },
  "CDL3290": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-290" },
  "CDL32902": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-90-2" },
  "CDL33": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-3(60hz)" },
  "CDL330": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-30" },
  "CDL3310": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-310" },
  "CDL3330": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-330" },
  "CDL3360": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-360" },
  "CDL34": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-4(60hz)" },
  "CDL340": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-40" },
  "CDL35": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-5(60hz)" },
  "CDL350": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-50" },
  "CDL36": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-6(60hz)" },
  "CDL360": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-60" },
  "CDL37": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-7(60hz)" },
  "CDL370": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-70" },
  "CDL38": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-8(60hz)" },
  "CDL380": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-80" },
  "CDL39": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-9(60hz)" },
  "CDL390": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-90" },
  "CDL410": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-10(60hz)" },
  "CDL4100": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-100" },
  "CDL412": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-12(60hz)" },
  "CDL4120": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-120" },
  "CDL414": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-14(60hz)" },
  "CDL4140": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-140" },
  "CDL416": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-16(60hz)" },
  "CDL4160": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-160" },
  "CDL4190": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-190" },
  "CDL42": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-2(60hz)" },
  "CDL420": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-20" },
  "CDL4210": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10(60hz)" },
  "CDL42101": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10-1(60hz)" },
  "CDL4220": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-220" },
  "CDL42202": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-20-2(60hz)" },
  "CDL4230": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30(60hz)" },
  "CDL42302": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30-2(60hz)" },
  "CDL4240": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40(60hz)" },
  "CDL42402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40-2(60hz)" },
  "CDL4250": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50(60hz)" },
  "CDL42502": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50-2(60hz)" },
  "CDL4260": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60(60hz)" },
  "CDL42602": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60-2(60hz)" },
  "CDL4270": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70(60hz)" },
  "CDL42702": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70-2(60hz)" },
  "CDL43": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-3(60hz)" },
  "CDL430": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-30" },
  "CDL44": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-4(60hz)" },
  "CDL440": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-40" },
  "CDL45": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-5(60hz)" },
  "CDL450": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-50" },
  "CDL4510": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-10" },
  "CDL45100": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-100" },
  "CDL451002": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-100-2" },
  "CDL45101": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-10-1" },
  "CDL45110": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-110" },
  "CDL451102": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-110-2" },
  "CDL45120": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-120" },
  "CDL451202": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-120-2" },
  "CDL451302": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-130-2" },
  "CDL4520": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-20" },
  "CDL45202": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-20-2" },
  "CDL4530": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-30" },
  "CDL45302": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-30-2" },
  "CDL4540": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-40" },
  "CDL45402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-40-2" },
  "CDL4550": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-50" },
  "CDL45502": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-50-2" },
  "CDL4560": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-60" },
  "CDL45602": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-60-2" },
  "CDL4570": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-70" },
  "CDL45702": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-70-2" },
  "CDL4580": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-80" },
  "CDL45802": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-80-2" },
  "CDL4590": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-90" },
  "CDL45902": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-90-2" },
  "CDL46": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-6(60hz)" },
  "CDL460": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-60" },
  "CDL47": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-7(60hz)" },
  "CDL470": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-70" },
  "CDL48": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-8(60hz)" },
  "CDL480": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-80" },
  "CDL510": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-10(60hz)" },
  "CDL511": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-11(60hz)" },
  "CDL512": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-12(60hz)" },
  "CDL513": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-13(60hz)" },
  "CDL514": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-14(60hz)" },
  "CDL515": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-15(60hz)" },
  "CDL516": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-16(60hz)" },
  "CDL518": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-18(60hz)" },
  "CDL52": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-2(60hz)" },
  "CDL520": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-20(60hz)" },
  "CDL522": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-22(60hz)" },
  "CDL524": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-24(60hz)" },
  "CDL53": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-3(60hz)" },
  "CDL54": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-4(60hz)" },
  "CDL55": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-5(60hz)" },
  "CDL56": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-6(60hz)" },
  "CDL57": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-7(60hz)" },
  "CDL58": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-8(60hz)" },
  "CDL59": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-9(60hz)" },
  "CDL6410": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-10" },
  "CDL64101": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-10-1" },
  "CDL6420": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-20" },
  "CDL64201": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-20-1" },
  "CDL64202": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-20-2" },
  "CDL6430": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-30" },
  "CDL64301": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-30-1" },
  "CDL64302": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-30-2" },
  "CDL6440": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-40" },
  "CDL64401": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-40-1" },
  "CDL64402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-40-2" },
  "CDL6450": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-50" },
  "CDL64501": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-50-1" },
  "CDL64502": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-50-2" },
  "CDL6460": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-60" },
  "CDL64601": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-60-1" },
  "CDL64602": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-60-2" },
  "CDL6470": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-70" },
  "CDL64701": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-70-1" },
  "CDL64702": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-70-2" },
  "CDL64801": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-80-1" },
  "CDL64802": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-80-2" },
  "CDL6510": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-10(60hz)" },
  "CDL65101": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-10-1(60hz)" },
  "CDL6520": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-20(60hz)" },
  "CDL65202": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-20-2(60hz)" },
  "CDL6530": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-30(60hz)" },
  "CDL65302": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-30-2(60hz)" },
  "CDL6540": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-40(60hz)" },
  "CDL65402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-40-2(60hz)" },
  "CDL65502": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-50-2(60hz)" },
  "CDL810": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-10(60hz)" },
  "CDL8100": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-100" },
  "CDL812": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-12(60hz)" },
  "CDL8120": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-120" },
  "CDL814": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-14(60hz)" },
  "CDL8140": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-140" },
  "CDL8160": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-160" },
  "CDL8180": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-180" },
  "CDL82": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-2(60hz)" },
  "CDL820": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-20" },
  "CDL8200": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-200" },
  "CDL821": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-2/1(60hz)" },
  "CDL83": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-3(60hz)" },
  "CDL830": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-30" },
  "CDL84": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-4(60hz)" },
  "CDL840": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-40" },
  "CDL85": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-5(60hz)" },
  "CDL850": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-50" },
  "CDL86": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-6(60hz)" },
  "CDL860": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-60" },
  "CDL88": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-8(60hz)" },
  "CDL880": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-80" },
  "CDL9010": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-10" },
  "CDL90101": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-10-1" },
  "CDL9020": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-20" },
  "CDL90201": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-20-1(60hz)" },
  "CDL90202": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-20-2" },
  "CDL9030": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-30" },
  "CDL90301": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-30-1(60hz)" },
  "CDL90302": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-30-2" },
  "CDL9040": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-40" },
  "CDL90402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-40-2" },
  "CDL9050": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-50" },
  "CDL90502": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-50-2" },
  "CDL9060": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-60" },
  "CDL90602": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-60-2" },
  "CDLK110010": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-100/10（60Hz）" },
  "CDLK111011": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-110/11（60Hz）" },
  "CDLK112012": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-120/12（60Hz）" },
  "CDLK113013": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-130/13（60Hz）" },
  "CDLK115015": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-150/15（60Hz）" },
  "CDLK117017": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-170/17（60Hz）" },
  "CDLK119019": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-190/19（60Hz）" },
  "CDLK1202": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-20/2（60Hz）" },
  "CDLK121021": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-210/21（60Hz）" },
  "CDLK123023": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-230/23（60Hz）" },
  "CDLK125025": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-250/25（60Hz）" },
  "CDLK127027": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-270/27" },
  "CDLK130030": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-300/30" },
  "CDLK1303": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-30/3（60Hz）" },
  "CDLK133033": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-330/33" },
  "CDLK136036": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-360/36" },
  "CDLK1404": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-40/4（60Hz）" },
  "CDLK1505": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-50/5（60Hz）" },
  "CDLK1606": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-60/6（60Hz）" },
  "CDLK1610010": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-100/10（60Hz）" },
  "CDLK1612012": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-120/12" },
  "CDLK1614014": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-140/14" },
  "CDLK1616016": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-160/16" },
  "CDLK16202": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-20/2（60Hz）" },
  "CDLK16303": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-30/3（60Hz）" },
  "CDLK16404": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-40/4（60Hz）" },
  "CDLK16505": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-50/5（60Hz）" },
  "CDLK16606": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-60/6（60Hz）" },
  "CDLK16707": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-70/7（60Hz）" },
  "CDLK16808": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-80/8（60Hz）" },
  "CDLK1707": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-70/7（60Hz）" },
  "CDLK1808": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-80/8（60Hz）" },
  "CDLK1909": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-90/9（60Hz）" },
  "CDLK2010010": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-100/10（60Hz）" },
  "CDLK2012012": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-120/12" },
  "CDLK2014014": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-140/14" },
  "CDLK2017017": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-170/17" },
  "CDLK20202": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-20/2（60Hz）" },
  "CDLK20303": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-30/3（60Hz）" },
  "CDLK20404": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-40/4（60Hz）" },
  "CDLK20505": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-50/5（60Hz）" },
  "CDLK20606": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-60/6（60Hz）" },
  "CDLK20707": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-70/7（60Hz）" },
  "CDLK20808": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-80/8（60Hz）" },
  "CDLK211011": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-110/11（60Hz）" },
  "CDLK213013": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-130/13（60Hz）" },
  "CDLK215015": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-150/15（60Hz）" },
  "CDLK218018": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-180/18（60Hz）" },
  "CDLK2202": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-20/2（60Hz）" },
  "CDLK222022": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-220/22" },
  "CDLK226026": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-260/26" },
  "CDLK2303": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-30/3（60Hz）" },
  "CDLK2404": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-40/4（60Hz）" },
  "CDLK2505": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-50/5（60Hz）" },
  "CDLK2606": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-60/6（60Hz）" },
  "CDLK2707": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-70/7（60Hz）" },
  "CDLK2909": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-90/9（60Hz）" },
  "CDLK310010": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-100/10（60Hz）" },
  "CDLK311011": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-110/11（60Hz）" },
  "CDLK312012": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-120/12（60Hz）" },
  "CDLK313013": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-130/13（60Hz）" },
  "CDLK315015": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-150/15（60Hz）" },
  "CDLK317017": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-170/17（60Hz）" },
  "CDLK319019": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-190/19（60Hz）" },
  "CDLK3202": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-20/2（60Hz）" },
  "CDLK32101": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-10/1（60Hz）" },
  "CDLK321021": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-210/21（60Hz）" },
  "CDLK32202": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2（60Hz）" },
  "CDLK322022": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "CDLK323023": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-230/23（60Hz）" },
  "CDLK32303": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-30/3（60Hz）" },
  "CDLK32404": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-40/4（60Hz）" },
  "CDLK325025": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-250/25（60Hz）" },
  "CDLK32505": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-50/5（60Hz）" },
  "CDLK32606": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-60/6（60Hz）" },
  "CDLK327027": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-270/27" },
  "CDLK32707": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-70/7（60Hz）" },
  "CDLK32808": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-80/8（60Hz）" },
  "CDLK329029": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-290/29" },
  "CDLK32909": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-90/9（60Hz）" },
  "CDLK3303": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-30/3（60Hz）" },
  "CDLK331031": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-310/31" },
  "CDLK333033": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-330/33" },
  "CDLK336036": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-360/36" },
  "CDLK3404": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-40/4（60Hz）" },
  "CDLK3505": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-50/5（60Hz）" },
  "CDLK3606": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-60/6（60Hz）" },
  "CDLK3707": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-70/7（60Hz）" },
  "CDLK3808": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-80/8（60Hz）" },
  "CDLK3909": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-90/9（60Hz）" },
  "CDLK410010": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-100/10（60Hz）" },
  "CDLK412012": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-120/12（60Hz）" },
  "CDLK414014": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-140/14（60Hz）" },
  "CDLK416016": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-160/16（60Hz）" },
  "CDLK419019": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-190/19" },
  "CDLK4202": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-20/2（60Hz）" },
  "CDLK4210010": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10" },
  "CDLK42100102": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10-2" },
  "CDLK42101": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1（60Hz）" },
  "CDLK421011": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1-1" },
  "CDLK4211011": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK 42-110/11" },
  "CDLK42110112": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-110/11-2" },
  "CDLK4212012": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12" },
  "CDLK42120122": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12-2" },
  "CDLK42130132": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-130/13-2" },
  "CDLK42202": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2（60Hz）" },
  "CDLK422022": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "CDLK42303": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "CDLK423032": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3-2" },
  "CDLK42404": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4（60Hz）" },
  "CDLK424042": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4-2" },
  "CDLK42505": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5（60Hz）" },
  "CDLK425052": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5-2" },
  "CDLK42606": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6（60Hz）" },
  "CDLK426062": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6-2" },
  "CDLK42707": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7（60Hz）" },
  "CDLK427072": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7-2" },
  "CDLK42808": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8" },
  "CDLK428082": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8-2" },
  "CDLK42909": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9" },
  "CDLK429092": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9-2" },
  "CDLK4303": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-30/3（60Hz）" },
  "CDLK4404": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-40/4（60Hz）" },
  "CDLK4505": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-50/5（60Hz）" },
  "CDLK4606": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-60/6（60Hz）" },
  "CDLK4707": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-70/7（60Hz）" },
  "CDLK4808": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-80/8（60Hz）" },
  "CDLK810010": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-100/10（60Hz）" },
  "CDLK812012": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-120/12（60Hz）" },
  "CDLK814014": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-140/14（60Hz）" },
  "CDLK816016": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-160/16" },
  "CDLK818018": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-180/18" },
  "CDLK820020": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-200/20" },
  "CDLK8202": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-20/2（60Hz）" },
  "CDLK8303": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-30/3（60Hz）" },
  "CDLK8404": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-40/4（60Hz）" },
  "CDLK8505": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-50/5（60Hz）" },
  "CDLK8606": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-60/6（60Hz）" },
  "CDLK8808": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-80/8（60Hz）" },
  "CHL121": { intro2SeriesName: "CHL", intro2ModelKey: "12-1" },
  "CHL122": { intro2SeriesName: "CHL", intro2ModelKey: "12-2" },
  "CHL123": { intro2SeriesName: "CHL", intro2ModelKey: "12-3" },
  "CHL124": { intro2SeriesName: "CHL", intro2ModelKey: "12-4" },
  "CHL125": { intro2SeriesName: "CHL", intro2ModelKey: "12-5" },
  "CHL161": { intro2SeriesName: "CHL", intro2ModelKey: "16-1" },
  "CHL162": { intro2SeriesName: "CHL", intro2ModelKey: "16-2" },
  "CHL163": { intro2SeriesName: "CHL", intro2ModelKey: "16-3" },
  "CHL164": { intro2SeriesName: "CHL", intro2ModelKey: "16-4" },
  "CHL201": { intro2SeriesName: "CHL", intro2ModelKey: "20-1" },
  "CHL202": { intro2SeriesName: "CHL", intro2ModelKey: "20-2" },
  "CHL203": { intro2SeriesName: "CHL", intro2ModelKey: "20-3" },
  "CHL22": { intro2SeriesName: "CHL", intro2ModelKey: "2-2" },
  "CHL23": { intro2SeriesName: "CHL", intro2ModelKey: "2-3" },
  "CHL24": { intro2SeriesName: "CHL", intro2ModelKey: "2-4" },
  "CHL25": { intro2SeriesName: "CHL", intro2ModelKey: "2-5" },
  "CHL26": { intro2SeriesName: "CHL", intro2ModelKey: "2-6" },
  "CHL42": { intro2SeriesName: "CHL", intro2ModelKey: "4-2" },
  "CHL43": { intro2SeriesName: "CHL", intro2ModelKey: "4-3" },
  "CHL44": { intro2SeriesName: "CHL", intro2ModelKey: "4-4" },
  "CHL45": { intro2SeriesName: "CHL", intro2ModelKey: "4-5" },
  "CHL46": { intro2SeriesName: "CHL", intro2ModelKey: "4-6" },
  "CHL81": { intro2SeriesName: "CHL", intro2ModelKey: "8-1" },
  "CHL82": { intro2SeriesName: "CHL", intro2ModelKey: "8-2" },
  "CHL83": { intro2SeriesName: "CHL", intro2ModelKey: "8-3" },
  "CHL84": { intro2SeriesName: "CHL", intro2ModelKey: "8-4" },
  "CHL85": { intro2SeriesName: "CHL", intro2ModelKey: "8-5" },
  "CMB120502": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x2" },
  "CMB120503": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x3" },
  "CMB120504": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x4" },
  "CMB120505": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x5" },
  "CMB120506": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x6" },
  "CMB120507": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x7" },
  "CMB120508": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x8" },
  "CMB120509": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x9" },
  "CMB122510": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x10" },
  "CMB122511": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x11" },
  "CMB122512": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x12" },
  "CMB12252": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x2" },
  "CMB12253": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x3" },
  "CMB12254": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x4" },
  "CMB12255": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x5" },
  "CMB12256": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x6" },
  "CMB12257": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x7" },
  "CMB12258": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x8" },
  "CMB12259": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x9" },
  "CMB125010": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x10" },
  "CMB125011": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x11" },
  "CMB125012": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x12" },
  "CMB12502": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x2" },
  "CMB12503": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x3" },
  "CMB12504": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x4" },
  "CMB12505": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x5" },
  "CMB12506": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x6" },
  "CMB12507": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x7" },
  "CMB12508": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x8" },
  "CMB12509": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x9" },
  "CMB1553010": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x10" },
  "CMB155302": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x2" },
  "CMB155303": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x3" },
  "CMB155304": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x4" },
  "CMB155305": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x5" },
  "CMB155306": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x6" },
  "CMB155307": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x7" },
  "CMB155308": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x8" },
  "CMB155309": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x9" },
  "CMB155672": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x2" },
  "CMB155673": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x3" },
  "CMB155674": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x4" },
  "CMB155675": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x5" },
  "CMB155676": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x6" },
  "CMB155677": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x7" },
  "CMB155678": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x8" },
  "CMB155679": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x9" },
  "CMB253010": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x10" },
  "CMB25302": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x2" },
  "CMB25303": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x3" },
  "CMB25304": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x4" },
  "CMB25305": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x5" },
  "CMB25306": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x6" },
  "CMB25307": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x7" },
  "CMB25308": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x8" },
  "CMB25309": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x9" },
  "CMB255010": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x10" },
  "CMB255011": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x11" },
  "CMB255012": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x12" },
  "CMB25503": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x3" },
  "CMB25504": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x4" },
  "CMB25505": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x5" },
  "CMB25506": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x6" },
  "CMB25507": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x7" },
  "CMB25508": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x8" },
  "CMB25509": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x9" },
  "CMB280432": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x2" },
  "CMB280433": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x3" },
  "CMB280434": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x4" },
  "CMB280435": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x5" },
  "CMB280436": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x6" },
  "CMB280437": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x7" },
  "CMB280438": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x8" },
  "CMB280439": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x9" },
  "CMB2806510": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x10" },
  "CMB280653": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x3" },
  "CMB280654": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x4" },
  "CMB280655": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x5" },
  "CMB280656": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x6" },
  "CMB280657": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x7" },
  "CMB280658": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x8" },
  "CMB280659": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x9" },
  "CMB3604010": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x10" },
  "CMB360402": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x2" },
  "CMB360403": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x3" },
  "CMB360404": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x4" },
  "CMB360405": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x5" },
  "CMB360406": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x6" },
  "CMB360407": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x7" },
  "CMB360408": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x8" },
  "CMB360409": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x9" },
  "CMB4506010": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x10" },
  "CMB450602": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x2" },
  "CMB450603": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x3" },
  "CMB450604": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x4" },
  "CMB450605": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x5" },
  "CMB450606": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x6" },
  "CMB450607": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x7" },
  "CMB450608": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x8" },
  "CMB450609": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x9" },
  "CMB463010": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x10" },
  "CMB46302": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x2" },
  "CMB46303": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x3" },
  "CMB46304": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x4" },
  "CMB46305": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x5" },
  "CMB46306": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x6" },
  "CMB46307": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x7" },
  "CMB46308": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x8" },
  "CMB46309": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x9" },
  "CMB465010": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x10" },
  "CMB465011": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x11" },
  "CMB465012": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x12" },
  "CMB46502": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x2" },
  "CMB46503": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x3" },
  "CMB46504": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x4" },
  "CMB46505": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x5" },
  "CMB46506": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x6" },
  "CMB46507": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x7" },
  "CMB46508": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x8" },
  "CMB46509": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x9" },
  "CMB550502": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x2" },
  "CMB550503": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x3" },
  "CMB550504": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x4" },
  "CMB550505": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x5" },
  "CMB550506": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x6" },
  "CMB550507": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x7" },
  "CMB550508": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x8" },
  "CMB550509": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x9" },
  "CMB5807010": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x10" },
  "CMB580703": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x3" },
  "CMB580704": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x4" },
  "CMB580705": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x5" },
  "CMB580706": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x6" },
  "CMB580707": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x7" },
  "CMB580708": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x8" },
  "CMB580709": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x9" },
  "CMB6006010": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x10" },
  "CMB600603": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x3" },
  "CMB600604": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x4" },
  "CMB600605": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x5" },
  "CMB600606": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x6" },
  "CMB600607": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x7" },
  "CMB600608": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x8" },
  "CMB600609": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x9" },
  "CMB62510": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x10" },
  "CMB62511": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x11" },
  "CMB62512": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x12" },
  "CMB6253": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x3" },
  "CMB6254": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x4" },
  "CMB6255": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x5" },
  "CMB6256": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x6" },
  "CMB6257": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x7" },
  "CMB6258": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x8" },
  "CMB6259": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x9" },
  "CMB65010": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x10" },
  "CMB65011": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x11" },
  "CMB65012": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x12" },
  "CMB6502": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x2" },
  "CMB6503": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x3" },
  "CMB6504": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x4" },
  "CMB6505": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x5" },
  "CMB6506": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x6" },
  "CMB6507": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x7" },
  "CMB6508": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x8" },
  "CMB6509": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x9" },
  "CMB720602": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x2" },
  "CMB720603": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x3" },
  "CMB720604": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x4" },
  "CMB720605": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x5" },
  "CMB720606": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x6" },
  "CMB720607": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x7" },
  "CMB720608": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x8" },
  "CMB720609": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x9" },
  "CMB85452": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x2" },
  "CMB85453": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x3" },
  "CMB85454": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x4" },
  "CMB85455": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x5" },
  "CMB85456": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x6" },
  "CMB85457": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x7" },
  "CMB85458": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x8" },
  "CMB85459": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x9" },
  "CMB85673": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x3" },
  "CMB85674": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x4" },
  "CMB85675": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x5" },
  "CMB85676": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x6" },
  "CMB85677": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x7" },
  "CMB85678": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x8" },
  "CMB85679": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x9" },
  "CMSL2012T1MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)20-12T1M-I" },
  "CMSL204T1MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)20-4T1M-I" },
  "CMSL206T1MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)20-6T1M-I" },
  "CMSL2512T1MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)25-12T1M-I" },
  "CMSL2516T3MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)25-16T3M-I" },
  "CMSL2520T3MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)25-20T3M-I" },
  "CMSL254T1MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)25-4T1M-I" },
  "CMSL256T1MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)25-6T1M-I" },
  "CMSL258T1MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)25-8T1M-I" },
  "CMSL3212F1SI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)32-12F1S-I" },
  "CMSL324T1MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)32-4T1M-I" },
  "CMSL326T1MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)32-6T1M-I" },
  "CMSL328F1MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)32-8F1M-I" },
  "CMSL328T1MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)32-8T1M-I" },
  "CMSL4012F3MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)40-12F3M-I" },
  "CMSL4016F3MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)40-16F3M-I" },
  "CMSL406F1SI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)40-6F1S-I" },
  "CMSL5012F3MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)50-12F3M-I" },
  "CMSL5016F3MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)50-16F3M-I" },
  "CMSL6512F3MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)65-12F3M-I" },
  "CMSL8012F3MI": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)80-12F3M-I" },
  "SMA150125315224": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-22/4" },
  "SMA655016042": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-4/2" },
  "SMA8050315554": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-5.5/4" },
  "SMAA10065200114": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-11/4" },
  "SMAA100652001852": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-18.5/2" },
  "SMAA10065200222": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-22/2" },
  "SMAA10065200224": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-2.2/4" },
  "SMAA10065200302": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-30/2" },
  "SMAA1006520034": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-3/4" },
  "SMAA10065200372": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-37/2" },
  "SMAA1006520044": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-4/4" },
  "SMAA10065200452": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-45/2" },
  "SMAA10065200552": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-55/2" },
  "SMAA10065200554": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-5.5/4" },
  "SMAA10065200752": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-75/2" },
  "SMAA10065200754": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-7.5/4" },
  "SMAA10065250114": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-11/4" },
  "SMAA10065250154": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-15/4" },
  "SMAA100652501854": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-18.5/4" },
  "SMAA10065250372": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-37/2" },
  "SMAA10065250452": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-45/2" },
  "SMAA10065250552": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-55/2" },
  "SMAA10065250554": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-5.5/4" },
  "SMAA10065250752": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-75/2" },
  "SMAA10065250754": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-7.5/4" },
  "SMAA10065250902": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-90/2" },
  "SMAA100653151102": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-110/2" },
  "SMAA10065315114": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-11/4" },
  "SMAA10065315154": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-15/4" },
  "SMAA100653151854": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-18.5/4" },
  "SMAA10065315224": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-22/4" },
  "SMAA10065315304": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-30/4" },
  "SMAA10065315752": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-75/2" },
  "SMAA10065315902": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-90/2" },
  "SMAA10080160112": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-11/2" },
  "SMAA10080160152": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-15/2" },
  "SMAA10080160154": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-1.5/4" },
  "SMAA100801601852": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-18.5/2" },
  "SMAA10080160222": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-22/2" },
  "SMAA10080160224": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-2.2/4" },
  "SMAA10080160302": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-30/2" },
  "SMAA1008016034": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-3/4" },
  "SMAA10080160372": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-37/2" },
  "SMAA10080160554": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-5.5/4" },
  "SMAA1251002001102": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-110/2" },
  "SMAA125100200114": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-11/4" },
  "SMAA125100200154": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-15/4" },
  "SMAA125100200302": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-30/2" },
  "SMAA125100200372": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-37/2" },
  "SMAA12510020044": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-4/4" },
  "SMAA125100200452": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-45/2" },
  "SMAA125100200552": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-55/2" },
  "SMAA125100200554": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-5.5/4" },
  "SMAA125100200752": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-75/2" },
  "SMAA125100200754": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-7.5/4" },
  "SMAA125100200902": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-90/2" },
  "SMAA1251002501102": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-110/2" },
  "SMAA125100250114": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-11/4" },
  "SMAA125100250154": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-15/4" },
  "SMAA1251002501854": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-18.5/4" },
  "SMAA125100250224": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-22/4" },
  "SMAA125100250304": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-30/4" },
  "SMAA125100250552": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-55/2" },
  "SMAA125100250752": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-75/2" },
  "SMAA125100250902": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-90/2" },
  "SMAA1251003151102": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-110/2" },
  "SMAA1251003151322": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-132/2" },
  "SMAA125100315154": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-15/4" },
  "SMAA1251003151602": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-160/2" },
  "SMAA1251003151854": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-18.5/4" },
  "SMAA125100315224": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-22/4" },
  "SMAA125100315304": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-30/4" },
  "SMAA125100315374": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-37/4" },
  "SMAA125100315902": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-90/2" },
  "SMAA125100400224": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-400-22/4" },
  "SMAA125100400304": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-400-30/4" },
  "SMAA125100400374": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-400-37/4" },
  "SMAA125100400454": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-400-45/4" },
  "SMAA125100400554": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-400-55/4" },
  "SMAA125100400754": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-400-75/4" },
  "SMAA125100500454": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-500-45/4" },
  "SMAA125100500554": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-500-55/4" },
  "SMAA125100500754": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-500-75/4" },
  "SMAA125100500904": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-500-90/4" },
  "SMAA12580400154": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-15/4" },
  "SMAA125804001854": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-18.5/4" },
  "SMAA12580400224": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-22/4" },
  "SMAA12580400304": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-30/4" },
  "SMAA12580400374": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-37/4" },
  "SMAA12580400454": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-45/4" },
  "SMAA12580400554": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-55/4" },
  "SMAA1501252501102": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-110/2" },
  "SMAA150125250114": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-11/4" },
  "SMAA1501252501322": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-132/2" },
  "SMAA150125250154": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-15/4" },
  "SMAA1501252501602": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-160/2" },
  "SMAA1501252501854": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-18.5/4" },
  "SMAA150125250224": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-22/4" },
  "SMAA150125250304": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-30/4" },
  "SMAA150125250374": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-37/4" },
  "SMAA150125250902": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-90/2" },
  "SMAA1501253151602": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-160/2" },
  "SMAA1501253151854": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-18.5/4" },
  "SMAA1501253152002": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-200/2" },
  "SMAA1501253152202": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-220/2" },
  "SMAA1501253152502": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-250/2" },
  "SMAA150125315304": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-30/4" },
  "SMAA150125315374": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-37/4" },
  "SMAA150125400374": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-400-37/4" },
  "SMAA150125400454": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-400-45/4" },
  "SMAA150125400554": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-400-55/4" },
  "SMAA150125400754": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-400-75/4" },
  "SMAA1501255001104": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-500-110/4" },
  "SMAA1501255001324": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-500-132/4" },
  "SMAA150125500754": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-500-75/4" },
  "SMAA150125500904": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-500-90/4" },
  "SMAA200150315304": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-315-30/4" },
  "SMAA200150315374": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-315-37/4" },
  "SMAA200150315454": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-315-45/4" },
  "SMAA200150315554": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-315-55/4" },
  "SMAA200150315754": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-315-75/4" },
  "SMAA2001504001104": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-400-110/4" },
  "SMAA200150400454": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-400-45/4" },
  "SMAA200150400554": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-400-55/4" },
  "SMAA200150400754": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-400-75/4" },
  "SMAA200150400904": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-400-90/4" },
  "SMAA2001505001104": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-500-110/4" },
  "SMAA2001505001324": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-500-132/4" },
  "SMAA2001505001604": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-500-160/4" },
  "SMAA200150500754": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-500-75/4" },
  "SMAA200150500904": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-500-90/4" },
  "SMAA250200200154": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-200-15/4" },
  "SMAA2502002001854": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-200-18.5/4" },
  "SMAA250200200304": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-200-30/4" },
  "SMAA250200200374": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-200-37/4" },
  "SMAA250200250554": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-250-55/4" },
  "SMAA250200315304": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-315-30/4" },
  "SMAA250200315374": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-315-37/4" },
  "SMAA250200315454": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-315-45/4" },
  "SMAA250200315554": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-315-55/4" },
  "SMAA250200315754": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-315-75/4" },
  "SMAA2502004001104": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-110/4" },
  "SMAA2502004001324": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-132/4" },
  "SMAA2502004001604": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-160/4" },
  "SMAA2502004002004": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-200/4" },
  "SMAA250200400754": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-75/4" },
  "SMAA250200400904": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-90/4" },
  "SMAA2502005001324": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-132/4" },
  "SMAA2502005001604": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-160/4" },
  "SMAA2502005002004": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-200/4" },
  "SMAA2502005002204": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-220/4" },
  "SMAA2502005002504": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-250/4" },
  "SMAA2502005002804": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-280/4" },
  "SMAA2502005003154": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-315/4" },
  "SMAA300250250754": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-250-75/4" },
  "SMAA3002503151104": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-315-110/4" },
  "SMAA3002503151324": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-315-132/4" },
  "SMAA300250315454": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-315-45/4" },
  "SMAA300250315554": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-315-55/4" },
  "SMAA300250315754": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-315-75/4" },
  "SMAA300250315904": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-315-90/4" },
  "SMAA3002504001104": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-110/4" },
  "SMAA3002504001324": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-132/4" },
  "SMAA3002504001604": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-160/4" },
  "SMAA3002504001854": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-185/4" },
  "SMAA3002504002004": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-200/4" },
  "SMAA3002504002204": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-220/4" },
  "SMAA3002504002504": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-250/4" },
  "SMAA3002504003154": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-315/4" },
  "SMAA300250400904": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-90/4" },
  "SMAA3002505002004": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-500-200/4" },
  "SMAA3002505002204": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-500-220/4" },
  "SMAA3002505002504": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-500-250/4" },
  "SMAA3002505002804": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-500-280/4" },
  "SMAA3002505003154": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-500-315/4" },
  "SMAA3503004001604": { intro2SeriesName: "SMA", intro2ModelKey: "350x300-400-160/4" },
  "SMAA3503004002004": { intro2SeriesName: "SMA", intro2ModelKey: "350x300-400-200/4" },
  "SMAA3503004002504": { intro2SeriesName: "SMA", intro2ModelKey: "350x300-400-250/4" },
  "SMAA3503004003154": { intro2SeriesName: "SMA", intro2ModelKey: "350x300-400-315/4" },
  "SMAA3503004005004": { intro2SeriesName: "SMA", intro2ModelKey: "350x300-400-500/4" },
  "SMAA50321600554": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-0.55/4" },
  "SMAA5032160114": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-1.1/4" },
  "SMAA5032160222": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-2.2/2" },
  "SMAA503216032": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-3/2" },
  "SMAA503216042": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-4/2" },
  "SMAA5032160552": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-5.5/2" },
  "SMAA5032160752": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-7.5/2" },
  "SMAA50322000754": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-0.75/4" },
  "SMAA5032200112": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-11/2" },
  "SMAA5032200114": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-1.1/4" },
  "SMAA5032200152": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-15/2" },
  "SMAA5032200154": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-1.5/4" },
  "SMAA5032200224": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-2.2/4" },
  "SMAA5032200552": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-5.5/2" },
  "SMAA5032200752": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-7.5/2" },
  "SMAA6540200112": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-200-11/2" },
  "SMAA6540200114": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-200-1.1/4" },
  "SMAA6540200152": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-200-15/2" },
  "SMAA6540200224": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-200-2.2/4" },
  "SMAA6540200752": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-200-7.5/2" },
  "SMAA6540250152": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-15/2" },
  "SMAA65402501852": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-18.5/2" },
  "SMAA6540250222": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-22/2" },
  "SMAA6540250224": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-2.2/4" },
  "SMAA6540250302": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-30/2" },
  "SMAA654025034": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-3/4" },
  "SMAA6540250372": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-37/2" },
  "SMAA654025044": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-4/4" },
  "SMAA6540250554": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-5.5/4" },
  "SMAA6540315114": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-11/4" },
  "SMAA6540315222": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-22/2" },
  "SMAA6540315302": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-30/2" },
  "SMAA6540315372": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-37/2" },
  "SMAA654031544": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-4/4" },
  "SMAA6540315452": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-45/2" },
  "SMAA6540315554": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-5.5/4" },
  "SMAA6540315754": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-7.5/4" },
  "SMAA65501600754": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-0.75/4" },
  "SMAA6550160152": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-15/2" },
  "SMAA6550160154": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-1.5/4" },
  "SMAA655016034": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-3/4" },
  "SMAA6550160552": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-5.5/2" },
  "SMAA6550160752": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-7.5/2" },
  "SMAA8050200112": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-11/2" },
  "SMAA8050200152": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-15/2" },
  "SMAA80502001852": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-18.5/2" },
  "SMAA8050200222": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-22/2" },
  "SMAA8050200224": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-2.2/4" },
  "SMAA8050200302": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-30/2" },
  "SMAA805020034": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-3/4" },
  "SMAA8050250114": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-11/4" },
  "SMAA8050250222": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-22/2" },
  "SMAA8050250302": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-30/2" },
  "SMAA8050250372": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-37/2" },
  "SMAA805025044": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-4/4" },
  "SMAA8050250452": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-45/2" },
  "SMAA8050250552": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-55/2" },
  "SMAA8050250554": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-5.5/4" },
  "SMAA8050250752": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-75/2" },
  "SMAA8050250754": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-7.5/4" },
  "SMAA8050250902": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-90/2" },
  "SMAA8050315114": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-11/4" },
  "SMAA8050315154": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-15/4" },
  "SMAA80503151854": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-18.5/4" },
  "SMAA8050315224": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-22/4" },
  "SMAA8050315452": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-45/2" },
  "SMAA8050315552": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-55/2" },
  "SMAA8050315752": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-75/2" },
  "SMAA8050315754": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-7.5/4" },
  "SMAA8050315902": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-90/2" },
  "SMAA8065160112": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-11/2" },
  "SMAA8065160114": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-1.1/4" },
  "SMAA8065160152": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-15/2" },
  "SMAA80651601852": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-18.5/2" },
  "SMAA8065160222": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-22/2" },
  "SMAA8065160224": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-2.2/4" },
  "SMAA8065160302": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-30/2" },
  "SMAA806516042": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-4/2" },
  "SMAA806516044": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-4/4" },
  "SMAA8065160752": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-7.5/2" },
  "TD100152": { intro2SeriesName: "TD", intro2ModelKey: "TD100-15/2" },
  "TD100172": { intro2SeriesName: "TD", intro2ModelKey: "TD100-17/2" },
  "TD100222": { intro2SeriesName: "TD", intro2ModelKey: "TD100-22/2" },
  "TD100272": { intro2SeriesName: "TD", intro2ModelKey: "TD100-27/2" },
  "TD100332": { intro2SeriesName: "TD", intro2ModelKey: "TD100-33/2" },
  "TD100402": { intro2SeriesName: "TD", intro2ModelKey: "TD100-40/2" },
  "TD100482": { intro2SeriesName: "TD", intro2ModelKey: "TD100-48/2" },
  "TD100522": { intro2SeriesName: "TD", intro2ModelKey: "TD100-52/2" },
  "TD10092": { intro2SeriesName: "TD", intro2ModelKey: "TD100-9/2" },
  "TD125114": { intro2SeriesName: "TD", intro2ModelKey: "TD125-11/4" },
  "TD125144": { intro2SeriesName: "TD", intro2ModelKey: "TD125-14/4" },
  "TD125184": { intro2SeriesName: "TD", intro2ModelKey: "TD125-18/4" },
  "TD125224": { intro2SeriesName: "TD", intro2ModelKey: "TD125-22/4" },
  "TD125284": { intro2SeriesName: "TD", intro2ModelKey: "TD125-28/4" },
  "TD125324": { intro2SeriesName: "TD", intro2ModelKey: "TD125-32/4" },
  "TD125404": { intro2SeriesName: "TD", intro2ModelKey: "TD125-40/4" },
  "TD125484": { intro2SeriesName: "TD", intro2ModelKey: "TD125-48/4" },
  "TD1501254": { intro2SeriesName: "TD", intro2ModelKey: "TD150-12.5/4" },
  "TD150174": { intro2SeriesName: "TD", intro2ModelKey: "TD150-17/4" },
  "TD150214": { intro2SeriesName: "TD", intro2ModelKey: "TD150-21/4" },
  "TD150254": { intro2SeriesName: "TD", intro2ModelKey: "TD150-25/4" },
  "TD150334": { intro2SeriesName: "TD", intro2ModelKey: "TD150-33/4" },
  "TD150404": { intro2SeriesName: "TD", intro2ModelKey: "TD150-40/4" },
  "TD150504": { intro2SeriesName: "TD", intro2ModelKey: "TD150-50/4" },
  "TD2001254": { intro2SeriesName: "TD", intro2ModelKey: "TD200-12.5/4" },
  "TD200204": { intro2SeriesName: "TD", intro2ModelKey: "TD200-20/4" },
  "TD200234": { intro2SeriesName: "TD", intro2ModelKey: "TD200-23/4" },
  "TD200244": { intro2SeriesName: "TD", intro2ModelKey: "TD200-24/4" },
  "TD200274": { intro2SeriesName: "TD", intro2ModelKey: "TD200-27/4" },
  "TD200324": { intro2SeriesName: "TD", intro2ModelKey: "TD200-32/4" },
  "TD200434": { intro2SeriesName: "TD", intro2ModelKey: "TD200-43/4" },
  "TD200504": { intro2SeriesName: "TD", intro2ModelKey: "TD200-50/4" },
  "TD200534": { intro2SeriesName: "TD", intro2ModelKey: "TD200-53/4" },
  "TD2501254": { intro2SeriesName: "TD", intro2ModelKey: "TD250-12.5/4" },
  "TD250144": { intro2SeriesName: "TD", intro2ModelKey: "TD250-14/4" },
  "TD250174": { intro2SeriesName: "TD", intro2ModelKey: "TD250-17/4" },
  "TD250204": { intro2SeriesName: "TD", intro2ModelKey: "TD250-20/4" },
  "TD250264": { intro2SeriesName: "TD", intro2ModelKey: "TD250-26/4" },
  "TD250324": { intro2SeriesName: "TD", intro2ModelKey: "TD250-32/4" },
  "TD250364": { intro2SeriesName: "TD", intro2ModelKey: "TD250-36/4" },
  "TD250404": { intro2SeriesName: "TD", intro2ModelKey: "TD250-40/4" },
  "TD250504": { intro2SeriesName: "TD", intro2ModelKey: "TD250-50/4" },
  "TD300154": { intro2SeriesName: "TD", intro2ModelKey: "TD300-15/4" },
  "TD300204": { intro2SeriesName: "TD", intro2ModelKey: "TD300-20/4" },
  "TD300254": { intro2SeriesName: "TD", intro2ModelKey: "TD300-25/4" },
  "TD300304": { intro2SeriesName: "TD", intro2ModelKey: "TD300-30/4" },
  "TD300354": { intro2SeriesName: "TD", intro2ModelKey: "TD300-35/4" },
  "TD300444": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "TD300554": { intro2SeriesName: "TD", intro2ModelKey: "TD300-55/4" },
  "TD32182": { intro2SeriesName: "TD", intro2ModelKey: "TD32-18/2" },
  "TD32212": { intro2SeriesName: "TD", intro2ModelKey: "TD32-21/2" },
  "TD32252": { intro2SeriesName: "TD", intro2ModelKey: "TD32-25/2" },
  "TD32322": { intro2SeriesName: "TD", intro2ModelKey: "TD32-32/2" },
  "TD32382": { intro2SeriesName: "TD", intro2ModelKey: "TD32-38/2" },
  "TD32502": { intro2SeriesName: "TD", intro2ModelKey: "TD32-50/2" },
  "TD40162": { intro2SeriesName: "TD", intro2ModelKey: "TD40-16/2" },
  "TD40182": { intro2SeriesName: "TD", intro2ModelKey: "TD40-18/2" },
  "TD40202": { intro2SeriesName: "TD", intro2ModelKey: "TD40-20/2" },
  "TD40252": { intro2SeriesName: "TD", intro2ModelKey: "TD40-25/2" },
  "TD40302": { intro2SeriesName: "TD", intro2ModelKey: "TD40-30/2" },
  "TD40362": { intro2SeriesName: "TD", intro2ModelKey: "TD40-36/2" },
  "TD40482": { intro2SeriesName: "TD", intro2ModelKey: "TD40-48/2" },
  "TD50122": { intro2SeriesName: "TD", intro2ModelKey: "TD50-12/2" },
  "TD50152": { intro2SeriesName: "TD", intro2ModelKey: "TD50-15/2" },
  "TD50182": { intro2SeriesName: "TD", intro2ModelKey: "TD50-18/2" },
  "TD50242": { intro2SeriesName: "TD", intro2ModelKey: "TD50-24/2" },
  "TD50282": { intro2SeriesName: "TD", intro2ModelKey: "TD50-28/2" },
  "TD50322": { intro2SeriesName: "TD", intro2ModelKey: "TD50-32/2" },
  "TD50352": { intro2SeriesName: "TD", intro2ModelKey: "TD50-35/2" },
  "TD50382": { intro2SeriesName: "TD", intro2ModelKey: "TD50-38/2" },
  "TD50402": { intro2SeriesName: "TD", intro2ModelKey: "TD50-40/2" },
  "TD50482": { intro2SeriesName: "TD", intro2ModelKey: "TD50-48/2" },
  "TD50502": { intro2SeriesName: "TD", intro2ModelKey: "TD50-50/2" },
  "TD50602": { intro2SeriesName: "TD", intro2ModelKey: "TD50-60/2" },
  "TD50702": { intro2SeriesName: "TD", intro2ModelKey: "TD50-70/2" },
  "TD50812": { intro2SeriesName: "TD", intro2ModelKey: "TD50-81/2" },
  "TD65152": { intro2SeriesName: "TD", intro2ModelKey: "TD65-15/2" },
  "TD65192": { intro2SeriesName: "TD", intro2ModelKey: "TD65-19/2" },
  "TD65222": { intro2SeriesName: "TD", intro2ModelKey: "TD65-22/2" },
  "TD65302": { intro2SeriesName: "TD", intro2ModelKey: "TD65-30/2" },
  "TD65342": { intro2SeriesName: "TD", intro2ModelKey: "TD65-34/2" },
  "TD65362": { intro2SeriesName: "TD", intro2ModelKey: "TD65-36/2" },
  "TD65402": { intro2SeriesName: "TD", intro2ModelKey: "TD65-40/2" },
  "TD65482": { intro2SeriesName: "TD", intro2ModelKey: "TD65-48/2" },
  "TD65502": { intro2SeriesName: "TD", intro2ModelKey: "TD65-50/2" },
  "TD65612": { intro2SeriesName: "TD", intro2ModelKey: "TD65-61/2" },
  "TD65672": { intro2SeriesName: "TD", intro2ModelKey: "TD65-67/2" },
  "TD65832": { intro2SeriesName: "TD", intro2ModelKey: "TD65-83/2" },
  "TD80132": { intro2SeriesName: "TD", intro2ModelKey: "TD80-13/2" },
  "TD80182": { intro2SeriesName: "TD", intro2ModelKey: "TD80-18/2" },
  "TD80222": { intro2SeriesName: "TD", intro2ModelKey: "TD80-22/2" },
  "TD80282": { intro2SeriesName: "TD", intro2ModelKey: "TD80-28/2" },
  "TD80302": { intro2SeriesName: "TD", intro2ModelKey: "TD80-30/2" },
  "TD80382": { intro2SeriesName: "TD", intro2ModelKey: "TD80-38/2" },
  "TD80402": { intro2SeriesName: "TD", intro2ModelKey: "TD80-40/2" },
  "TD80472": { intro2SeriesName: "TD", intro2ModelKey: "TD80-47/2" },
  "TD80482": { intro2SeriesName: "TD", intro2ModelKey: "TD80-48/2" },
  "TD80542": { intro2SeriesName: "TD", intro2ModelKey: "TD80-54/2" },
  "TD80672": { intro2SeriesName: "TD", intro2ModelKey: "TD80-67/2" },
  "NES10080160152": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-15-2" },
  "NES10080160154": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-1.5-4" },
  "NES100801601852": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-18.5-2" },
  "NES10080160222": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-22-2" },
  "NES10080160224": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-2.2-4" },
  "NES1008016034": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-3-4" },
  "NES10080200302": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-30-2" },
  "NES1008020034": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-3-4" },
  "NES10080200372": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-37-2" },
  "NES1008020044": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-4-4" },
  "NES10080200452": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-45-2" },
  "NES10080200554": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-5.5-4" },
  "NES10080260114": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-11-4" },
  "NES10080260452": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-45-2" },
  "NES10080260552": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-55-2" },
  "NES10080260752": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-75-2" },
  "NES10080260754": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-7.5-4" },
  "NES10080320114": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-11-4" },
  "NES10080320154": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-15-4" },
  "NES10080320H752": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-75-2" },
  "NES10080320H902": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-90-2" },
  "NES100804001854": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-18.5-4" },
  "NES10080400224": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-22-4" },
  "NES10080400304": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-30-4" },
  "NES125100160152": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-15-2" },
  "NES1251001601852": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-18.5-2" },
  "NES125100160222": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-22-2" },
  "NES125100160224": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-2.2-4" },
  "NES125100160302": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-30-2" },
  "NES12510016034": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-3-4" },
  "NES125100200372": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-37-2" },
  "NES125100200452": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-45-2" },
  "NES125100200552": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-55-2" },
  "NES125100200554": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-5.5-4" },
  "NES125100200752": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-75-2" },
  "NES125100200754": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-7.5-4" },
  "NES125100260114": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-11-4" },
  "NES125100260154": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-15-4" },
  "NES125100320154": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-15-4" },
  "NES1251003201854": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-18.5-4" },
  "NES125100320224": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-22-4" },
  "NES125100320304": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-30-4" },
  "NES125100400224": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-22-4" },
  "NES125100400304": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-30-4" },
  "NES125100400374": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-37-4" },
  "NES150125200114": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-11-4" },
  "NES150125200552": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-55-2" },
  "NES150125200752": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-75-2" },
  "NES150125200754": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-7.5-4" },
  "NES150125260154": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-15-4" },
  "NES1501252601854": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-18.5-4" },
  "NES150125260224": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-22-4" },
  "NES150125260304": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-30-4" },
  "NES1501253201854": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-18.5-4" },
  "NES150125320224": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-22-4" },
  "NES150125320304": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-30-4" },
  "NES150125400374": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-37-4" },
  "NES150125400454": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-45-4" },
  "NES150125400554": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-55-4" },
  "NES150125400754": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-75-4" },
  "NES200150200114": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-11-4" },
  "NES200150200154": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-15-4" },
  "NES2001502001854": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-18.5-4" },
  "NES2001502601854": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-18.5-4" },
  "NES200150260224": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-22-4" },
  "NES200150260304": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-30-4" },
  "NES200150320304": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-30-4" },
  "NES200150320374": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-37-4" },
  "NES200150320454": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-45-4" },
  "NES200150320554": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-55-4" },
  "NES200150400454": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-45-4" },
  "NES200150400554": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-55-4" },
  "NES200150400754": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-75-4" },
  "NES200150400904": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-90-4" },
  "NES250200260224": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-22-4" },
  "NES250200260304": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-30-4" },
  "NES250200320374": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-37-4" },
  "NES250200320454": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-45-4" },
  "NES250200320554": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-55-4" },
  "NES250200320754": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-75-4" },
  "NES2502004001104": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-110-4" },
  "NES250200400554": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-55-4" },
  "NES250200400754": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-75-4" },
  "NES250200400904": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-90-4" },
  "NES300250320554": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-55-4" },
  "NES300250320754": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-75-4" },
  "NES300250320904": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-90-4" },
  "NES3002504001104": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-110-4" },
  "NES3002504001324": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-132-4" },
  "NES300250400754": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-75-4" },
  "NES300250400904": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-90-4" },
  "NES50321300554": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-0.55-4" },
  "NES5032130112": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-1.1-2" },
  "NES5032130152": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-1.5-2" },
  "NES5032130222": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-2.2-2" },
  "NES50321600554": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-0.55-4" },
  "NES5032160222": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-2.2-2" },
  "NES503216032": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-3-2" },
  "NES503216042": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-4-2" },
  "NES5032160552": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-5.5-2" },
  "NES50322000754": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-0.75-4" },
  "NES5032200112": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-11-2" },
  "NES5032200114": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-1.1-4" },
  "NES5032200552": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-5.5-2" },
  "NES5032200752": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-7.5-2" },
  "NES5032260112": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-11-2" },
  "NES5032260152": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-15-2" },
  "NES50322601852": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-18.5-2" },
  "NES5032260224": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-2.2-4" },
  "NES503226034": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-3-4" },
  "NES65401300554": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-0.55-4" },
  "NES6540130152": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-1.5-2" },
  "NES6540130222": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-2.2-2" },
  "NES654013032": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-3-2" },
  "NES654013042": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-4-2" },
  "NES65401600554": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.55-4" },
  "NES65401600754": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.75-4" },
  "NES6540160114": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-1.1-4" },
  "NES654016032": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-3-2" },
  "NES654016042": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-4-2" },
  "NES6540160552": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-5.5-2" },
  "NES6540160752": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-7.5-2" },
  "NES65402000754": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-0.75-4" },
  "NES6540200112": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-11-2" },
  "NES6540200114": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.1-4" },
  "NES6540200154": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.5-4" },
  "NES6540200552": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-5.5-2" },
  "NES6540200752": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-7.5-2" },
  "NES6540260152": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-15-2" },
  "NES6540260154": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-1.5-4" },
  "NES65402601852": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-18.5-2" },
  "NES6540260222": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-22-2" },
  "NES6540260224": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-2.2-4" },
  "NES654026034": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-3-4" },
  "NES6540320222": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-22-2" },
  "NES6540320302": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-30-2" },
  "NES6540320372": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-37-2" },
  "NES654032044": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-4-4" },
  "NES6540320452": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-45-2" },
  "NES6540320554": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-5.5-4" },
  "NES6540320754": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-7.5-4" },
  "NES65501300554": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.55-4" },
  "NES65501300754": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.75-4" },
  "NES6550130114": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-1.1-4" },
  "NES655013032": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-3-2" },
  "NES655013042": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-4-2" },
  "NES6550130552": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-5.5-2" },
  "NES6550130752": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-7.5-2" },
  "NES65501600754": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-0.75-4" },
  "NES6550160112": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-11-2" },
  "NES6550160114": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.1-4" },
  "NES6550160154": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.5-4" },
  "NES6550160752": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-7.5-2" },
  "NES6550200112": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-11-2" },
  "NES6550200114": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.1-4" },
  "NES6550200152": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-15-2" },
  "NES6550200154": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.5-4" },
  "NES65502001852": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-18.5-2" },
  "NES6550200224": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-2.2-4" },
  "NES6550260222": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-22-2" },
  "NES655026034": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-3-4" },
  "NES655026044": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-4-4" },
  "NES6550260554": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-5.5-4" },
  "NES6550260H222": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-22-2" },
  "NES6550260H302": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-30-2" },
  "NES6550320114": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-11-4" },
  "NES6550320554": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-5.5-4" },
  "NES6550320754": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-7.5-4" },
  "NES80651300754": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-0.75-4" },
  "NES8065130114": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-1.1-4" },
  "NES806513042": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-4-2" },
  "NES8065130752": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-7.5-2" },
  "NES8065160112": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-11-2" },
  "NES8065160114": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.1-4" },
  "NES8065160152": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-15-2" },
  "NES8065160154": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.5-4" },
  "NES80651601852": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-18.5-2" },
  "NES8065160224": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-2.2-4" },
  "NES80652001852": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-18.5-2" },
  "NES8065200224": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-2.2-4" },
  "NES806520034": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-3-4" },
  "NES806520044": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-4-4" },
  "NES8065200H302": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200H-30-2" },
  "NES806526034": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-3-4" },
  "NES8065260372": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-37-2" },
  "NES806526044": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-4-4" },
  "NES8065260452": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-45-2" },
  "NES8065260552": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-55-2" },
  "NES8065260554": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-5.5-4" },
  "NES8065260754": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-7.5-4" },
  "NES8065320114": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-11-4" },
  "NES8065320154": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-15-4" },
  "NES8065320754": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-7.5-4" },
  "NES8065320H902": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320H-90-2" },
};

export const PARAMETER_SHEET_SPU_ID_MAPPING: Record<string, ParameterSheetMappingEntry> = {
  "45": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-1.5-2" },
  "46": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-2.2-2" },
  "48": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-2.2-2" },
  "49": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-3-2" },
  "50": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-4-2" },
  "51": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-5.5-2" },
  "52": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-5.5-2" },
  "53": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-7.5-2" },
  "54": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-11-2" },
  "55": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-11-2" },
  "56": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-15-2" },
  "57": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-18.5-2" },
  "58": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-1.5-2" },
  "59": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-2.2-2" },
  "60": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-3-2" },
  "61": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-4-2" },
  "62": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-3-2" },
  "63": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-4-2" },
  "64": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-5.5-2" },
  "65": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-7.5-2" },
  "66": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-5.5-2" },
  "67": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-7.5-2" },
  "68": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-11-2" },
  "69": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-15-2" },
  "70": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-18.5-2" },
  "71": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-22-2" },
  "72": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-22-2" },
  "73": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-15-2" },
  "74": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-30-2" },
  "75": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-18.5-2" },
  "76": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-37-2" },
  "77": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-45-2" },
  "78": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-22-2" },
  "79": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-30-2" },
  "81": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-3-2" },
  "82": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-4-2" },
  "83": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-37-2" },
  "84": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-5.5-2" },
  "85": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-7.5-2" },
  "86": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-45-2" },
  "87": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-55-2" },
  "88": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-75-2" },
  "91": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-7.5-2" },
  "92": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-11-2" },
  "98": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-11-2" },
  "99": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-15-2" },
  "101": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-18.5-2" },
  "103": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-22-2" },
  "105": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-30-2" },
  "107": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-55-2" },
  "113": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-75-2" },
  "116": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-4-2" },
  "118": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-7.5-2" },
  "120": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-15-2" },
  "121": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-18.5-2" },
  "123": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-11-2" },
  "124": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-15-2" },
  "125": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-22-2" },
  "126": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-18.5-2" },
  "132": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200H-30-2" },
  "133": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-30-2" },
  "134": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-37-2" },
  "136": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-37-2" },
  "137": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-45-2" },
  "138": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-45-2" },
  "139": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-55-2" },
  "140": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-45-2" },
  "141": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-55-2" },
  "142": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-75-2" },
  "146": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320H-90-2" },
  "147": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-75-2" },
  "148": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-90-2" },
  "149": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-0.55-4" },
  "150": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-0.55-4" },
  "151": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-0.75-4" },
  "152": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-1.1-4" },
  "153": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-2.2-4" },
  "154": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-0.55-4" },
  "155": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.55-4" },
  "156": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.75-4" },
  "157": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-1.1-4" },
  "158": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-0.75-4" },
  "159": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-75-4" },
  "160": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-11-4" },
  "161": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.1-4" },
  "162": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-15-4" },
  "163": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-18.5-4" },
  "164": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-18.5-4" },
  "165": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.5-4" },
  "166": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-22-4" },
  "167": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-30-4" },
  "168": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-30-4" },
  "169": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-37-4" },
  "170": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-45-4" },
  "171": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-3-4" },
  "172": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-2.2-4" },
  "173": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-2.2-4" },
  "174": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.1-4" },
  "175": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-3-4" },
  "176": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.5-4" },
  "177": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-1.5-4" },
  "178": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-2.2-4" },
  "179": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-4-4" },
  "180": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-3-4" },
  "181": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-3-4" },
  "182": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-4-4" },
  "183": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-4-4" },
  "184": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-5.5-4" },
  "185": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-5.5-4" },
  "186": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-7.5-4" },
  "187": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-7.5-4" },
  "188": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-7.5-4" },
  "189": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-11-4" },
  "190": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-15-4" },
  "191": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-1.5-4" },
  "192": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-2.2-4" },
  "193": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-3-4" },
  "194": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-3-4" },
  "195": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-55-4" },
  "196": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-45-4" },
  "197": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-55-4" },
  "198": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-75-4" },
  "199": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-90-4" },
  "200": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-22-4" },
  "201": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-30-4" },
  "202": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-37-4" },
  "203": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-45-4" },
  "204": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-55-4" },
  "205": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-75-4" },
  "206": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-55-4" },
  "207": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-75-4" },
  "208": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-90-4" },
  "209": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-110-4" },
  "210": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-55-4" },
  "211": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-75-4" },
  "212": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-90-4" },
  "213": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-110-4" },
  "214": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-132-4" },
  "215": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-4-4" },
  "216": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-5.5-4" },
  "217": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-7.5-4" },
  "218": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-11-4" },
  "219": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-11-4" },
  "220": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-15-4" },
  "221": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-18.5-4" },
  "222": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-22-4" },
  "223": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-30-4" },
  "224": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-2.2-4" },
  "225": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-3-4" },
  "226": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-5.5-4" },
  "227": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-7.5-4" },
  "228": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-11-4" },
  "229": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-15-4" },
  "230": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-15-4" },
  "231": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-18.5-4" },
  "232": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-22-4" },
  "233": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-30-4" },
  "234": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-22-4" },
  "235": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-30-4" },
  "236": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-37-4" },
  "237": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-7.5-4" },
  "238": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-11-4" },
  "239": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-15-4" },
  "240": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-18.5-4" },
  "241": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.55-4" },
  "242": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-22-4" },
  "243": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.75-4" },
  "244": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-30-4" },
  "245": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-18.5-4" },
  "246": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-1.1-4" },
  "247": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-22-4" },
  "248": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-30-4" },
  "249": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-37-4" },
  "250": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-0.75-4" },
  "251": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-45-4" },
  "252": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.1-4" },
  "253": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.5-4" },
  "254": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-55-4" },
  "255": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.1-4" },
  "256": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.5-4" },
  "257": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-2.2-4" },
  "258": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-3-4" },
  "259": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-4-4" },
  "260": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-5.5-4" },
  "261": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-5.5-4" },
  "262": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-7.5-4" },
  "263": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-11-4" },
  "264": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-0.75-4" },
  "265": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-1.1-4" },
  "785": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-2(60hz)" },
  "786": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-3(60hz)" },
  "787": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-4(60hz)" },
  "788": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-5(60hz)" },
  "789": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-6(60hz)" },
  "790": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-7(60hz)" },
  "791": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-8(60hz)" },
  "792": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-9(60hz)" },
  "793": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-10(60hz)" },
  "794": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-11(60hz)" },
  "795": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-12(60hz)" },
  "796": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-13(60hz)" },
  "798": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-15(60hz)" },
  "800": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-17(60hz)" },
  "802": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-19(60hz)" },
  "803": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-20" },
  "804": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-21(60hz)" },
  "805": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-2(60hz)" },
  "806": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-23(60hz)" },
  "807": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-4(60hz)" },
  "808": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-25(60hz)" },
  "809": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-6(60hz)" },
  "810": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-7(60hz)" },
  "811": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-8(60hz)" },
  "813": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-30" },
  "820": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-2(60hz)" },
  "821": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-3(60hz)" },
  "822": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-4(60hz)" },
  "823": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-5(60hz)" },
  "824": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "825": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-7(60hz)" },
  "827": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-9(60hz)" },
  "829": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-11(60hz)" },
  "831": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-13(60hz)" },
  "833": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-15(60hz)" },
  "836": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-18(60hz)" },
  "838": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-20" },
  "845": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-2(60hz)" },
  "846": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-3(60hz)" },
  "847": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-4(60hz)" },
  "848": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-5(60hz)" },
  "849": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-6(60hz)" },
  "850": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-7(60hz)" },
  "851": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-8(60hz)" },
  "852": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-9(60hz)" },
  "853": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-10(60hz)" },
  "854": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-11(60hz)" },
  "855": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-12(60hz)" },
  "856": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-13(60hz)" },
  "858": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-15(60hz)" },
  "860": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-17(60hz)" },
  "862": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-19(60hz)" },
  "863": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-20" },
  "864": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-21(60hz)" },
  "866": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-23(60hz)" },
  "868": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-25(60hz)" },
  "873": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-30" },
  "880": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-2(60hz)" },
  "881": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-3(60hz)" },
  "882": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-4(60hz)" },
  "883": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-5(60hz)" },
  "884": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-6(60hz)" },
  "885": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-7(60hz)" },
  "886": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-8(60hz)" },
  "888": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-10(60hz)" },
  "890": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-12(60hz)" },
  "892": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-14(60hz)" },
  "894": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-16(60hz)" },
  "898": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-20" },
  "901": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-2/1(60hz)" },
  "902": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-2(60hz)" },
  "903": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-3(60hz)" },
  "904": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-4(60hz)" },
  "905": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-5(60hz)" },
  "906": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-6(60hz)" },
  "908": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-8(60hz)" },
  "910": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-10(60hz)" },
  "912": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-12(60hz)" },
  "914": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-14(60hz)" },
  "920": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-20" },
  "921": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-1(60hz)" },
  "922": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-2(60hz)" },
  "923": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-3(60hz)" },
  "924": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-4(60hz)" },
  "925": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-5(60hz)" },
  "926": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-6(60hz)" },
  "927": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-7(60hz)" },
  "928": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-8(60hz)" },
  "929": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-9(60hz)" },
  "930": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-10" },
  "932": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-12(60hz)" },
  "934": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-14(60hz)" },
  "936": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-16(60hz)" },
  "937": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-17(60hz)" },
  "940": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-20" },
  "943": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-2(60hz)" },
  "944": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-23(60hz)" },
  "945": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-4(60hz)" },
  "946": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-25(60hz)" },
  "947": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-6(60hz)" },
  "948": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-7(60hz)" },
  "949": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-8(60hz)" },
  "951": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-210" },
  "953": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-12(60hz)" },
  "955": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-14(60hz)" },
  "960": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-1(60hz)" },
  "961": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-2(60hz)" },
  "962": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-3(60hz)" },
  "963": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-4(60hz)" },
  "964": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-5(60hz)" },
  "965": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-6(60hz)" },
  "966": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-7(60hz)" },
  "967": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-8(60hz)" },
  "968": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-9(60hz)" },
  "969": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-10(60hz)" },
  "971": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-12(60hz)" },
  "977": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-2/1(60hz)" },
  "978": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-2(60hz)" },
  "979": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-3(60hz)" },
  "980": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-4(60hz)" },
  "981": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-5(60hz)" },
  "982": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-6(60hz)" },
  "983": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-7(60hz)" },
  "984": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-8(60hz)" },
  "986": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-10(60hz)" },
  "993": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-1(60hz)" },
  "994": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-2(60hz)" },
  "995": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-3(60hz)" },
  "996": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-4(60hz)" },
  "997": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-5(60hz)" },
  "998": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-6(60hz)" },
  "999": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-7(60hz)" },
  "1000": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-8(60hz)" },
  "1002": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-10" },
  "1010": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-10-1" },
  "1011": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-210" },
  "1012": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20-2" },
  "1013": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20" },
  "1014": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-230" },
  "1015": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-40" },
  "1016": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-250" },
  "1017": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60" },
  "1018": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-270" },
  "1019": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-80" },
  "1020": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-290" },
  "1021": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-100" },
  "1022": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-110" },
  "1023": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-120" },
  "1024": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-130" },
  "1025": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-140" },
  "1026": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150-2" },
  "1027": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150" },
  "1028": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160-2" },
  "1029": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160" },
  "1030": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10-1(60hz)" },
  "1031": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10(60hz)" },
  "1032": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-20-2(60hz)" },
  "1033": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-220" },
  "1034": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30-2(60hz)" },
  "1035": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30(60hz)" },
  "1036": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40-2(60hz)" },
  "1037": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40(60hz)" },
  "1038": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50-2(60hz)" },
  "1039": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50(60hz)" },
  "1040": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60-2(60hz)" },
  "1041": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60(60hz)" },
  "1042": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70-2(60hz)" },
  "1043": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70(60hz)" },
  "1055": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-10-1(60hz)" },
  "1056": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-10(60hz)" },
  "1057": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-20-2(60hz)" },
  "1059": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-20(60hz)" },
  "1060": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-30-2(60hz)" },
  "1062": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-30(60hz)" },
  "1063": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-40-2(60hz)" },
  "1065": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-40(60hz)" },
  "1066": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-50-2(60hz)" },
  "1089": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-10" },
  "1090": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-2" },
  "1091": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-1" },
  "1092": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20" },
  "1093": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-2" },
  "1094": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-1" },
  "1095": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30" },
  "1096": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-2" },
  "1097": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-1" },
  "1098": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40" },
  "1099": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-2" },
  "1100": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-1" },
  "1101": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50" },
  "1102": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-2" },
  "1103": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-1" },
  "1104": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60" },
  "1105": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-2" },
  "1106": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-1" },
  "1107": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70" },
  "1108": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10-1" },
  "1109": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10" },
  "1110": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-2" },
  "1111": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-1" },
  "1112": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20" },
  "1113": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-2" },
  "1114": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-1" },
  "1115": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30" },
  "1116": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-2" },
  "1117": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-1" },
  "1118": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40" },
  "1119": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-2" },
  "1120": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-1" },
  "1121": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50" },
  "1122": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-2" },
  "1123": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-1" },
  "1124": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60" },
  "1125": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-B" },
  "1126": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-A" },
  "1127": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10" },
  "1128": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2B" },
  "1129": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2A" },
  "1130": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20" },
  "1131": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2B" },
  "1132": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A-B" },
  "1133": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2A" },
  "1134": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-B" },
  "1135": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A" },
  "1136": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30" },
  "1137": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2B" },
  "1138": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2A" },
  "1139": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-A" },
  "1140": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40" },
  "1145": { intro2SeriesName: "TD", intro2ModelKey: "TD32-18/2" },
  "1146": { intro2SeriesName: "TD", intro2ModelKey: "TD32-21/2" },
  "1147": { intro2SeriesName: "TD", intro2ModelKey: "TD32-25/2" },
  "1148": { intro2SeriesName: "TD", intro2ModelKey: "TD32-32/2" },
  "1149": { intro2SeriesName: "TD", intro2ModelKey: "TD32-38/2" },
  "1150": { intro2SeriesName: "TD", intro2ModelKey: "TD32-50/2" },
  "1151": { intro2SeriesName: "TD", intro2ModelKey: "TD40-16/2" },
  "1152": { intro2SeriesName: "TD", intro2ModelKey: "TD40-20/2" },
  "1153": { intro2SeriesName: "TD", intro2ModelKey: "TD40-18/2" },
  "1154": { intro2SeriesName: "TD", intro2ModelKey: "TD40-25/2" },
  "1155": { intro2SeriesName: "TD", intro2ModelKey: "TD40-30/2" },
  "1156": { intro2SeriesName: "TD", intro2ModelKey: "TD40-36/2" },
  "1157": { intro2SeriesName: "TD", intro2ModelKey: "TD40-48/2" },
  "1158": { intro2SeriesName: "TD", intro2ModelKey: "TD50-12/2" },
  "1159": { intro2SeriesName: "TD", intro2ModelKey: "TD50-15/2" },
  "1160": { intro2SeriesName: "TD", intro2ModelKey: "TD50-18/2" },
  "1161": { intro2SeriesName: "TD", intro2ModelKey: "TD50-24/2" },
  "1162": { intro2SeriesName: "TD", intro2ModelKey: "TD50-28/2" },
  "1163": { intro2SeriesName: "TD", intro2ModelKey: "TD50-32/2" },
  "1164": { intro2SeriesName: "TD", intro2ModelKey: "TD50-38/2" },
  "1165": { intro2SeriesName: "TD", intro2ModelKey: "TD50-48/2" },
  "1168": { intro2SeriesName: "TD", intro2ModelKey: "TD50-35/2" },
  "1169": { intro2SeriesName: "TD", intro2ModelKey: "TD50-40/2" },
  "1170": { intro2SeriesName: "TD", intro2ModelKey: "TD50-50/2" },
  "1171": { intro2SeriesName: "TD", intro2ModelKey: "TD50-60/2" },
  "1172": { intro2SeriesName: "TD", intro2ModelKey: "TD50-70/2" },
  "1173": { intro2SeriesName: "TD", intro2ModelKey: "TD50-81/2" },
  "1174": { intro2SeriesName: "TD", intro2ModelKey: "TD65-15/2" },
  "1175": { intro2SeriesName: "TD", intro2ModelKey: "TD65-19/2" },
  "1176": { intro2SeriesName: "TD", intro2ModelKey: "TD65-22/2" },
  "1177": { intro2SeriesName: "TD", intro2ModelKey: "TD65-30/2" },
  "1178": { intro2SeriesName: "TD", intro2ModelKey: "TD65-36/2" },
  "1179": { intro2SeriesName: "TD", intro2ModelKey: "TD65-34/2" },
  "1180": { intro2SeriesName: "TD", intro2ModelKey: "TD65-40/2" },
  "1181": { intro2SeriesName: "TD", intro2ModelKey: "TD65-48/2" },
  "1182": { intro2SeriesName: "TD", intro2ModelKey: "TD65-50/2" },
  "1183": { intro2SeriesName: "TD", intro2ModelKey: "TD65-61/2" },
  "1184": { intro2SeriesName: "TD", intro2ModelKey: "TD65-67/2" },
  "1185": { intro2SeriesName: "TD", intro2ModelKey: "TD65-83/2" },
  "1186": { intro2SeriesName: "TD", intro2ModelKey: "TD80-13/2" },
  "1187": { intro2SeriesName: "TD", intro2ModelKey: "TD80-18/2" },
  "1188": { intro2SeriesName: "TD", intro2ModelKey: "TD80-22/2" },
  "1189": { intro2SeriesName: "TD", intro2ModelKey: "TD80-28/2" },
  "1190": { intro2SeriesName: "TD", intro2ModelKey: "TD80-30/2" },
  "1191": { intro2SeriesName: "TD", intro2ModelKey: "TD80-38/2" },
  "1192": { intro2SeriesName: "TD", intro2ModelKey: "TD80-40/2" },
  "1193": { intro2SeriesName: "TD", intro2ModelKey: "TD80-48/2" },
  "1194": { intro2SeriesName: "TD", intro2ModelKey: "TD80-47/2" },
  "1195": { intro2SeriesName: "TD", intro2ModelKey: "TD80-54/2" },
  "1196": { intro2SeriesName: "TD", intro2ModelKey: "TD80-67/2" },
  "1197": { intro2SeriesName: "TD", intro2ModelKey: "TD100-9/2" },
  "1198": { intro2SeriesName: "TD", intro2ModelKey: "TD100-15/2" },
  "1199": { intro2SeriesName: "TD", intro2ModelKey: "TD100-17/2" },
  "1200": { intro2SeriesName: "TD", intro2ModelKey: "TD100-22/2" },
  "1201": { intro2SeriesName: "TD", intro2ModelKey: "TD100-27/2" },
  "1202": { intro2SeriesName: "TD", intro2ModelKey: "TD100-33/2" },
  "1203": { intro2SeriesName: "TD", intro2ModelKey: "TD100-40/2" },
  "1204": { intro2SeriesName: "TD", intro2ModelKey: "TD100-48/2" },
  "1205": { intro2SeriesName: "TD", intro2ModelKey: "TD100-52/2" },
  "1206": { intro2SeriesName: "TD", intro2ModelKey: "TD125-11/4" },
  "1207": { intro2SeriesName: "TD", intro2ModelKey: "TD125-14/4" },
  "1208": { intro2SeriesName: "TD", intro2ModelKey: "TD125-18/4" },
  "1209": { intro2SeriesName: "TD", intro2ModelKey: "TD125-22/4" },
  "1210": { intro2SeriesName: "TD", intro2ModelKey: "TD125-28/4" },
  "1211": { intro2SeriesName: "TD", intro2ModelKey: "TD125-32/4" },
  "1212": { intro2SeriesName: "TD", intro2ModelKey: "TD125-40/4" },
  "1213": { intro2SeriesName: "TD", intro2ModelKey: "TD125-48/4" },
  "1214": { intro2SeriesName: "TD", intro2ModelKey: "TD150-12.5/4" },
  "1215": { intro2SeriesName: "TD", intro2ModelKey: "TD150-17/4" },
  "1216": { intro2SeriesName: "TD", intro2ModelKey: "TD150-21/4" },
  "1217": { intro2SeriesName: "TD", intro2ModelKey: "TD150-25/4" },
  "1218": { intro2SeriesName: "TD", intro2ModelKey: "TD150-33/4" },
  "1219": { intro2SeriesName: "TD", intro2ModelKey: "TD150-40/4" },
  "1220": { intro2SeriesName: "TD", intro2ModelKey: "TD150-50/4" },
  "1223": { intro2SeriesName: "TD", intro2ModelKey: "TD200-24/4" },
  "1227": { intro2SeriesName: "TD", intro2ModelKey: "TD200-53/4" },
  "1228": { intro2SeriesName: "TD", intro2ModelKey: "TD200-12.5/4" },
  "1229": { intro2SeriesName: "TD", intro2ModelKey: "TD200-20/4" },
  "1230": { intro2SeriesName: "TD", intro2ModelKey: "TD200-23/4" },
  "1231": { intro2SeriesName: "TD", intro2ModelKey: "TD200-27/4" },
  "1232": { intro2SeriesName: "TD", intro2ModelKey: "TD200-32/4" },
  "1233": { intro2SeriesName: "TD", intro2ModelKey: "TD200-43/4" },
  "1234": { intro2SeriesName: "TD", intro2ModelKey: "TD200-50/4" },
  "1239": { intro2SeriesName: "TD", intro2ModelKey: "TD250-36/4" },
  "1242": { intro2SeriesName: "TD", intro2ModelKey: "TD250-12.5/4" },
  "1243": { intro2SeriesName: "TD", intro2ModelKey: "TD250-14/4" },
  "1244": { intro2SeriesName: "TD", intro2ModelKey: "TD250-17/4" },
  "1245": { intro2SeriesName: "TD", intro2ModelKey: "TD250-20/4" },
  "1246": { intro2SeriesName: "TD", intro2ModelKey: "TD250-26/4" },
  "1247": { intro2SeriesName: "TD", intro2ModelKey: "TD250-32/4" },
  "1248": { intro2SeriesName: "TD", intro2ModelKey: "TD250-40/4" },
  "1249": { intro2SeriesName: "TD", intro2ModelKey: "TD250-50/4" },
  "1250": { intro2SeriesName: "TD", intro2ModelKey: "TD300-15/4" },
  "1251": { intro2SeriesName: "TD", intro2ModelKey: "TD300-20/4" },
  "1252": { intro2SeriesName: "TD", intro2ModelKey: "TD300-25/4" },
  "1253": { intro2SeriesName: "TD", intro2ModelKey: "TD300-30/4" },
  "1254": { intro2SeriesName: "TD", intro2ModelKey: "TD300-35/4" },
  "1255": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "1256": { intro2SeriesName: "TD", intro2ModelKey: "TD300-55/4" },
  "1761": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-1.1/4" },
  "1762": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-2.2/2" },
  "1763": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-3/2" },
  "1764": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-4/2" },
  "1765": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-5.5/2" },
  "1766": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-7.5/2" },
  "1767": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-1.5/4" },
  "1768": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-3/4" },
  "1769": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-7.5/2" },
  "1771": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-15/2" },
  "1774": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-2.2/4" },
  "1775": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-4/4" },
  "1776": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-11/2" },
  "1777": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-15/2" },
  "1778": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-18.5/2" },
  "1779": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-22/2" },
  "1780": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-30/2" },
  "1781": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-3/4" },
  "1782": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-5.5/4" },
  "1783": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-15/2" },
  "1784": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-18.5/2" },
  "1785": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-22/2" },
  "1786": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-30/2" },
  "1787": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-37/2" },
  "1789": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-1.1/4" },
  "1790": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-1.5/4" },
  "1791": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-2.2/4" },
  "1792": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-5.5/2" },
  "1793": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-7.5/2" },
  "1794": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-11/2" },
  "1795": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-15/2" },
  "1796": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-200-1.1/4" },
  "1797": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-3/4" },
  "1799": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-11/2" },
  "1800": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-15/2" },
  "1801": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-18.5/2" },
  "1802": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-22/2" },
  "1803": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-30/2" },
  "1813": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-5.5/4" },
  "1814": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-7.5/4" },
  "1815": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-11/4" },
  "1816": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-30/2" },
  "1817": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-37/2" },
  "1818": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-45/2" },
  "1819": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-55/2" },
  "1820": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-75/2" },
  "1821": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-5.5/4" },
  "1822": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-7.5/4" },
  "1823": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-11/4" },
  "1824": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-15/4" },
  "1825": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-30/2" },
  "1826": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-37/2" },
  "1827": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-45/2" },
  "1828": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-55/2" },
  "1829": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-75/2" },
  "1830": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-90/2" },
  "1831": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-110/2" },
  "1832": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-2.2/4" },
  "1833": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-3/4" },
  "1834": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-4/4" },
  "1835": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-5.5/4" },
  "1836": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-15/2" },
  "1837": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-18.5/2" },
  "1838": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-22/2" },
  "1839": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-30/2" },
  "1840": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-250-37/2" },
  "1841": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-5.5/4" },
  "1842": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-7.5/4" },
  "1843": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-11/4" },
  "1844": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-37/2" },
  "1845": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-45/2" },
  "1846": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-55/2" },
  "1847": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-75/2" },
  "1848": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-90/2" },
  "1849": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-7.5/4" },
  "1850": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-11/4" },
  "1851": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-15/4" },
  "1852": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-18.5/4" },
  "1853": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-55/2" },
  "1854": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-75/2" },
  "1855": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-90/2" },
  "1856": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-11/4" },
  "1857": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-15/4" },
  "1858": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-18.5/4" },
  "1859": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-22/4" },
  "1860": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-30/4" },
  "1861": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-75/2" },
  "1862": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-90/2" },
  "1863": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-110/2" },
  "1864": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-15/4" },
  "1865": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-18.5/4" },
  "1866": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-22/4" },
  "1867": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-30/4" },
  "1868": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-37/4" },
  "1870": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-4/4" },
  "1871": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-5.5/4" },
  "1872": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-7.5/4" },
  "1873": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-11/4" },
  "1874": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-22/2" },
  "1875": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-30/2" },
  "1876": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-37/2" },
  "1877": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-315-45/2" },
  "1887": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-7.5/4" },
  "1888": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-11/4" },
  "1889": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-15/4" },
  "1890": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-18.5/4" },
  "1891": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-22/4" },
  "1892": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-45/2" },
  "1893": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-55/2" },
  "1894": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-75/2" },
  "1895": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-90/2" },
  "1896": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-11/4" },
  "1897": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-15/4" },
  "1898": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-18.5/4" },
  "1899": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-22/4" },
  "1900": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-30/4" },
  "1901": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-75/2" },
  "1902": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-90/2" },
  "1903": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-315-110/2" },
  "1905": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-15/4" },
  "1906": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-18.5/4" },
  "1907": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-22/4" },
  "1908": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-30/4" },
  "1909": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-37/4" },
  "1911": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-18.5/4" },
  "1913": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-30/4" },
  "1914": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-37/4" },
  "1917": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-315-30/4" },
  "1918": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-315-37/4" },
  "1919": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-315-45/4" },
  "1920": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-315-55/4" },
  "1921": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-315-75/4" },
  "1923": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-315-37/4" },
  "1924": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-315-45/4" },
  "1925": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-315-55/4" },
  "1926": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-315-75/4" },
  "1929": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-315-45/4" },
  "1930": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-315-55/4" },
  "1931": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-315-75/4" },
  "1932": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-315-90/4" },
  "1933": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-315-110/4" },
  "1934": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-315-132/4" },
  "1935": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-22/4" },
  "1936": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-30/4" },
  "1937": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-37/4" },
  "1938": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-45/4" },
  "1939": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-55/4" },
  "1940": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-400-30/4" },
  "1941": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-400-37/4" },
  "1942": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-400-45/4" },
  "1943": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-400-55/4" },
  "1944": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-400-75/4" },
  "1945": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-400-37/4" },
  "1946": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-400-45/4" },
  "1947": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-400-55/4" },
  "1948": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-400-75/4" },
  "1951": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-400-55/4" },
  "1952": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-400-75/4" },
  "1953": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-400-90/4" },
  "1954": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-400-110/4" },
  "1956": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-75/4" },
  "1957": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-90/4" },
  "1958": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-110/4" },
  "1959": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-132/4" },
  "1960": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-160/4" },
  "1961": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-200/4" },
  "1962": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-90/4" },
  "1963": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-110/4" },
  "1964": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-132/4" },
  "1965": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-160/4" },
  "1966": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-200/4" },
  "2516": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x3" },
  "2517": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x4" },
  "2518": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x5" },
  "2519": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x6" },
  "2520": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x7" },
  "2521": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x8" },
  "2522": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x9" },
  "2523": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x10" },
  "2524": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x11" },
  "2525": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x12" },
  "2526": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x3" },
  "2527": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x4" },
  "2528": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x5" },
  "2529": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x6" },
  "2530": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x7" },
  "2531": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x8" },
  "2532": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x9" },
  "2533": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x10" },
  "2534": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x11" },
  "2535": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x12" },
  "2536": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x2" },
  "2537": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x3" },
  "2538": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x4" },
  "2539": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x5" },
  "2540": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x6" },
  "2541": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x7" },
  "2542": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x8" },
  "2543": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x9" },
  "2544": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x10" },
  "2545": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x11" },
  "2546": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x12" },
  "2547": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x3" },
  "2548": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x4" },
  "2549": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x5" },
  "2550": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x6" },
  "2551": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x7" },
  "2552": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x8" },
  "2553": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x9" },
  "2554": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x10" },
  "2555": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x3" },
  "2556": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x4" },
  "2557": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x5" },
  "2558": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x6" },
  "2559": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x7" },
  "2560": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x8" },
  "2561": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x9" },
  "2562": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x10" },
  "2563": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x11" },
  "2564": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x12" },
  "2565": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x3" },
  "2566": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x4" },
  "2567": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x5" },
  "2568": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x6" },
  "2569": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x7" },
  "2570": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x8" },
  "2571": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x9" },
  "2572": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x10" },
  "2573": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x11" },
  "2574": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x12" },
  "2575": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x3" },
  "2576": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x4" },
  "2577": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x5" },
  "2578": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x6" },
  "2579": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x7" },
  "2580": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x8" },
  "2581": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x9" },
  "2582": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x10" },
  "2583": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x3" },
  "2584": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x4" },
  "2585": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x5" },
  "2586": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x6" },
  "2587": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x7" },
  "2588": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x8" },
  "2589": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x9" },
  "2590": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x3" },
  "2591": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x4" },
  "2592": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x5" },
  "2593": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x6" },
  "2594": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x7" },
  "2595": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x8" },
  "2596": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x9" },
  "2597": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x2" },
  "2598": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x3" },
  "2599": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x4" },
  "2600": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x5" },
  "2601": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x6" },
  "2602": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x7" },
  "2603": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x8" },
  "2604": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x9" },
  "2606": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x2" },
  "2607": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x3" },
  "2608": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x4" },
  "2609": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x5" },
  "2610": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x6" },
  "2611": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x7" },
  "2612": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x8" },
  "2613": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x9" },
  "2614": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x10" },
  "2615": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x2" },
  "2616": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x3" },
  "2617": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x4" },
  "2618": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x5" },
  "2619": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x6" },
  "2620": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x7" },
  "2621": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x8" },
  "2622": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x9" },
  "2623": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x3" },
  "2624": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x4" },
  "2625": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x5" },
  "2626": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x6" },
  "2627": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x7" },
  "2628": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x8" },
  "2629": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x9" },
  "2630": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x2" },
  "2631": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x3" },
  "2632": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x4" },
  "2633": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x5" },
  "2634": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x6" },
  "2635": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x7" },
  "2636": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x8" },
  "2637": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x9" },
  "2638": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x10" },
  "2639": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x2" },
  "2640": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x3" },
  "2641": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x4" },
  "2642": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x5" },
  "2643": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x6" },
  "2644": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x7" },
  "2645": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x8" },
  "2646": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x9" },
  "2647": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x10" },
  "2658": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x3" },
  "2659": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x4" },
  "2660": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x5" },
  "2661": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x6" },
  "2662": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x7" },
  "2663": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x2" },
  "2664": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x3" },
  "2665": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x4" },
  "2666": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x5" },
  "2667": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x6" },
  "2668": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x7" },
  "2669": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x8" },
  "2938": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-500-90/4" },
  "2939": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-500-75/4" },
  "2940": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-500-55/4" },
  "2941": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-500-45/4" },
  "2942": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-500-132/4" },
  "2943": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-500-110/4" },
  "2944": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-500-90/4" },
  "2945": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-500-75/4" },
  "2947": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-500-160/4" },
  "2948": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-500-132/4" },
  "2949": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-500-110/4" },
  "2950": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-500-75/4" },
  "2951": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-250/4" },
  "2952": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-220/4" },
  "2953": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-200/4" },
  "2954": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-160/4" },
  "2955": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-132/4" },
  "2957": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-500-315/4" },
  "2958": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-500-280/4" },
  "2959": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-500-220/4" },
  "2960": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-500-200/4" },
  "4104": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-90-4" },
  "4105": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-75-4" },
  "4169": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-250/4" },
  "4170": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-315/4" },
  "4171": { intro2SeriesName: "SMA", intro2ModelKey: "350x300-400-250/4" },
  "4172": { intro2SeriesName: "SMA", intro2ModelKey: "350x300-400-315/4" },
  "4173": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-5.5/4" },
  "4184": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-45/2" },
  "4187": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "4195": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "4196": { intro2SeriesName: "TD", intro2ModelKey: "TD40-18/2" },
  "4197": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-250/25（60Hz）" },
  "4210": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-90/2" },
  "4214": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-15/4" },
  "4215": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-18.5/4" },
  "4218": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-20/2（60Hz）" },
  "4219": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-30/3（60Hz）" },
  "4220": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-40/4（60Hz）" },
  "4221": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-50/5（60Hz）" },
  "4222": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-60/6（60Hz）" },
  "4223": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-70/7（60Hz）" },
  "4224": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-80/8（60Hz）" },
  "4225": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-90/9（60Hz）" },
  "4226": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-100/10（60Hz）" },
  "4227": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-110/11（60Hz）" },
  "4228": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-120/12（60Hz）" },
  "4229": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-130/13（60Hz）" },
  "4231": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-150/15（60Hz）" },
  "4233": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-170/17（60Hz）" },
  "4235": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-190/19（60Hz）" },
  "4237": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-210/21（60Hz）" },
  "4239": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-230/23（60Hz）" },
  "4242": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-270/27" },
  "4245": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-300/30" },
  "4248": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-330/33" },
  "4251": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-360/36" },
  "4252": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-20/2（60Hz）" },
  "4253": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-30/3（60Hz）" },
  "4254": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-40/4（60Hz）" },
  "4255": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-50/5（60Hz）" },
  "4256": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-60/6（60Hz）" },
  "4257": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-70/7（60Hz）" },
  "4259": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-90/9（60Hz）" },
  "4261": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-110/11（60Hz）" },
  "4263": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-130/13（60Hz）" },
  "4265": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-150/15（60Hz）" },
  "4268": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-180/18（60Hz）" },
  "4272": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-220/22" },
  "4276": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-260/26" },
  "4277": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-20/2（60Hz）" },
  "4278": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-30/3（60Hz）" },
  "4279": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-40/4（60Hz）" },
  "4280": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-50/5（60Hz）" },
  "4281": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-60/6（60Hz）" },
  "4282": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-70/7（60Hz）" },
  "4283": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-80/8（60Hz）" },
  "4284": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-90/9（60Hz）" },
  "4285": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-100/10（60Hz）" },
  "4286": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-110/11（60Hz）" },
  "4287": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-120/12（60Hz）" },
  "4288": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-130/13（60Hz）" },
  "4290": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-150/15（60Hz）" },
  "4292": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-170/17（60Hz）" },
  "4294": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-190/19（60Hz）" },
  "4296": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-210/21（60Hz）" },
  "4297": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "4298": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-230/23（60Hz）" },
  "4300": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-250/25（60Hz）" },
  "4302": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-270/27" },
  "4304": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-290/29" },
  "4306": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-310/31" },
  "4308": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-330/33" },
  "4311": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-360/36" },
  "4312": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-20/2（60Hz）" },
  "4313": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-30/3（60Hz）" },
  "4314": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-40/4（60Hz）" },
  "4315": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-50/5（60Hz）" },
  "4316": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-60/6（60Hz）" },
  "4317": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-70/7（60Hz）" },
  "4318": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-80/8（60Hz）" },
  "4320": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-100/10（60Hz）" },
  "4322": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-120/12（60Hz）" },
  "4324": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-140/14（60Hz）" },
  "4326": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-160/16（60Hz）" },
  "4329": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-190/19" },
  "4332": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "4333": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-20/2（60Hz）" },
  "4334": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-30/3（60Hz）" },
  "4335": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-40/4（60Hz）" },
  "4336": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-50/5（60Hz）" },
  "4337": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-60/6（60Hz）" },
  "4339": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-80/8（60Hz）" },
  "4341": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-100/10（60Hz）" },
  "4343": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-120/12（60Hz）" },
  "4345": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-140/14（60Hz）" },
  "4347": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-160/16" },
  "4349": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-180/18" },
  "4351": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-200/20" },
  "4352": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-20/2（60Hz）" },
  "4353": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-30/3（60Hz）" },
  "4354": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-40/4（60Hz）" },
  "4355": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-50/5（60Hz）" },
  "4356": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-60/6（60Hz）" },
  "4357": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-70/7（60Hz）" },
  "4358": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-80/8（60Hz）" },
  "4360": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-100/10（60Hz）" },
  "4362": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-120/12" },
  "4364": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-140/14" },
  "4366": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-160/16" },
  "4367": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-20/2（60Hz）" },
  "4368": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-30/3（60Hz）" },
  "4369": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-40/4（60Hz）" },
  "4370": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-50/5（60Hz）" },
  "4371": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-60/6（60Hz）" },
  "4372": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-70/7（60Hz）" },
  "4373": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-80/8（60Hz）" },
  "4375": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-100/10（60Hz）" },
  "4377": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-120/12" },
  "4379": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-140/14" },
  "4382": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-170/17" },
  "4384": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-10/1（60Hz）" },
  "4385": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "4386": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2（60Hz）" },
  "4387": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-30/3（60Hz）" },
  "4388": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-40/4（60Hz）" },
  "4389": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-50/5（60Hz）" },
  "4390": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-60/6（60Hz）" },
  "4391": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-70/7（60Hz）" },
  "4392": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-80/8（60Hz）" },
  "4393": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-90/9（60Hz）" },
  "4399": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1-1" },
  "4400": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1（60Hz）" },
  "4401": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "4402": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2（60Hz）" },
  "4403": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3-2" },
  "4404": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "4405": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4-2" },
  "4407": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5-2" },
  "4408": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5（60Hz）" },
  "4409": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6-2" },
  "4410": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6（60Hz）" },
  "4411": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7-2" },
  "4412": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7（60Hz）" },
  "4413": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8-2" },
  "4414": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8" },
  "4415": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9-2" },
  "4416": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9" },
  "4417": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10-2" },
  "4418": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10" },
  "4419": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-110/11-2" },
  "4420": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK 42-110/11" },
  "4421": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12-2" },
  "4422": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12" },
  "4423": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-130/13-2" },
  "4630": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "4631": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4（60Hz）" },
  "5655": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-160/2" },
  "5657": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "5658": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "5723": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-70-2" },
  "5743": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-A" },
  "5750": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-1.1/4" },
  "5781": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-2.2/4" },
  "5788": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-4/4" },
  "5796": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-160/2" },
  "5810": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-250-55/4" },
  "5821": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-4/2" },
  "5860": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60-2" },
  "5904": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-1.1-2" },
  "5905": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-1.5-2" },
  "5906": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-2.2-2" },
  "5908": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-2.2-2" },
  "5909": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-3-2" },
  "5910": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-4-2" },
  "5911": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-5.5-2" },
  "5912": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-5.5-2" },
  "5913": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-7.5-2" },
  "5914": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-11-2" },
  "5915": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-11-2" },
  "5916": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-15-2" },
  "5917": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-18.5-2" },
  "5918": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-1.5-2" },
  "5919": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-2.2-2" },
  "5920": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-3-2" },
  "5921": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-4-2" },
  "5922": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-3-2" },
  "5923": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-4-2" },
  "5924": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-5.5-2" },
  "5925": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-7.5-2" },
  "5926": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-5.5-2" },
  "5927": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-7.5-2" },
  "5928": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-11-2" },
  "5929": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-15-2" },
  "5930": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-18.5-2" },
  "5931": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-22-2" },
  "5932": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-22-2" },
  "5933": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-15-2" },
  "5934": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-30-2" },
  "5935": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-18.5-2" },
  "5936": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-37-2" },
  "5937": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-45-2" },
  "5938": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-22-2" },
  "5939": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-30-2" },
  "5941": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-3-2" },
  "5942": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-4-2" },
  "5943": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-37-2" },
  "5944": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-5.5-2" },
  "5945": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-7.5-2" },
  "5946": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-45-2" },
  "5947": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-55-2" },
  "5948": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-75-2" },
  "5951": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-7.5-2" },
  "5952": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-11-2" },
  "5958": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-11-2" },
  "5959": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-15-2" },
  "5961": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-18.5-2" },
  "5963": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-22-2" },
  "5965": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-30-2" },
  "5967": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-55-2" },
  "5973": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-75-2" },
  "5976": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-4-2" },
  "5978": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-7.5-2" },
  "5980": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-15-2" },
  "5981": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-18.5-2" },
  "5983": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-11-2" },
  "5984": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-15-2" },
  "5985": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-22-2" },
  "5986": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-18.5-2" },
  "5992": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200H-30-2" },
  "5993": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-30-2" },
  "5994": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-37-2" },
  "5996": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-37-2" },
  "5997": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-45-2" },
  "5998": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-45-2" },
  "5999": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-55-2" },
  "6000": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-45-2" },
  "6001": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-55-2" },
  "6002": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-75-2" },
  "6006": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320H-90-2" },
  "6007": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-75-2" },
  "6008": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-90-2" },
  "6009": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-0.55-4" },
  "6010": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-0.55-4" },
  "6011": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-0.75-4" },
  "6012": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-1.1-4" },
  "6013": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-2.2-4" },
  "6014": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-0.55-4" },
  "6015": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.55-4" },
  "6016": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.75-4" },
  "6017": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-1.1-4" },
  "6018": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-0.75-4" },
  "6019": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-75-4" },
  "6020": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-11-4" },
  "6021": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.1-4" },
  "6022": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-15-4" },
  "6023": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-18.5-4" },
  "6024": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-18.5-4" },
  "6025": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.5-4" },
  "6026": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-22-4" },
  "6027": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-30-4" },
  "6028": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-30-4" },
  "6029": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-37-4" },
  "6030": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-45-4" },
  "6031": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-3-4" },
  "6032": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-2.2-4" },
  "6033": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-2.2-4" },
  "6034": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.1-4" },
  "6035": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-3-4" },
  "6036": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.5-4" },
  "6037": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-1.5-4" },
  "6038": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-2.2-4" },
  "6039": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-4-4" },
  "6040": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-3-4" },
  "6041": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-3-4" },
  "6042": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-4-4" },
  "6043": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-4-4" },
  "6044": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-5.5-4" },
  "6045": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-5.5-4" },
  "6046": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-7.5-4" },
  "6047": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-7.5-4" },
  "6048": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-7.5-4" },
  "6049": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-11-4" },
  "6050": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-15-4" },
  "6051": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-1.5-4" },
  "6052": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-2.2-4" },
  "6053": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-3-4" },
  "6054": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-3-4" },
  "6055": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-55-4" },
  "6056": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-45-4" },
  "6057": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-55-4" },
  "6058": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-75-4" },
  "6059": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-90-4" },
  "6060": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-22-4" },
  "6061": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-30-4" },
  "6062": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-37-4" },
  "6063": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-45-4" },
  "6064": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-55-4" },
  "6065": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-75-4" },
  "6066": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-55-4" },
  "6067": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-75-4" },
  "6068": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-90-4" },
  "6069": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-110-4" },
  "6070": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-55-4" },
  "6071": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-75-4" },
  "6072": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-90-4" },
  "6073": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-110-4" },
  "6074": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-132-4" },
  "6075": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-4-4" },
  "6076": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-5.5-4" },
  "6077": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-7.5-4" },
  "6078": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-11-4" },
  "6079": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-11-4" },
  "6080": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-15-4" },
  "6081": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-18.5-4" },
  "6082": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-22-4" },
  "6083": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-30-4" },
  "6084": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-2.2-4" },
  "6085": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-3-4" },
  "6086": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-5.5-4" },
  "6087": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-7.5-4" },
  "6088": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-11-4" },
  "6089": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-15-4" },
  "6090": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-15-4" },
  "6091": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-18.5-4" },
  "6092": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-22-4" },
  "6093": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-30-4" },
  "6094": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-22-4" },
  "6095": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-30-4" },
  "6096": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-37-4" },
  "6097": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-7.5-4" },
  "6098": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-11-4" },
  "6099": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-15-4" },
  "6100": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-18.5-4" },
  "6101": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.55-4" },
  "6102": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-22-4" },
  "6103": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.75-4" },
  "6104": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-30-4" },
  "6105": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-18.5-4" },
  "6106": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-1.1-4" },
  "6107": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-22-4" },
  "6108": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-30-4" },
  "6109": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-37-4" },
  "6110": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-0.75-4" },
  "6111": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-45-4" },
  "6112": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.1-4" },
  "6113": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.5-4" },
  "6114": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-55-4" },
  "6115": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.1-4" },
  "6116": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.5-4" },
  "6117": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-2.2-4" },
  "6118": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-3-4" },
  "6119": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-4-4" },
  "6120": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-5.5-4" },
  "6121": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-5.5-4" },
  "6122": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-7.5-4" },
  "6123": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-11-4" },
  "6124": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-0.75-4" },
  "6125": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-1.1-4" },
  "6645": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-2(60hz)" },
  "6646": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-3(60hz)" },
  "6647": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-4(60hz)" },
  "6648": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-5(60hz)" },
  "6649": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-6(60hz)" },
  "6650": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-7(60hz)" },
  "6651": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-8(60hz)" },
  "6652": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-9(60hz)" },
  "6653": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-10(60hz)" },
  "6654": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-11(60hz)" },
  "6655": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-12(60hz)" },
  "6656": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-13(60hz)" },
  "6658": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-15(60hz)" },
  "6660": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-17(60hz)" },
  "6662": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-19(60hz)" },
  "6663": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-20" },
  "6664": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-21(60hz)" },
  "6665": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-2(60hz)" },
  "6666": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-23(60hz)" },
  "6667": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-4(60hz)" },
  "6668": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-25(60hz)" },
  "6669": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-6(60hz)" },
  "6670": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-7(60hz)" },
  "6671": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-8(60hz)" },
  "6673": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-30" },
  "6680": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-2(60hz)" },
  "6681": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-3(60hz)" },
  "6682": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-4(60hz)" },
  "6683": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-5(60hz)" },
  "6684": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "6685": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-7(60hz)" },
  "6687": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-9(60hz)" },
  "6689": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-11(60hz)" },
  "6691": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-13(60hz)" },
  "6693": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-15(60hz)" },
  "6696": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-18(60hz)" },
  "6698": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-20" },
  "6705": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-2(60hz)" },
  "6706": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-3(60hz)" },
  "6707": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-4(60hz)" },
  "6708": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-5(60hz)" },
  "6709": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-6(60hz)" },
  "6710": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-7(60hz)" },
  "6711": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-8(60hz)" },
  "6712": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-9(60hz)" },
  "6713": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-10(60hz)" },
  "6714": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-11(60hz)" },
  "6715": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-12(60hz)" },
  "6716": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-13(60hz)" },
  "6718": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-15(60hz)" },
  "6720": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-17(60hz)" },
  "6722": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-19(60hz)" },
  "6723": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-20" },
  "6724": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-21(60hz)" },
  "6726": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-23(60hz)" },
  "6728": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-25(60hz)" },
  "6733": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-30" },
  "6740": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-2(60hz)" },
  "6741": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-3(60hz)" },
  "6742": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-4(60hz)" },
  "6743": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-5(60hz)" },
  "6744": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-6(60hz)" },
  "6745": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-7(60hz)" },
  "6746": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-8(60hz)" },
  "6748": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-10(60hz)" },
  "6750": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-12(60hz)" },
  "6752": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-14(60hz)" },
  "6754": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-16(60hz)" },
  "6758": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-20" },
  "6761": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-2/1(60hz)" },
  "6762": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-2(60hz)" },
  "6763": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-3(60hz)" },
  "6764": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-4(60hz)" },
  "6765": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-5(60hz)" },
  "6766": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-6(60hz)" },
  "6768": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-8(60hz)" },
  "6770": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-10(60hz)" },
  "6772": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-12(60hz)" },
  "6774": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-14(60hz)" },
  "6780": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-20" },
  "6781": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-1(60hz)" },
  "6782": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-2(60hz)" },
  "6783": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-3(60hz)" },
  "6784": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-4(60hz)" },
  "6785": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-5(60hz)" },
  "6786": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-6(60hz)" },
  "6787": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-7(60hz)" },
  "6788": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-8(60hz)" },
  "6789": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-9(60hz)" },
  "6790": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-10" },
  "6792": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-12(60hz)" },
  "6794": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-14(60hz)" },
  "6796": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-16(60hz)" },
  "6797": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-17(60hz)" },
  "6800": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-20" },
  "6803": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-2(60hz)" },
  "6804": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-23(60hz)" },
  "6805": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-4(60hz)" },
  "6806": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-25(60hz)" },
  "6807": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-6(60hz)" },
  "6808": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-7(60hz)" },
  "6809": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-8(60hz)" },
  "6811": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-210" },
  "6813": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-12(60hz)" },
  "6815": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-14(60hz)" },
  "6820": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-1(60hz)" },
  "6821": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-2(60hz)" },
  "6822": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-3(60hz)" },
  "6823": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-4(60hz)" },
  "6824": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-5(60hz)" },
  "6825": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-6(60hz)" },
  "6826": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-7(60hz)" },
  "6827": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-8(60hz)" },
  "6828": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-9(60hz)" },
  "6829": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-10(60hz)" },
  "6831": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-12(60hz)" },
  "6837": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-2/1(60hz)" },
  "6838": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-2(60hz)" },
  "6839": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-3(60hz)" },
  "6840": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-4(60hz)" },
  "6841": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-5(60hz)" },
  "6842": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-6(60hz)" },
  "6843": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-7(60hz)" },
  "6844": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-8(60hz)" },
  "6846": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-10(60hz)" },
  "6853": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-1(60hz)" },
  "6854": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-2(60hz)" },
  "6855": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-3(60hz)" },
  "6856": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-4(60hz)" },
  "6857": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-5(60hz)" },
  "6858": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-6(60hz)" },
  "6859": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-7(60hz)" },
  "6860": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-8(60hz)" },
  "6862": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-10" },
  "6870": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-10-1" },
  "6871": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-210" },
  "6872": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20-2" },
  "6873": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20" },
  "6874": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-230" },
  "6875": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-40" },
  "6876": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-250" },
  "6877": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60" },
  "6878": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-270" },
  "6879": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-80" },
  "6880": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-290" },
  "6881": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-100" },
  "6882": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-110" },
  "6883": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-120" },
  "6884": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-130" },
  "6885": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-140" },
  "6886": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150-2" },
  "6887": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150" },
  "6888": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160-2" },
  "6889": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160" },
  "6890": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10-1(60hz)" },
  "6891": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10(60hz)" },
  "6892": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-20-2(60hz)" },
  "6893": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-220" },
  "6894": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30-2(60hz)" },
  "6895": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30(60hz)" },
  "6896": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40-2(60hz)" },
  "6897": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40(60hz)" },
  "6898": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50-2(60hz)" },
  "6899": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50(60hz)" },
  "6900": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60-2(60hz)" },
  "6901": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60(60hz)" },
  "6902": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70-2(60hz)" },
  "6903": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70(60hz)" },
  "6915": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-10-1(60hz)" },
  "6916": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-10(60hz)" },
  "6917": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-20-2(60hz)" },
  "6919": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-20(60hz)" },
  "6920": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-30-2(60hz)" },
  "6922": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-30(60hz)" },
  "6923": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-40-2(60hz)" },
  "6925": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-40(60hz)" },
  "6926": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-50-2(60hz)" },
  "6949": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-10" },
  "6950": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-2" },
  "6951": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-1" },
  "6952": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20" },
  "6953": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-2" },
  "6954": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-1" },
  "6955": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30" },
  "6956": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-2" },
  "6957": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-1" },
  "6958": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40" },
  "6959": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-2" },
  "6960": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-1" },
  "6961": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50" },
  "6962": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-2" },
  "6963": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-1" },
  "6964": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60" },
  "6965": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-2" },
  "6966": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-1" },
  "6967": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70" },
  "6968": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10-1" },
  "6969": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10" },
  "6970": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-2" },
  "6971": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-1" },
  "6972": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20" },
  "6973": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-2" },
  "6974": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-1" },
  "6975": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30" },
  "6976": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-2" },
  "6977": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-1" },
  "6978": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40" },
  "6979": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-2" },
  "6980": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-1" },
  "6981": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50" },
  "6982": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-2" },
  "6983": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-1" },
  "6984": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60" },
  "6985": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-B" },
  "6986": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-A" },
  "6987": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10" },
  "6988": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2B" },
  "6989": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2A" },
  "6990": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20" },
  "6991": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2B" },
  "6992": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A-B" },
  "6993": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2A" },
  "6994": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-B" },
  "6995": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A" },
  "6996": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30" },
  "6997": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2B" },
  "6998": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2A" },
  "6999": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-A" },
  "7000": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40" },
  "7005": { intro2SeriesName: "TD", intro2ModelKey: "TD32-18/2" },
  "7006": { intro2SeriesName: "TD", intro2ModelKey: "TD32-21/2" },
  "7007": { intro2SeriesName: "TD", intro2ModelKey: "TD32-25/2" },
  "7008": { intro2SeriesName: "TD", intro2ModelKey: "TD32-32/2" },
  "7009": { intro2SeriesName: "TD", intro2ModelKey: "TD32-38/2" },
  "7010": { intro2SeriesName: "TD", intro2ModelKey: "TD32-50/2" },
  "7011": { intro2SeriesName: "TD", intro2ModelKey: "TD40-16/2" },
  "7012": { intro2SeriesName: "TD", intro2ModelKey: "TD40-20/2" },
  "7013": { intro2SeriesName: "TD", intro2ModelKey: "TD40-18/2" },
  "7014": { intro2SeriesName: "TD", intro2ModelKey: "TD40-25/2" },
  "7015": { intro2SeriesName: "TD", intro2ModelKey: "TD40-30/2" },
  "7016": { intro2SeriesName: "TD", intro2ModelKey: "TD40-36/2" },
  "7017": { intro2SeriesName: "TD", intro2ModelKey: "TD40-48/2" },
  "7018": { intro2SeriesName: "TD", intro2ModelKey: "TD50-12/2" },
  "7019": { intro2SeriesName: "TD", intro2ModelKey: "TD50-15/2" },
  "7020": { intro2SeriesName: "TD", intro2ModelKey: "TD50-18/2" },
  "7021": { intro2SeriesName: "TD", intro2ModelKey: "TD50-24/2" },
  "7022": { intro2SeriesName: "TD", intro2ModelKey: "TD50-28/2" },
  "7023": { intro2SeriesName: "TD", intro2ModelKey: "TD50-32/2" },
  "7024": { intro2SeriesName: "TD", intro2ModelKey: "TD50-38/2" },
  "7025": { intro2SeriesName: "TD", intro2ModelKey: "TD50-48/2" },
  "7028": { intro2SeriesName: "TD", intro2ModelKey: "TD50-35/2" },
  "7029": { intro2SeriesName: "TD", intro2ModelKey: "TD50-40/2" },
  "7030": { intro2SeriesName: "TD", intro2ModelKey: "TD50-50/2" },
  "7031": { intro2SeriesName: "TD", intro2ModelKey: "TD50-60/2" },
  "7032": { intro2SeriesName: "TD", intro2ModelKey: "TD50-70/2" },
  "7033": { intro2SeriesName: "TD", intro2ModelKey: "TD50-81/2" },
  "7034": { intro2SeriesName: "TD", intro2ModelKey: "TD65-15/2" },
  "7035": { intro2SeriesName: "TD", intro2ModelKey: "TD65-19/2" },
  "7036": { intro2SeriesName: "TD", intro2ModelKey: "TD65-22/2" },
  "7037": { intro2SeriesName: "TD", intro2ModelKey: "TD65-30/2" },
  "7038": { intro2SeriesName: "TD", intro2ModelKey: "TD65-36/2" },
  "7039": { intro2SeriesName: "TD", intro2ModelKey: "TD65-34/2" },
  "7040": { intro2SeriesName: "TD", intro2ModelKey: "TD65-40/2" },
  "7041": { intro2SeriesName: "TD", intro2ModelKey: "TD65-48/2" },
  "7042": { intro2SeriesName: "TD", intro2ModelKey: "TD65-50/2" },
  "7043": { intro2SeriesName: "TD", intro2ModelKey: "TD65-61/2" },
  "7044": { intro2SeriesName: "TD", intro2ModelKey: "TD65-67/2" },
  "7045": { intro2SeriesName: "TD", intro2ModelKey: "TD65-83/2" },
  "7046": { intro2SeriesName: "TD", intro2ModelKey: "TD80-13/2" },
  "7047": { intro2SeriesName: "TD", intro2ModelKey: "TD80-18/2" },
  "7048": { intro2SeriesName: "TD", intro2ModelKey: "TD80-22/2" },
  "7049": { intro2SeriesName: "TD", intro2ModelKey: "TD80-28/2" },
  "7050": { intro2SeriesName: "TD", intro2ModelKey: "TD80-30/2" },
  "7051": { intro2SeriesName: "TD", intro2ModelKey: "TD80-38/2" },
  "7052": { intro2SeriesName: "TD", intro2ModelKey: "TD80-40/2" },
  "7053": { intro2SeriesName: "TD", intro2ModelKey: "TD80-48/2" },
  "7054": { intro2SeriesName: "TD", intro2ModelKey: "TD80-47/2" },
  "7055": { intro2SeriesName: "TD", intro2ModelKey: "TD80-54/2" },
  "7056": { intro2SeriesName: "TD", intro2ModelKey: "TD80-67/2" },
  "7057": { intro2SeriesName: "TD", intro2ModelKey: "TD100-9/2" },
  "7058": { intro2SeriesName: "TD", intro2ModelKey: "TD100-15/2" },
  "7059": { intro2SeriesName: "TD", intro2ModelKey: "TD100-17/2" },
  "7060": { intro2SeriesName: "TD", intro2ModelKey: "TD100-22/2" },
  "7061": { intro2SeriesName: "TD", intro2ModelKey: "TD100-27/2" },
  "7062": { intro2SeriesName: "TD", intro2ModelKey: "TD100-33/2" },
  "7063": { intro2SeriesName: "TD", intro2ModelKey: "TD100-40/2" },
  "7064": { intro2SeriesName: "TD", intro2ModelKey: "TD100-48/2" },
  "7065": { intro2SeriesName: "TD", intro2ModelKey: "TD100-52/2" },
  "7066": { intro2SeriesName: "TD", intro2ModelKey: "TD125-11/4" },
  "7067": { intro2SeriesName: "TD", intro2ModelKey: "TD125-14/4" },
  "7068": { intro2SeriesName: "TD", intro2ModelKey: "TD125-18/4" },
  "7069": { intro2SeriesName: "TD", intro2ModelKey: "TD125-22/4" },
  "7070": { intro2SeriesName: "TD", intro2ModelKey: "TD125-28/4" },
  "7071": { intro2SeriesName: "TD", intro2ModelKey: "TD125-32/4" },
  "7072": { intro2SeriesName: "TD", intro2ModelKey: "TD125-40/4" },
  "7073": { intro2SeriesName: "TD", intro2ModelKey: "TD125-48/4" },
  "7074": { intro2SeriesName: "TD", intro2ModelKey: "TD150-12.5/4" },
  "7075": { intro2SeriesName: "TD", intro2ModelKey: "TD150-17/4" },
  "7076": { intro2SeriesName: "TD", intro2ModelKey: "TD150-21/4" },
  "7077": { intro2SeriesName: "TD", intro2ModelKey: "TD150-25/4" },
  "7078": { intro2SeriesName: "TD", intro2ModelKey: "TD150-33/4" },
  "7079": { intro2SeriesName: "TD", intro2ModelKey: "TD150-40/4" },
  "7080": { intro2SeriesName: "TD", intro2ModelKey: "TD150-50/4" },
  "7083": { intro2SeriesName: "TD", intro2ModelKey: "TD200-24/4" },
  "7087": { intro2SeriesName: "TD", intro2ModelKey: "TD200-53/4" },
  "7088": { intro2SeriesName: "TD", intro2ModelKey: "TD200-12.5/4" },
  "7089": { intro2SeriesName: "TD", intro2ModelKey: "TD200-20/4" },
  "7090": { intro2SeriesName: "TD", intro2ModelKey: "TD200-23/4" },
  "7091": { intro2SeriesName: "TD", intro2ModelKey: "TD200-27/4" },
  "7092": { intro2SeriesName: "TD", intro2ModelKey: "TD200-32/4" },
  "7093": { intro2SeriesName: "TD", intro2ModelKey: "TD200-43/4" },
  "7094": { intro2SeriesName: "TD", intro2ModelKey: "TD200-50/4" },
  "7099": { intro2SeriesName: "TD", intro2ModelKey: "TD250-36/4" },
  "7102": { intro2SeriesName: "TD", intro2ModelKey: "TD250-12.5/4" },
  "7103": { intro2SeriesName: "TD", intro2ModelKey: "TD250-14/4" },
  "7104": { intro2SeriesName: "TD", intro2ModelKey: "TD250-17/4" },
  "7105": { intro2SeriesName: "TD", intro2ModelKey: "TD250-20/4" },
  "7106": { intro2SeriesName: "TD", intro2ModelKey: "TD250-26/4" },
  "7107": { intro2SeriesName: "TD", intro2ModelKey: "TD250-32/4" },
  "7108": { intro2SeriesName: "TD", intro2ModelKey: "TD250-40/4" },
  "7109": { intro2SeriesName: "TD", intro2ModelKey: "TD250-50/4" },
  "7110": { intro2SeriesName: "TD", intro2ModelKey: "TD300-15/4" },
  "7111": { intro2SeriesName: "TD", intro2ModelKey: "TD300-20/4" },
  "7112": { intro2SeriesName: "TD", intro2ModelKey: "TD300-25/4" },
  "7113": { intro2SeriesName: "TD", intro2ModelKey: "TD300-30/4" },
  "7114": { intro2SeriesName: "TD", intro2ModelKey: "TD300-35/4" },
  "7115": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "7116": { intro2SeriesName: "TD", intro2ModelKey: "TD300-55/4" },
  "8376": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x3" },
  "8377": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x4" },
  "8378": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x5" },
  "8379": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x6" },
  "8380": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x7" },
  "8381": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x8" },
  "8382": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x9" },
  "8383": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x10" },
  "8384": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x11" },
  "8385": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x12" },
  "8386": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x3" },
  "8387": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x4" },
  "8388": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x5" },
  "8389": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x6" },
  "8390": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x7" },
  "8391": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x8" },
  "8392": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x9" },
  "8393": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x10" },
  "8394": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x11" },
  "8395": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x12" },
  "8396": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x2" },
  "8397": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x3" },
  "8398": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x4" },
  "8399": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x5" },
  "8400": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x6" },
  "8401": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x7" },
  "8402": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x8" },
  "8403": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x9" },
  "8404": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x10" },
  "8405": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x11" },
  "8406": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x12" },
  "8407": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x3" },
  "8408": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x4" },
  "8409": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x5" },
  "8410": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x6" },
  "8411": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x7" },
  "8412": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x8" },
  "8413": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x9" },
  "8414": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x10" },
  "8415": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x3" },
  "8416": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x4" },
  "8417": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x5" },
  "8418": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x6" },
  "8419": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x7" },
  "8420": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x8" },
  "8421": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x9" },
  "8422": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x10" },
  "8423": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x11" },
  "8424": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x12" },
  "8425": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x3" },
  "8426": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x4" },
  "8427": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x5" },
  "8428": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x6" },
  "8429": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x7" },
  "8430": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x8" },
  "8431": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x9" },
  "8432": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x10" },
  "8433": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x11" },
  "8434": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x12" },
  "8435": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x3" },
  "8436": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x4" },
  "8437": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x5" },
  "8438": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x6" },
  "8439": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x7" },
  "8440": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x8" },
  "8441": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x9" },
  "8442": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x10" },
  "8443": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x3" },
  "8444": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x4" },
  "8445": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x5" },
  "8446": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x6" },
  "8447": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x7" },
  "8448": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x8" },
  "8449": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x9" },
  "8450": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x3" },
  "8451": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x4" },
  "8452": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x5" },
  "8453": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x6" },
  "8454": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x7" },
  "8455": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x8" },
  "8456": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x9" },
  "8457": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x2" },
  "8458": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x3" },
  "8459": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x4" },
  "8460": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x5" },
  "8461": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x6" },
  "8462": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x7" },
  "8463": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x8" },
  "8464": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x9" },
  "8466": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x2" },
  "8467": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x3" },
  "8468": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x4" },
  "8469": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x5" },
  "8470": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x6" },
  "8471": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x7" },
  "8472": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x8" },
  "8473": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x9" },
  "8474": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x10" },
  "8475": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x2" },
  "8476": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x3" },
  "8477": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x4" },
  "8478": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x5" },
  "8479": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x6" },
  "8480": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x7" },
  "8481": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x8" },
  "8482": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x9" },
  "8483": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x3" },
  "8484": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x4" },
  "8485": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x5" },
  "8486": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x6" },
  "8487": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x7" },
  "8488": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x8" },
  "8489": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x9" },
  "8490": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x2" },
  "8491": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x3" },
  "8492": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x4" },
  "8493": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x5" },
  "8494": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x6" },
  "8495": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x7" },
  "8496": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x8" },
  "8497": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x9" },
  "8498": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x10" },
  "8499": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x2" },
  "8500": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x3" },
  "8501": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x4" },
  "8502": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x5" },
  "8503": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x6" },
  "8504": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x7" },
  "8505": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x8" },
  "8506": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x9" },
  "8507": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x10" },
  "8518": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x3" },
  "8519": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x4" },
  "8520": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x5" },
  "8521": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x6" },
  "8522": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x7" },
  "8523": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x2" },
  "8524": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x3" },
  "8525": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x4" },
  "8526": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x5" },
  "8527": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x6" },
  "8528": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x7" },
  "8529": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x8" },
  "9964": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-90-4" },
  "9965": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-75-4" },
  "10047": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "10055": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "10056": { intro2SeriesName: "TD", intro2ModelKey: "TD40-18/2" },
  "10057": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-250/25（60Hz）" },
  "10078": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-20/2（60Hz）" },
  "10079": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-30/3（60Hz）" },
  "10080": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-40/4（60Hz）" },
  "10081": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-50/5（60Hz）" },
  "10082": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-60/6（60Hz）" },
  "10083": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-70/7（60Hz）" },
  "10084": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-80/8（60Hz）" },
  "10085": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-90/9（60Hz）" },
  "10086": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-100/10（60Hz）" },
  "10087": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-110/11（60Hz）" },
  "10088": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-120/12（60Hz）" },
  "10089": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-130/13（60Hz）" },
  "10091": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-150/15（60Hz）" },
  "10093": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-170/17（60Hz）" },
  "10095": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-190/19（60Hz）" },
  "10097": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-210/21（60Hz）" },
  "10099": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-230/23（60Hz）" },
  "10102": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-270/27" },
  "10105": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-300/30" },
  "10108": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-330/33" },
  "10111": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-360/36" },
  "10112": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-20/2（60Hz）" },
  "10113": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-30/3（60Hz）" },
  "10114": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-40/4（60Hz）" },
  "10115": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-50/5（60Hz）" },
  "10116": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-60/6（60Hz）" },
  "10117": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-70/7（60Hz）" },
  "10119": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-90/9（60Hz）" },
  "10121": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-110/11（60Hz）" },
  "10123": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-130/13（60Hz）" },
  "10125": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-150/15（60Hz）" },
  "10128": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-180/18（60Hz）" },
  "10132": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-220/22" },
  "10136": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-260/26" },
  "10137": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-20/2（60Hz）" },
  "10138": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-30/3（60Hz）" },
  "10139": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-40/4（60Hz）" },
  "10140": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-50/5（60Hz）" },
  "10141": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-60/6（60Hz）" },
  "10142": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-70/7（60Hz）" },
  "10143": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-80/8（60Hz）" },
  "10144": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-90/9（60Hz）" },
  "10145": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-100/10（60Hz）" },
  "10146": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-110/11（60Hz）" },
  "10147": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-120/12（60Hz）" },
  "10148": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-130/13（60Hz）" },
  "10150": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-150/15（60Hz）" },
  "10152": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-170/17（60Hz）" },
  "10154": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-190/19（60Hz）" },
  "10156": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-210/21（60Hz）" },
  "10157": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "10158": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-230/23（60Hz）" },
  "10160": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-250/25（60Hz）" },
  "10162": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-270/27" },
  "10164": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-290/29" },
  "10166": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-310/31" },
  "10168": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-330/33" },
  "10171": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-360/36" },
  "10172": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-20/2（60Hz）" },
  "10173": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-30/3（60Hz）" },
  "10174": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-40/4（60Hz）" },
  "10175": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-50/5（60Hz）" },
  "10176": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-60/6（60Hz）" },
  "10177": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-70/7（60Hz）" },
  "10178": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-80/8（60Hz）" },
  "10180": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-100/10（60Hz）" },
  "10182": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-120/12（60Hz）" },
  "10184": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-140/14（60Hz）" },
  "10186": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-160/16（60Hz）" },
  "10189": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-190/19" },
  "10192": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "10193": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-20/2（60Hz）" },
  "10194": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-30/3（60Hz）" },
  "10195": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-40/4（60Hz）" },
  "10196": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-50/5（60Hz）" },
  "10197": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-60/6（60Hz）" },
  "10199": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-80/8（60Hz）" },
  "10201": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-100/10（60Hz）" },
  "10203": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-120/12（60Hz）" },
  "10205": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-140/14（60Hz）" },
  "10207": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-160/16" },
  "10209": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-180/18" },
  "10211": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-200/20" },
  "10212": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-20/2（60Hz）" },
  "10213": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-30/3（60Hz）" },
  "10214": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-40/4（60Hz）" },
  "10215": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-50/5（60Hz）" },
  "10216": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-60/6（60Hz）" },
  "10217": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-70/7（60Hz）" },
  "10218": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-80/8（60Hz）" },
  "10220": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-100/10（60Hz）" },
  "10222": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-120/12" },
  "10224": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-140/14" },
  "10226": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-160/16" },
  "10227": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-20/2（60Hz）" },
  "10228": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-30/3（60Hz）" },
  "10229": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-40/4（60Hz）" },
  "10230": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-50/5（60Hz）" },
  "10231": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-60/6（60Hz）" },
  "10232": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-70/7（60Hz）" },
  "10233": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-80/8（60Hz）" },
  "10235": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-100/10（60Hz）" },
  "10237": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-120/12" },
  "10239": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-140/14" },
  "10242": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-170/17" },
  "10244": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-10/1（60Hz）" },
  "10245": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "10246": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2（60Hz）" },
  "10247": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-30/3（60Hz）" },
  "10248": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-40/4（60Hz）" },
  "10249": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-50/5（60Hz）" },
  "10250": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-60/6（60Hz）" },
  "10251": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-70/7（60Hz）" },
  "10252": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-80/8（60Hz）" },
  "10253": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-90/9（60Hz）" },
  "10259": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1-1" },
  "10260": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1（60Hz）" },
  "10261": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "10262": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2（60Hz）" },
  "10263": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3-2" },
  "10264": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "10265": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4-2" },
  "10267": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5-2" },
  "10268": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5（60Hz）" },
  "10269": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6-2" },
  "10270": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6（60Hz）" },
  "10271": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7-2" },
  "10272": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7（60Hz）" },
  "10273": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8-2" },
  "10274": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8" },
  "10275": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9-2" },
  "10276": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9" },
  "10277": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10-2" },
  "10278": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10" },
  "10279": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-110/11-2" },
  "10280": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK 42-110/11" },
  "10281": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12-2" },
  "10282": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12" },
  "10283": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-130/13-2" },
  "10490": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "10491": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4（60Hz）" },
  "11517": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "11518": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "11583": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-70-2" },
  "11603": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-A" },
  "11720": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60-2" },
  "11764": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-1.1-2" },
  "11765": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-1.5-2" },
  "11766": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-2.2-2" },
  "11768": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-2.2-2" },
  "11769": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-3-2" },
  "11770": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-4-2" },
  "11771": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-5.5-2" },
  "11772": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-5.5-2" },
  "11773": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-7.5-2" },
  "11774": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-11-2" },
  "11775": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-11-2" },
  "11776": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-15-2" },
  "11777": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-18.5-2" },
  "11778": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-1.5-2" },
  "11779": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-2.2-2" },
  "11780": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-3-2" },
  "11781": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-4-2" },
  "11782": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-3-2" },
  "11783": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-4-2" },
  "11784": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-5.5-2" },
  "11785": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-7.5-2" },
  "11786": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-5.5-2" },
  "11787": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-7.5-2" },
  "11788": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-11-2" },
  "11789": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-15-2" },
  "11790": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-18.5-2" },
  "11791": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-22-2" },
  "11792": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-22-2" },
  "11793": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-15-2" },
  "11794": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-30-2" },
  "11795": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-18.5-2" },
  "11796": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-37-2" },
  "11797": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-45-2" },
  "11798": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-22-2" },
  "11799": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-30-2" },
  "11801": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-3-2" },
  "11802": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-4-2" },
  "11803": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-37-2" },
  "11804": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-5.5-2" },
  "11805": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-7.5-2" },
  "11806": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-45-2" },
  "11807": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-55-2" },
  "11808": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-75-2" },
  "11811": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-7.5-2" },
  "11812": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-11-2" },
  "11818": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-11-2" },
  "11819": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-15-2" },
  "11821": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-18.5-2" },
  "11823": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-22-2" },
  "11825": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-30-2" },
  "11827": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-55-2" },
  "11833": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-75-2" },
  "11836": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-4-2" },
  "11838": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-7.5-2" },
  "11840": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-15-2" },
  "11841": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-18.5-2" },
  "11843": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-11-2" },
  "11844": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-15-2" },
  "11845": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-22-2" },
  "11846": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-18.5-2" },
  "11852": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200H-30-2" },
  "11853": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-30-2" },
  "11854": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-37-2" },
  "11856": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-37-2" },
  "11857": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-45-2" },
  "11858": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-45-2" },
  "11859": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-55-2" },
  "11860": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-45-2" },
  "11861": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-55-2" },
  "11862": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-75-2" },
  "11866": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320H-90-2" },
  "11867": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-75-2" },
  "11868": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-90-2" },
  "11869": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-0.55-4" },
  "11870": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-0.55-4" },
  "11871": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-0.75-4" },
  "11872": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-1.1-4" },
  "11873": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-2.2-4" },
  "11874": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-0.55-4" },
  "11875": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.55-4" },
  "11876": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.75-4" },
  "11877": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-1.1-4" },
  "11878": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-0.75-4" },
  "11879": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-75-4" },
  "11880": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-11-4" },
  "11881": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.1-4" },
  "11882": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-15-4" },
  "11883": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-18.5-4" },
  "11884": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-18.5-4" },
  "11885": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.5-4" },
  "11886": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-22-4" },
  "11887": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-30-4" },
  "11888": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-30-4" },
  "11889": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-37-4" },
  "11890": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-45-4" },
  "11891": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-3-4" },
  "11892": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-2.2-4" },
  "11893": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-2.2-4" },
  "11894": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.1-4" },
  "11895": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-3-4" },
  "11896": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.5-4" },
  "11897": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-1.5-4" },
  "11898": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-2.2-4" },
  "11899": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-4-4" },
  "11900": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-3-4" },
  "11901": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-3-4" },
  "11902": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-4-4" },
  "11903": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-4-4" },
  "11904": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-5.5-4" },
  "11905": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-5.5-4" },
  "11906": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-7.5-4" },
  "11907": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-7.5-4" },
  "11908": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-7.5-4" },
  "11909": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-11-4" },
  "11910": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-15-4" },
  "11911": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-1.5-4" },
  "11912": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-2.2-4" },
  "11913": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-3-4" },
  "11914": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-3-4" },
  "11915": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-55-4" },
  "11916": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-45-4" },
  "11917": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-55-4" },
  "11918": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-75-4" },
  "11919": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-90-4" },
  "11920": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-22-4" },
  "11921": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-30-4" },
  "11922": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-37-4" },
  "11923": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-45-4" },
  "11924": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-55-4" },
  "11925": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-75-4" },
  "11926": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-55-4" },
  "11927": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-75-4" },
  "11928": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-90-4" },
  "11929": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-110-4" },
  "11930": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-55-4" },
  "11931": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-75-4" },
  "11932": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-90-4" },
  "11933": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-110-4" },
  "11934": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-132-4" },
  "11935": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-4-4" },
  "11936": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-5.5-4" },
  "11937": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-7.5-4" },
  "11938": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-11-4" },
  "11939": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-11-4" },
  "11940": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-15-4" },
  "11941": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-18.5-4" },
  "11942": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-22-4" },
  "11943": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-30-4" },
  "11944": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-2.2-4" },
  "11945": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-3-4" },
  "11946": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-5.5-4" },
  "11947": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-7.5-4" },
  "11948": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-11-4" },
  "11949": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-15-4" },
  "11950": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-15-4" },
  "11951": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-18.5-4" },
  "11952": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-22-4" },
  "11953": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-30-4" },
  "11954": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-22-4" },
  "11955": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-30-4" },
  "11956": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-37-4" },
  "11957": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-7.5-4" },
  "11958": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-11-4" },
  "11959": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-15-4" },
  "11960": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-18.5-4" },
  "11961": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.55-4" },
  "11962": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-22-4" },
  "11963": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.75-4" },
  "11964": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-30-4" },
  "11965": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-18.5-4" },
  "11966": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-1.1-4" },
  "11967": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-22-4" },
  "11968": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-30-4" },
  "11969": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-37-4" },
  "11970": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-0.75-4" },
  "11971": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-45-4" },
  "11972": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.1-4" },
  "11973": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.5-4" },
  "11974": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-55-4" },
  "11975": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.1-4" },
  "11976": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.5-4" },
  "11977": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-2.2-4" },
  "11978": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-3-4" },
  "11979": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-4-4" },
  "11980": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-5.5-4" },
  "11981": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-5.5-4" },
  "11982": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-7.5-4" },
  "11983": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-11-4" },
  "11984": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-0.75-4" },
  "11985": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-1.1-4" },
  "12505": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-2(60hz)" },
  "12506": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-3(60hz)" },
  "12507": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-4(60hz)" },
  "12508": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-5(60hz)" },
  "12509": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-6(60hz)" },
  "12510": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-7(60hz)" },
  "12511": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-8(60hz)" },
  "12512": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-9(60hz)" },
  "12513": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-10(60hz)" },
  "12514": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-11(60hz)" },
  "12515": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-12(60hz)" },
  "12516": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-13(60hz)" },
  "12518": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-15(60hz)" },
  "12520": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-17(60hz)" },
  "12522": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-19(60hz)" },
  "12523": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-20" },
  "12524": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-21(60hz)" },
  "12525": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-2(60hz)" },
  "12526": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-23(60hz)" },
  "12527": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-4(60hz)" },
  "12528": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-25(60hz)" },
  "12529": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-6(60hz)" },
  "12530": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-7(60hz)" },
  "12531": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-8(60hz)" },
  "12533": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-30" },
  "12540": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-2(60hz)" },
  "12541": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-3(60hz)" },
  "12542": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-4(60hz)" },
  "12543": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-5(60hz)" },
  "12544": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "12545": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-7(60hz)" },
  "12547": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-9(60hz)" },
  "12549": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-11(60hz)" },
  "12551": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-13(60hz)" },
  "12553": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-15(60hz)" },
  "12556": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-18(60hz)" },
  "12558": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-20" },
  "12565": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-2(60hz)" },
  "12566": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-3(60hz)" },
  "12567": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-4(60hz)" },
  "12568": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-5(60hz)" },
  "12569": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-6(60hz)" },
  "12570": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-7(60hz)" },
  "12571": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-8(60hz)" },
  "12572": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-9(60hz)" },
  "12573": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-10(60hz)" },
  "12574": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-11(60hz)" },
  "12575": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-12(60hz)" },
  "12576": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-13(60hz)" },
  "12578": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-15(60hz)" },
  "12580": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-17(60hz)" },
  "12582": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-19(60hz)" },
  "12583": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-20" },
  "12584": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-21(60hz)" },
  "12586": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-23(60hz)" },
  "12588": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-25(60hz)" },
  "12593": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-30" },
  "12600": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-2(60hz)" },
  "12601": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-3(60hz)" },
  "12602": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-4(60hz)" },
  "12603": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-5(60hz)" },
  "12604": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-6(60hz)" },
  "12605": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-7(60hz)" },
  "12606": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-8(60hz)" },
  "12608": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-10(60hz)" },
  "12610": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-12(60hz)" },
  "12612": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-14(60hz)" },
  "12614": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-16(60hz)" },
  "12618": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-20" },
  "12621": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-2/1(60hz)" },
  "12622": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-2(60hz)" },
  "12623": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-3(60hz)" },
  "12624": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-4(60hz)" },
  "12625": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-5(60hz)" },
  "12626": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-6(60hz)" },
  "12628": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-8(60hz)" },
  "12630": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-10(60hz)" },
  "12632": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-12(60hz)" },
  "12634": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-14(60hz)" },
  "12640": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-20" },
  "12641": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-1(60hz)" },
  "12642": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-2(60hz)" },
  "12643": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-3(60hz)" },
  "12644": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-4(60hz)" },
  "12645": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-5(60hz)" },
  "12646": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-6(60hz)" },
  "12647": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-7(60hz)" },
  "12648": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-8(60hz)" },
  "12649": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-9(60hz)" },
  "12650": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-10" },
  "12652": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-12(60hz)" },
  "12654": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-14(60hz)" },
  "12656": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-16(60hz)" },
  "12657": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-17(60hz)" },
  "12660": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-20" },
  "12663": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-2(60hz)" },
  "12664": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-23(60hz)" },
  "12665": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-4(60hz)" },
  "12666": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-25(60hz)" },
  "12667": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-6(60hz)" },
  "12668": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-7(60hz)" },
  "12669": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-8(60hz)" },
  "12671": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-210" },
  "12673": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-12(60hz)" },
  "12675": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-14(60hz)" },
  "12680": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-1(60hz)" },
  "12681": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-2(60hz)" },
  "12682": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-3(60hz)" },
  "12683": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-4(60hz)" },
  "12684": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-5(60hz)" },
  "12685": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-6(60hz)" },
  "12686": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-7(60hz)" },
  "12687": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-8(60hz)" },
  "12688": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-9(60hz)" },
  "12689": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-10(60hz)" },
  "12691": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-12(60hz)" },
  "12697": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-2/1(60hz)" },
  "12698": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-2(60hz)" },
  "12699": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-3(60hz)" },
  "12700": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-4(60hz)" },
  "12701": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-5(60hz)" },
  "12702": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-6(60hz)" },
  "12703": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-7(60hz)" },
  "12704": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-8(60hz)" },
  "12706": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-10(60hz)" },
  "12713": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-1(60hz)" },
  "12714": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-2(60hz)" },
  "12715": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-3(60hz)" },
  "12716": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-4(60hz)" },
  "12717": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-5(60hz)" },
  "12718": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-6(60hz)" },
  "12719": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-7(60hz)" },
  "12720": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-8(60hz)" },
  "12722": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-10" },
  "12730": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-10-1" },
  "12731": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-210" },
  "12732": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20-2" },
  "12733": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20" },
  "12734": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-230" },
  "12735": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-40" },
  "12736": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-250" },
  "12737": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60" },
  "12738": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-270" },
  "12739": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-80" },
  "12740": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-290" },
  "12741": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-100" },
  "12742": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-110" },
  "12743": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-120" },
  "12744": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-130" },
  "12745": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-140" },
  "12746": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150-2" },
  "12747": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150" },
  "12748": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160-2" },
  "12749": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160" },
  "12750": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10-1(60hz)" },
  "12751": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10(60hz)" },
  "12752": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-20-2(60hz)" },
  "12753": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-220" },
  "12754": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30-2(60hz)" },
  "12755": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30(60hz)" },
  "12756": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40-2(60hz)" },
  "12757": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40(60hz)" },
  "12758": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50-2(60hz)" },
  "12759": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50(60hz)" },
  "12760": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60-2(60hz)" },
  "12761": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60(60hz)" },
  "12762": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70-2(60hz)" },
  "12763": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70(60hz)" },
  "12775": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-10-1(60hz)" },
  "12776": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-10(60hz)" },
  "12777": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-20-2(60hz)" },
  "12779": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-20(60hz)" },
  "12780": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-30-2(60hz)" },
  "12782": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-30(60hz)" },
  "12783": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-40-2(60hz)" },
  "12785": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-40(60hz)" },
  "12786": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-50-2(60hz)" },
  "12809": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-10" },
  "12810": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-2" },
  "12811": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-1" },
  "12812": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20" },
  "12813": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-2" },
  "12814": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-1" },
  "12815": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30" },
  "12816": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-2" },
  "12817": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-1" },
  "12818": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40" },
  "12819": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-2" },
  "12820": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-1" },
  "12821": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50" },
  "12822": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-2" },
  "12823": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-1" },
  "12824": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60" },
  "12825": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-2" },
  "12826": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-1" },
  "12827": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70" },
  "12828": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10-1" },
  "12829": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10" },
  "12830": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-2" },
  "12831": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-1" },
  "12832": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20" },
  "12833": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-2" },
  "12834": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-1" },
  "12835": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30" },
  "12836": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-2" },
  "12837": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-1" },
  "12838": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40" },
  "12839": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-2" },
  "12840": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-1" },
  "12841": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50" },
  "12842": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-2" },
  "12843": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-1" },
  "12844": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60" },
  "12845": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-B" },
  "12846": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-A" },
  "12847": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10" },
  "12848": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2B" },
  "12849": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2A" },
  "12850": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20" },
  "12851": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2B" },
  "12852": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A-B" },
  "12853": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2A" },
  "12854": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-B" },
  "12855": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A" },
  "12856": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30" },
  "12857": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2B" },
  "12858": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2A" },
  "12859": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-A" },
  "12860": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40" },
  "12865": { intro2SeriesName: "TD", intro2ModelKey: "TD32-18/2" },
  "12866": { intro2SeriesName: "TD", intro2ModelKey: "TD32-21/2" },
  "12867": { intro2SeriesName: "TD", intro2ModelKey: "TD32-25/2" },
  "12868": { intro2SeriesName: "TD", intro2ModelKey: "TD32-32/2" },
  "12869": { intro2SeriesName: "TD", intro2ModelKey: "TD32-38/2" },
  "12870": { intro2SeriesName: "TD", intro2ModelKey: "TD32-50/2" },
  "12871": { intro2SeriesName: "TD", intro2ModelKey: "TD40-16/2" },
  "12872": { intro2SeriesName: "TD", intro2ModelKey: "TD40-20/2" },
  "12873": { intro2SeriesName: "TD", intro2ModelKey: "TD40-18/2" },
  "12874": { intro2SeriesName: "TD", intro2ModelKey: "TD40-25/2" },
  "12875": { intro2SeriesName: "TD", intro2ModelKey: "TD40-30/2" },
  "12876": { intro2SeriesName: "TD", intro2ModelKey: "TD40-36/2" },
  "12877": { intro2SeriesName: "TD", intro2ModelKey: "TD40-48/2" },
  "12878": { intro2SeriesName: "TD", intro2ModelKey: "TD50-12/2" },
  "12879": { intro2SeriesName: "TD", intro2ModelKey: "TD50-15/2" },
  "12880": { intro2SeriesName: "TD", intro2ModelKey: "TD50-18/2" },
  "12881": { intro2SeriesName: "TD", intro2ModelKey: "TD50-24/2" },
  "12882": { intro2SeriesName: "TD", intro2ModelKey: "TD50-28/2" },
  "12883": { intro2SeriesName: "TD", intro2ModelKey: "TD50-32/2" },
  "12884": { intro2SeriesName: "TD", intro2ModelKey: "TD50-38/2" },
  "12885": { intro2SeriesName: "TD", intro2ModelKey: "TD50-48/2" },
  "12888": { intro2SeriesName: "TD", intro2ModelKey: "TD50-35/2" },
  "12889": { intro2SeriesName: "TD", intro2ModelKey: "TD50-40/2" },
  "12890": { intro2SeriesName: "TD", intro2ModelKey: "TD50-50/2" },
  "12891": { intro2SeriesName: "TD", intro2ModelKey: "TD50-60/2" },
  "12892": { intro2SeriesName: "TD", intro2ModelKey: "TD50-70/2" },
  "12893": { intro2SeriesName: "TD", intro2ModelKey: "TD50-81/2" },
  "12894": { intro2SeriesName: "TD", intro2ModelKey: "TD65-15/2" },
  "12895": { intro2SeriesName: "TD", intro2ModelKey: "TD65-19/2" },
  "12896": { intro2SeriesName: "TD", intro2ModelKey: "TD65-22/2" },
  "12897": { intro2SeriesName: "TD", intro2ModelKey: "TD65-30/2" },
  "12898": { intro2SeriesName: "TD", intro2ModelKey: "TD65-36/2" },
  "12899": { intro2SeriesName: "TD", intro2ModelKey: "TD65-34/2" },
  "12900": { intro2SeriesName: "TD", intro2ModelKey: "TD65-40/2" },
  "12901": { intro2SeriesName: "TD", intro2ModelKey: "TD65-48/2" },
  "12902": { intro2SeriesName: "TD", intro2ModelKey: "TD65-50/2" },
  "12903": { intro2SeriesName: "TD", intro2ModelKey: "TD65-61/2" },
  "12904": { intro2SeriesName: "TD", intro2ModelKey: "TD65-67/2" },
  "12905": { intro2SeriesName: "TD", intro2ModelKey: "TD65-83/2" },
  "12906": { intro2SeriesName: "TD", intro2ModelKey: "TD80-13/2" },
  "12907": { intro2SeriesName: "TD", intro2ModelKey: "TD80-18/2" },
  "12908": { intro2SeriesName: "TD", intro2ModelKey: "TD80-22/2" },
  "12909": { intro2SeriesName: "TD", intro2ModelKey: "TD80-28/2" },
  "12910": { intro2SeriesName: "TD", intro2ModelKey: "TD80-30/2" },
  "12911": { intro2SeriesName: "TD", intro2ModelKey: "TD80-38/2" },
  "12912": { intro2SeriesName: "TD", intro2ModelKey: "TD80-40/2" },
  "12913": { intro2SeriesName: "TD", intro2ModelKey: "TD80-48/2" },
  "12914": { intro2SeriesName: "TD", intro2ModelKey: "TD80-47/2" },
  "12915": { intro2SeriesName: "TD", intro2ModelKey: "TD80-54/2" },
  "12916": { intro2SeriesName: "TD", intro2ModelKey: "TD80-67/2" },
  "12917": { intro2SeriesName: "TD", intro2ModelKey: "TD100-9/2" },
  "12918": { intro2SeriesName: "TD", intro2ModelKey: "TD100-15/2" },
  "12919": { intro2SeriesName: "TD", intro2ModelKey: "TD100-17/2" },
  "12920": { intro2SeriesName: "TD", intro2ModelKey: "TD100-22/2" },
  "12921": { intro2SeriesName: "TD", intro2ModelKey: "TD100-27/2" },
  "12922": { intro2SeriesName: "TD", intro2ModelKey: "TD100-33/2" },
  "12923": { intro2SeriesName: "TD", intro2ModelKey: "TD100-40/2" },
  "12924": { intro2SeriesName: "TD", intro2ModelKey: "TD100-48/2" },
  "12925": { intro2SeriesName: "TD", intro2ModelKey: "TD100-52/2" },
  "12926": { intro2SeriesName: "TD", intro2ModelKey: "TD125-11/4" },
  "12927": { intro2SeriesName: "TD", intro2ModelKey: "TD125-14/4" },
  "12928": { intro2SeriesName: "TD", intro2ModelKey: "TD125-18/4" },
  "12929": { intro2SeriesName: "TD", intro2ModelKey: "TD125-22/4" },
  "12930": { intro2SeriesName: "TD", intro2ModelKey: "TD125-28/4" },
  "12931": { intro2SeriesName: "TD", intro2ModelKey: "TD125-32/4" },
  "12932": { intro2SeriesName: "TD", intro2ModelKey: "TD125-40/4" },
  "12933": { intro2SeriesName: "TD", intro2ModelKey: "TD125-48/4" },
  "12934": { intro2SeriesName: "TD", intro2ModelKey: "TD150-12.5/4" },
  "12935": { intro2SeriesName: "TD", intro2ModelKey: "TD150-17/4" },
  "12936": { intro2SeriesName: "TD", intro2ModelKey: "TD150-21/4" },
  "12937": { intro2SeriesName: "TD", intro2ModelKey: "TD150-25/4" },
  "12938": { intro2SeriesName: "TD", intro2ModelKey: "TD150-33/4" },
  "12939": { intro2SeriesName: "TD", intro2ModelKey: "TD150-40/4" },
  "12940": { intro2SeriesName: "TD", intro2ModelKey: "TD150-50/4" },
  "12943": { intro2SeriesName: "TD", intro2ModelKey: "TD200-24/4" },
  "12947": { intro2SeriesName: "TD", intro2ModelKey: "TD200-53/4" },
  "12948": { intro2SeriesName: "TD", intro2ModelKey: "TD200-12.5/4" },
  "12949": { intro2SeriesName: "TD", intro2ModelKey: "TD200-20/4" },
  "12950": { intro2SeriesName: "TD", intro2ModelKey: "TD200-23/4" },
  "12951": { intro2SeriesName: "TD", intro2ModelKey: "TD200-27/4" },
  "12952": { intro2SeriesName: "TD", intro2ModelKey: "TD200-32/4" },
  "12953": { intro2SeriesName: "TD", intro2ModelKey: "TD200-43/4" },
  "12954": { intro2SeriesName: "TD", intro2ModelKey: "TD200-50/4" },
  "12959": { intro2SeriesName: "TD", intro2ModelKey: "TD250-36/4" },
  "12962": { intro2SeriesName: "TD", intro2ModelKey: "TD250-12.5/4" },
  "12963": { intro2SeriesName: "TD", intro2ModelKey: "TD250-14/4" },
  "12964": { intro2SeriesName: "TD", intro2ModelKey: "TD250-17/4" },
  "12965": { intro2SeriesName: "TD", intro2ModelKey: "TD250-20/4" },
  "12966": { intro2SeriesName: "TD", intro2ModelKey: "TD250-26/4" },
  "12967": { intro2SeriesName: "TD", intro2ModelKey: "TD250-32/4" },
  "12968": { intro2SeriesName: "TD", intro2ModelKey: "TD250-40/4" },
  "12969": { intro2SeriesName: "TD", intro2ModelKey: "TD250-50/4" },
  "12970": { intro2SeriesName: "TD", intro2ModelKey: "TD300-15/4" },
  "12971": { intro2SeriesName: "TD", intro2ModelKey: "TD300-20/4" },
  "12972": { intro2SeriesName: "TD", intro2ModelKey: "TD300-25/4" },
  "12973": { intro2SeriesName: "TD", intro2ModelKey: "TD300-30/4" },
  "12974": { intro2SeriesName: "TD", intro2ModelKey: "TD300-35/4" },
  "12975": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "12976": { intro2SeriesName: "TD", intro2ModelKey: "TD300-55/4" },
  "14236": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x3" },
  "14237": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x4" },
  "14238": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x5" },
  "14239": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x6" },
  "14240": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x7" },
  "14241": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x8" },
  "14242": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x9" },
  "14243": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x10" },
  "14244": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x11" },
  "14245": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x12" },
  "14246": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x3" },
  "14247": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x4" },
  "14248": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x5" },
  "14249": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x6" },
  "14250": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x7" },
  "14251": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x8" },
  "14252": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x9" },
  "14253": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x10" },
  "14254": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x11" },
  "14255": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x12" },
  "14256": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x2" },
  "14257": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x3" },
  "14258": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x4" },
  "14259": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x5" },
  "14260": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x6" },
  "14261": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x7" },
  "14262": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x8" },
  "14263": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x9" },
  "14264": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x10" },
  "14265": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x11" },
  "14266": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x12" },
  "14267": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x3" },
  "14268": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x4" },
  "14269": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x5" },
  "14270": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x6" },
  "14271": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x7" },
  "14272": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x8" },
  "14273": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x9" },
  "14274": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x10" },
  "14275": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x3" },
  "14276": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x4" },
  "14277": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x5" },
  "14278": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x6" },
  "14279": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x7" },
  "14280": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x8" },
  "14281": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x9" },
  "14282": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x10" },
  "14283": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x11" },
  "14284": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x12" },
  "14285": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x3" },
  "14286": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x4" },
  "14287": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x5" },
  "14288": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x6" },
  "14289": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x7" },
  "14290": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x8" },
  "14291": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x9" },
  "14292": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x10" },
  "14293": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x11" },
  "14294": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x12" },
  "14295": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x3" },
  "14296": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x4" },
  "14297": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x5" },
  "14298": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x6" },
  "14299": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x7" },
  "14300": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x8" },
  "14301": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x9" },
  "14302": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x10" },
  "14303": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x3" },
  "14304": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x4" },
  "14305": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x5" },
  "14306": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x6" },
  "14307": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x7" },
  "14308": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x8" },
  "14309": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x9" },
  "14310": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x3" },
  "14311": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x4" },
  "14312": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x5" },
  "14313": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x6" },
  "14314": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x7" },
  "14315": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x8" },
  "14316": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x9" },
  "14317": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x2" },
  "14318": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x3" },
  "14319": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x4" },
  "14320": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x5" },
  "14321": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x6" },
  "14322": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x7" },
  "14323": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x8" },
  "14324": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x9" },
  "14326": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x2" },
  "14327": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x3" },
  "14328": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x4" },
  "14329": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x5" },
  "14330": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x6" },
  "14331": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x7" },
  "14332": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x8" },
  "14333": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x9" },
  "14334": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x10" },
  "14335": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x2" },
  "14336": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x3" },
  "14337": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x4" },
  "14338": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x5" },
  "14339": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x6" },
  "14340": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x7" },
  "14341": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x8" },
  "14342": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x9" },
  "14343": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x3" },
  "14344": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x4" },
  "14345": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x5" },
  "14346": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x6" },
  "14347": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x7" },
  "14348": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x8" },
  "14349": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x9" },
  "14350": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x2" },
  "14351": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x3" },
  "14352": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x4" },
  "14353": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x5" },
  "14354": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x6" },
  "14355": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x7" },
  "14356": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x8" },
  "14357": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x9" },
  "14358": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x10" },
  "14359": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x2" },
  "14360": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x3" },
  "14361": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x4" },
  "14362": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x5" },
  "14363": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x6" },
  "14364": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x7" },
  "14365": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x8" },
  "14366": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x9" },
  "14367": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x10" },
  "14378": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x3" },
  "14379": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x4" },
  "14380": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x5" },
  "14381": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x6" },
  "14382": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x7" },
  "14383": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x2" },
  "14384": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x3" },
  "14385": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x4" },
  "14386": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x5" },
  "14387": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x6" },
  "14388": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x7" },
  "14389": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x8" },
  "15824": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-90-4" },
  "15825": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-75-4" },
  "15907": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "15915": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "15916": { intro2SeriesName: "TD", intro2ModelKey: "TD40-18/2" },
  "15917": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-250/25（60Hz）" },
  "15938": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-20/2（60Hz）" },
  "15939": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-30/3（60Hz）" },
  "15940": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-40/4（60Hz）" },
  "15941": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-50/5（60Hz）" },
  "15942": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-60/6（60Hz）" },
  "15943": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-70/7（60Hz）" },
  "15944": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-80/8（60Hz）" },
  "15945": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-90/9（60Hz）" },
  "15946": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-100/10（60Hz）" },
  "15947": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-110/11（60Hz）" },
  "15948": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-120/12（60Hz）" },
  "15949": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-130/13（60Hz）" },
  "15951": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-150/15（60Hz）" },
  "15953": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-170/17（60Hz）" },
  "15955": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-190/19（60Hz）" },
  "15957": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-210/21（60Hz）" },
  "15959": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-230/23（60Hz）" },
  "15962": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-270/27" },
  "15965": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-300/30" },
  "15968": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-330/33" },
  "15971": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-360/36" },
  "15972": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-20/2（60Hz）" },
  "15973": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-30/3（60Hz）" },
  "15974": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-40/4（60Hz）" },
  "15975": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-50/5（60Hz）" },
  "15976": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-60/6（60Hz）" },
  "15977": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-70/7（60Hz）" },
  "15979": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-90/9（60Hz）" },
  "15981": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-110/11（60Hz）" },
  "15983": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-130/13（60Hz）" },
  "15985": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-150/15（60Hz）" },
  "15988": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-180/18（60Hz）" },
  "15992": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-220/22" },
  "15996": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-260/26" },
  "15997": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-20/2（60Hz）" },
  "15998": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-30/3（60Hz）" },
  "15999": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-40/4（60Hz）" },
  "16000": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-50/5（60Hz）" },
  "16001": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-60/6（60Hz）" },
  "16002": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-70/7（60Hz）" },
  "16003": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-80/8（60Hz）" },
  "16004": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-90/9（60Hz）" },
  "16005": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-100/10（60Hz）" },
  "16006": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-110/11（60Hz）" },
  "16007": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-120/12（60Hz）" },
  "16008": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-130/13（60Hz）" },
  "16010": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-150/15（60Hz）" },
  "16012": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-170/17（60Hz）" },
  "16014": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-190/19（60Hz）" },
  "16016": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-210/21（60Hz）" },
  "16017": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "16018": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-230/23（60Hz）" },
  "16020": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-250/25（60Hz）" },
  "16022": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-270/27" },
  "16024": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-290/29" },
  "16026": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-310/31" },
  "16028": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-330/33" },
  "16031": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-360/36" },
  "16032": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-20/2（60Hz）" },
  "16033": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-30/3（60Hz）" },
  "16034": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-40/4（60Hz）" },
  "16035": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-50/5（60Hz）" },
  "16036": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-60/6（60Hz）" },
  "16037": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-70/7（60Hz）" },
  "16038": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-80/8（60Hz）" },
  "16040": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-100/10（60Hz）" },
  "16042": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-120/12（60Hz）" },
  "16044": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-140/14（60Hz）" },
  "16046": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-160/16（60Hz）" },
  "16049": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-190/19" },
  "16052": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "16053": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-20/2（60Hz）" },
  "16054": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-30/3（60Hz）" },
  "16055": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-40/4（60Hz）" },
  "16056": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-50/5（60Hz）" },
  "16057": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-60/6（60Hz）" },
  "16059": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-80/8（60Hz）" },
  "16061": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-100/10（60Hz）" },
  "16063": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-120/12（60Hz）" },
  "16065": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-140/14（60Hz）" },
  "16067": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-160/16" },
  "16069": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-180/18" },
  "16071": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-200/20" },
  "16072": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-20/2（60Hz）" },
  "16073": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-30/3（60Hz）" },
  "16074": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-40/4（60Hz）" },
  "16075": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-50/5（60Hz）" },
  "16076": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-60/6（60Hz）" },
  "16077": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-70/7（60Hz）" },
  "16078": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-80/8（60Hz）" },
  "16080": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-100/10（60Hz）" },
  "16082": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-120/12" },
  "16084": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-140/14" },
  "16086": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-160/16" },
  "16087": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-20/2（60Hz）" },
  "16088": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-30/3（60Hz）" },
  "16089": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-40/4（60Hz）" },
  "16090": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-50/5（60Hz）" },
  "16091": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-60/6（60Hz）" },
  "16092": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-70/7（60Hz）" },
  "16093": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-80/8（60Hz）" },
  "16095": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-100/10（60Hz）" },
  "16097": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-120/12" },
  "16099": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-140/14" },
  "16102": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-170/17" },
  "16104": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-10/1（60Hz）" },
  "16105": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "16106": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2（60Hz）" },
  "16107": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-30/3（60Hz）" },
  "16108": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-40/4（60Hz）" },
  "16109": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-50/5（60Hz）" },
  "16110": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-60/6（60Hz）" },
  "16111": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-70/7（60Hz）" },
  "16112": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-80/8（60Hz）" },
  "16113": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-90/9（60Hz）" },
  "16119": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1-1" },
  "16120": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1（60Hz）" },
  "16121": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "16122": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2（60Hz）" },
  "16123": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3-2" },
  "16124": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "16125": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4-2" },
  "16127": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5-2" },
  "16128": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5（60Hz）" },
  "16129": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6-2" },
  "16130": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6（60Hz）" },
  "16131": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7-2" },
  "16132": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7（60Hz）" },
  "16133": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8-2" },
  "16134": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8" },
  "16135": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9-2" },
  "16136": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9" },
  "16137": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10-2" },
  "16138": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10" },
  "16139": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-110/11-2" },
  "16140": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK 42-110/11" },
  "16141": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12-2" },
  "16142": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12" },
  "16143": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-130/13-2" },
  "16350": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "16351": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4（60Hz）" },
  "17377": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "17378": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "17443": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-70-2" },
  "17463": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-A" },
  "17580": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60-2" },
  "17624": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-1.1-2" },
  "17625": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-1.5-2" },
  "17626": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-2.2-2" },
  "17628": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-2.2-2" },
  "17629": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-3-2" },
  "17630": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-4-2" },
  "17631": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-5.5-2" },
  "17632": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-5.5-2" },
  "17633": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-7.5-2" },
  "17634": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-11-2" },
  "17635": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-11-2" },
  "17636": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-15-2" },
  "17637": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-18.5-2" },
  "17638": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-1.5-2" },
  "17639": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-2.2-2" },
  "17640": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-3-2" },
  "17641": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-4-2" },
  "17642": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-3-2" },
  "17643": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-4-2" },
  "17644": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-5.5-2" },
  "17645": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-7.5-2" },
  "17646": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-5.5-2" },
  "17647": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-7.5-2" },
  "17648": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-11-2" },
  "17649": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-15-2" },
  "17650": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-18.5-2" },
  "17651": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-22-2" },
  "17652": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-22-2" },
  "17653": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-15-2" },
  "17654": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-30-2" },
  "17655": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-18.5-2" },
  "17656": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-37-2" },
  "17657": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-45-2" },
  "17658": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-22-2" },
  "17659": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-30-2" },
  "17661": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-3-2" },
  "17662": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-4-2" },
  "17663": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-37-2" },
  "17664": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-5.5-2" },
  "17665": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-7.5-2" },
  "17666": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-45-2" },
  "17667": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-55-2" },
  "17668": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-75-2" },
  "17671": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-7.5-2" },
  "17672": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-11-2" },
  "17678": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-11-2" },
  "17679": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-15-2" },
  "17681": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-18.5-2" },
  "17683": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-22-2" },
  "17685": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-30-2" },
  "17687": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-55-2" },
  "17693": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-75-2" },
  "17696": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-4-2" },
  "17698": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-7.5-2" },
  "17700": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-15-2" },
  "17701": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-18.5-2" },
  "17703": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-11-2" },
  "17704": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-15-2" },
  "17705": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-22-2" },
  "17706": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-18.5-2" },
  "17712": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200H-30-2" },
  "17713": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-30-2" },
  "17714": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-37-2" },
  "17716": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-37-2" },
  "17717": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-45-2" },
  "17718": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-45-2" },
  "17719": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-55-2" },
  "17720": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-45-2" },
  "17721": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-55-2" },
  "17722": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-75-2" },
  "17726": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320H-90-2" },
  "17727": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-75-2" },
  "17728": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-90-2" },
  "17729": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-0.55-4" },
  "17730": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-0.55-4" },
  "17731": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-0.75-4" },
  "17732": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-1.1-4" },
  "17733": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-2.2-4" },
  "17734": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-0.55-4" },
  "17735": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.55-4" },
  "17736": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.75-4" },
  "17737": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-1.1-4" },
  "17738": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-0.75-4" },
  "17739": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-75-4" },
  "17740": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-11-4" },
  "17741": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.1-4" },
  "17742": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-15-4" },
  "17743": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-18.5-4" },
  "17744": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-18.5-4" },
  "17745": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.5-4" },
  "17746": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-22-4" },
  "17747": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-30-4" },
  "17748": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-30-4" },
  "17749": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-37-4" },
  "17750": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-45-4" },
  "17751": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-3-4" },
  "17752": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-2.2-4" },
  "17753": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-2.2-4" },
  "17754": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.1-4" },
  "17755": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-3-4" },
  "17756": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.5-4" },
  "17757": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-1.5-4" },
  "17758": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-2.2-4" },
  "17759": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-4-4" },
  "17760": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-3-4" },
  "17761": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-3-4" },
  "17762": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-4-4" },
  "17763": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-4-4" },
  "17764": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-5.5-4" },
  "17765": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-5.5-4" },
  "17766": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-7.5-4" },
  "17767": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-7.5-4" },
  "17768": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-7.5-4" },
  "17769": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-11-4" },
  "17770": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-15-4" },
  "17771": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-1.5-4" },
  "17772": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-2.2-4" },
  "17773": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-3-4" },
  "17774": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-3-4" },
  "17775": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-55-4" },
  "17776": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-45-4" },
  "17777": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-55-4" },
  "17778": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-75-4" },
  "17779": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-90-4" },
  "17780": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-22-4" },
  "17781": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-30-4" },
  "17782": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-37-4" },
  "17783": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-45-4" },
  "17784": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-55-4" },
  "17785": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-75-4" },
  "17786": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-55-4" },
  "17787": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-75-4" },
  "17788": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-90-4" },
  "17789": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-110-4" },
  "17790": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-55-4" },
  "17791": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-75-4" },
  "17792": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-90-4" },
  "17793": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-110-4" },
  "17794": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-132-4" },
  "17795": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-4-4" },
  "17796": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-5.5-4" },
  "17797": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-7.5-4" },
  "17798": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-11-4" },
  "17799": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-11-4" },
  "17800": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-15-4" },
  "17801": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-18.5-4" },
  "17802": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-22-4" },
  "17803": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-30-4" },
  "17804": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-2.2-4" },
  "17805": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-3-4" },
  "17806": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-5.5-4" },
  "17807": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-7.5-4" },
  "17808": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-11-4" },
  "17809": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-15-4" },
  "17810": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-15-4" },
  "17811": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-18.5-4" },
  "17812": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-22-4" },
  "17813": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-30-4" },
  "17814": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-22-4" },
  "17815": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-30-4" },
  "17816": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-37-4" },
  "17817": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-7.5-4" },
  "17818": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-11-4" },
  "17819": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-15-4" },
  "17820": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-18.5-4" },
  "17821": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.55-4" },
  "17822": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-22-4" },
  "17823": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.75-4" },
  "17824": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-30-4" },
  "17825": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-18.5-4" },
  "17826": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-1.1-4" },
  "17827": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-22-4" },
  "17828": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-30-4" },
  "17829": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-37-4" },
  "17830": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-0.75-4" },
  "17831": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-45-4" },
  "17832": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.1-4" },
  "17833": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.5-4" },
  "17834": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-55-4" },
  "17835": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.1-4" },
  "17836": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.5-4" },
  "17837": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-2.2-4" },
  "17838": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-3-4" },
  "17839": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-4-4" },
  "17840": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-5.5-4" },
  "17841": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-5.5-4" },
  "17842": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-7.5-4" },
  "17843": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-11-4" },
  "17844": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-0.75-4" },
  "17845": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-1.1-4" },
  "18365": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-2(60hz)" },
  "18366": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-3(60hz)" },
  "18367": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-4(60hz)" },
  "18368": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-5(60hz)" },
  "18369": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-6(60hz)" },
  "18370": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-7(60hz)" },
  "18371": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-8(60hz)" },
  "18372": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-9(60hz)" },
  "18373": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-10(60hz)" },
  "18374": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-11(60hz)" },
  "18375": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-12(60hz)" },
  "18376": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-13(60hz)" },
  "18378": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-15(60hz)" },
  "18380": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-17(60hz)" },
  "18382": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-19(60hz)" },
  "18383": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-20" },
  "18384": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-21(60hz)" },
  "18385": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-2(60hz)" },
  "18386": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-23(60hz)" },
  "18387": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-4(60hz)" },
  "18388": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-25(60hz)" },
  "18389": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-6(60hz)" },
  "18390": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-7(60hz)" },
  "18391": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-8(60hz)" },
  "18393": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-30" },
  "18400": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-2(60hz)" },
  "18401": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-3(60hz)" },
  "18402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-4(60hz)" },
  "18403": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-5(60hz)" },
  "18404": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "18405": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-7(60hz)" },
  "18407": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-9(60hz)" },
  "18409": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-11(60hz)" },
  "18411": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-13(60hz)" },
  "18413": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-15(60hz)" },
  "18416": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-18(60hz)" },
  "18418": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-20" },
  "18425": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-2(60hz)" },
  "18426": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-3(60hz)" },
  "18427": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-4(60hz)" },
  "18428": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-5(60hz)" },
  "18429": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-6(60hz)" },
  "18430": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-7(60hz)" },
  "18431": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-8(60hz)" },
  "18432": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-9(60hz)" },
  "18433": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-10(60hz)" },
  "18434": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-11(60hz)" },
  "18435": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-12(60hz)" },
  "18436": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-13(60hz)" },
  "18438": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-15(60hz)" },
  "18440": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-17(60hz)" },
  "18442": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-19(60hz)" },
  "18443": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-20" },
  "18444": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-21(60hz)" },
  "18446": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-23(60hz)" },
  "18448": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-25(60hz)" },
  "18453": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-30" },
  "18460": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-2(60hz)" },
  "18461": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-3(60hz)" },
  "18462": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-4(60hz)" },
  "18463": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-5(60hz)" },
  "18464": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-6(60hz)" },
  "18465": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-7(60hz)" },
  "18466": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-8(60hz)" },
  "18468": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-10(60hz)" },
  "18470": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-12(60hz)" },
  "18472": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-14(60hz)" },
  "18474": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-16(60hz)" },
  "18478": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-20" },
  "18481": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-2/1(60hz)" },
  "18482": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-2(60hz)" },
  "18483": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-3(60hz)" },
  "18484": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-4(60hz)" },
  "18485": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-5(60hz)" },
  "18486": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-6(60hz)" },
  "18488": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-8(60hz)" },
  "18490": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-10(60hz)" },
  "18492": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-12(60hz)" },
  "18494": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-14(60hz)" },
  "18500": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-20" },
  "18501": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-1(60hz)" },
  "18502": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-2(60hz)" },
  "18503": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-3(60hz)" },
  "18504": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-4(60hz)" },
  "18505": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-5(60hz)" },
  "18506": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-6(60hz)" },
  "18507": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-7(60hz)" },
  "18508": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-8(60hz)" },
  "18509": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-9(60hz)" },
  "18510": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-10" },
  "18512": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-12(60hz)" },
  "18514": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-14(60hz)" },
  "18516": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-16(60hz)" },
  "18517": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-17(60hz)" },
  "18520": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-20" },
  "18523": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-2(60hz)" },
  "18524": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-23(60hz)" },
  "18525": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-4(60hz)" },
  "18526": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-25(60hz)" },
  "18527": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-6(60hz)" },
  "18528": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-7(60hz)" },
  "18529": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-8(60hz)" },
  "18531": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-210" },
  "18533": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-12(60hz)" },
  "18535": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-14(60hz)" },
  "18540": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-1(60hz)" },
  "18541": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-2(60hz)" },
  "18542": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-3(60hz)" },
  "18543": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-4(60hz)" },
  "18544": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-5(60hz)" },
  "18545": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-6(60hz)" },
  "18546": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-7(60hz)" },
  "18547": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-8(60hz)" },
  "18548": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-9(60hz)" },
  "18549": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-10(60hz)" },
  "18551": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-12(60hz)" },
  "18557": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-2/1(60hz)" },
  "18558": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-2(60hz)" },
  "18559": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-3(60hz)" },
  "18560": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-4(60hz)" },
  "18561": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-5(60hz)" },
  "18562": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-6(60hz)" },
  "18563": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-7(60hz)" },
  "18564": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-8(60hz)" },
  "18566": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-10(60hz)" },
  "18573": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-1(60hz)" },
  "18574": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-2(60hz)" },
  "18575": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-3(60hz)" },
  "18576": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-4(60hz)" },
  "18577": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-5(60hz)" },
  "18578": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-6(60hz)" },
  "18579": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-7(60hz)" },
  "18580": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-8(60hz)" },
  "18582": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-10" },
  "18590": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-10-1" },
  "18591": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-210" },
  "18592": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20-2" },
  "18593": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20" },
  "18594": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-230" },
  "18595": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-40" },
  "18596": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-250" },
  "18597": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60" },
  "18598": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-270" },
  "18599": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-80" },
  "18600": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-290" },
  "18601": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-100" },
  "18602": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-110" },
  "18603": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-120" },
  "18604": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-130" },
  "18605": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-140" },
  "18606": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150-2" },
  "18607": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150" },
  "18608": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160-2" },
  "18609": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160" },
  "18610": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10-1(60hz)" },
  "18611": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10(60hz)" },
  "18612": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-20-2(60hz)" },
  "18613": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-220" },
  "18614": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30-2(60hz)" },
  "18615": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30(60hz)" },
  "18616": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40-2(60hz)" },
  "18617": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40(60hz)" },
  "18618": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50-2(60hz)" },
  "18619": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50(60hz)" },
  "18620": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60-2(60hz)" },
  "18621": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60(60hz)" },
  "18622": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70-2(60hz)" },
  "18623": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70(60hz)" },
  "18635": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-10-1(60hz)" },
  "18636": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-10(60hz)" },
  "18637": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-20-2(60hz)" },
  "18639": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-20(60hz)" },
  "18640": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-30-2(60hz)" },
  "18642": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-30(60hz)" },
  "18643": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-40-2(60hz)" },
  "18645": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-40(60hz)" },
  "18646": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-50-2(60hz)" },
  "18669": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-10" },
  "18670": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-2" },
  "18671": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-1" },
  "18672": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20" },
  "18673": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-2" },
  "18674": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-1" },
  "18675": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30" },
  "18676": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-2" },
  "18677": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-1" },
  "18678": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40" },
  "18679": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-2" },
  "18680": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-1" },
  "18681": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50" },
  "18682": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-2" },
  "18683": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-1" },
  "18684": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60" },
  "18685": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-2" },
  "18686": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-1" },
  "18687": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70" },
  "18688": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10-1" },
  "18689": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10" },
  "18690": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-2" },
  "18691": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-1" },
  "18692": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20" },
  "18693": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-2" },
  "18694": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-1" },
  "18695": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30" },
  "18696": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-2" },
  "18697": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-1" },
  "18698": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40" },
  "18699": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-2" },
  "18700": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-1" },
  "18701": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50" },
  "18702": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-2" },
  "18703": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-1" },
  "18704": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60" },
  "18705": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-B" },
  "18706": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-A" },
  "18707": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10" },
  "18708": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2B" },
  "18709": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2A" },
  "18710": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20" },
  "18711": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2B" },
  "18712": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A-B" },
  "18713": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2A" },
  "18714": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-B" },
  "18715": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A" },
  "18716": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30" },
  "18717": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2B" },
  "18718": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2A" },
  "18719": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-A" },
  "18720": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40" },
  "18725": { intro2SeriesName: "TD", intro2ModelKey: "TD32-18/2" },
  "18726": { intro2SeriesName: "TD", intro2ModelKey: "TD32-21/2" },
  "18727": { intro2SeriesName: "TD", intro2ModelKey: "TD32-25/2" },
  "18728": { intro2SeriesName: "TD", intro2ModelKey: "TD32-32/2" },
  "18729": { intro2SeriesName: "TD", intro2ModelKey: "TD32-38/2" },
  "18730": { intro2SeriesName: "TD", intro2ModelKey: "TD32-50/2" },
  "18731": { intro2SeriesName: "TD", intro2ModelKey: "TD40-16/2" },
  "18732": { intro2SeriesName: "TD", intro2ModelKey: "TD40-20/2" },
  "18733": { intro2SeriesName: "TD", intro2ModelKey: "TD40-18/2" },
  "18734": { intro2SeriesName: "TD", intro2ModelKey: "TD40-25/2" },
  "18735": { intro2SeriesName: "TD", intro2ModelKey: "TD40-30/2" },
  "18736": { intro2SeriesName: "TD", intro2ModelKey: "TD40-36/2" },
  "18737": { intro2SeriesName: "TD", intro2ModelKey: "TD40-48/2" },
  "18738": { intro2SeriesName: "TD", intro2ModelKey: "TD50-12/2" },
  "18739": { intro2SeriesName: "TD", intro2ModelKey: "TD50-15/2" },
  "18740": { intro2SeriesName: "TD", intro2ModelKey: "TD50-18/2" },
  "18741": { intro2SeriesName: "TD", intro2ModelKey: "TD50-24/2" },
  "18742": { intro2SeriesName: "TD", intro2ModelKey: "TD50-28/2" },
  "18743": { intro2SeriesName: "TD", intro2ModelKey: "TD50-32/2" },
  "18744": { intro2SeriesName: "TD", intro2ModelKey: "TD50-38/2" },
  "18745": { intro2SeriesName: "TD", intro2ModelKey: "TD50-48/2" },
  "18748": { intro2SeriesName: "TD", intro2ModelKey: "TD50-35/2" },
  "18749": { intro2SeriesName: "TD", intro2ModelKey: "TD50-40/2" },
  "18750": { intro2SeriesName: "TD", intro2ModelKey: "TD50-50/2" },
  "18751": { intro2SeriesName: "TD", intro2ModelKey: "TD50-60/2" },
  "18752": { intro2SeriesName: "TD", intro2ModelKey: "TD50-70/2" },
  "18753": { intro2SeriesName: "TD", intro2ModelKey: "TD50-81/2" },
  "18754": { intro2SeriesName: "TD", intro2ModelKey: "TD65-15/2" },
  "18755": { intro2SeriesName: "TD", intro2ModelKey: "TD65-19/2" },
  "18756": { intro2SeriesName: "TD", intro2ModelKey: "TD65-22/2" },
  "18757": { intro2SeriesName: "TD", intro2ModelKey: "TD65-30/2" },
  "18758": { intro2SeriesName: "TD", intro2ModelKey: "TD65-36/2" },
  "18759": { intro2SeriesName: "TD", intro2ModelKey: "TD65-34/2" },
  "18760": { intro2SeriesName: "TD", intro2ModelKey: "TD65-40/2" },
  "18761": { intro2SeriesName: "TD", intro2ModelKey: "TD65-48/2" },
  "18762": { intro2SeriesName: "TD", intro2ModelKey: "TD65-50/2" },
  "18763": { intro2SeriesName: "TD", intro2ModelKey: "TD65-61/2" },
  "18764": { intro2SeriesName: "TD", intro2ModelKey: "TD65-67/2" },
  "18765": { intro2SeriesName: "TD", intro2ModelKey: "TD65-83/2" },
  "18766": { intro2SeriesName: "TD", intro2ModelKey: "TD80-13/2" },
  "18767": { intro2SeriesName: "TD", intro2ModelKey: "TD80-18/2" },
  "18768": { intro2SeriesName: "TD", intro2ModelKey: "TD80-22/2" },
  "18769": { intro2SeriesName: "TD", intro2ModelKey: "TD80-28/2" },
  "18770": { intro2SeriesName: "TD", intro2ModelKey: "TD80-30/2" },
  "18771": { intro2SeriesName: "TD", intro2ModelKey: "TD80-38/2" },
  "18772": { intro2SeriesName: "TD", intro2ModelKey: "TD80-40/2" },
  "18773": { intro2SeriesName: "TD", intro2ModelKey: "TD80-48/2" },
  "18774": { intro2SeriesName: "TD", intro2ModelKey: "TD80-47/2" },
  "18775": { intro2SeriesName: "TD", intro2ModelKey: "TD80-54/2" },
  "18776": { intro2SeriesName: "TD", intro2ModelKey: "TD80-67/2" },
  "18777": { intro2SeriesName: "TD", intro2ModelKey: "TD100-9/2" },
  "18778": { intro2SeriesName: "TD", intro2ModelKey: "TD100-15/2" },
  "18779": { intro2SeriesName: "TD", intro2ModelKey: "TD100-17/2" },
  "18780": { intro2SeriesName: "TD", intro2ModelKey: "TD100-22/2" },
  "18781": { intro2SeriesName: "TD", intro2ModelKey: "TD100-27/2" },
  "18782": { intro2SeriesName: "TD", intro2ModelKey: "TD100-33/2" },
  "18783": { intro2SeriesName: "TD", intro2ModelKey: "TD100-40/2" },
  "18784": { intro2SeriesName: "TD", intro2ModelKey: "TD100-48/2" },
  "18785": { intro2SeriesName: "TD", intro2ModelKey: "TD100-52/2" },
  "18786": { intro2SeriesName: "TD", intro2ModelKey: "TD125-11/4" },
  "18787": { intro2SeriesName: "TD", intro2ModelKey: "TD125-14/4" },
  "18788": { intro2SeriesName: "TD", intro2ModelKey: "TD125-18/4" },
  "18789": { intro2SeriesName: "TD", intro2ModelKey: "TD125-22/4" },
  "18790": { intro2SeriesName: "TD", intro2ModelKey: "TD125-28/4" },
  "18791": { intro2SeriesName: "TD", intro2ModelKey: "TD125-32/4" },
  "18792": { intro2SeriesName: "TD", intro2ModelKey: "TD125-40/4" },
  "18793": { intro2SeriesName: "TD", intro2ModelKey: "TD125-48/4" },
  "18794": { intro2SeriesName: "TD", intro2ModelKey: "TD150-12.5/4" },
  "18795": { intro2SeriesName: "TD", intro2ModelKey: "TD150-17/4" },
  "18796": { intro2SeriesName: "TD", intro2ModelKey: "TD150-21/4" },
  "18797": { intro2SeriesName: "TD", intro2ModelKey: "TD150-25/4" },
  "18798": { intro2SeriesName: "TD", intro2ModelKey: "TD150-33/4" },
  "18799": { intro2SeriesName: "TD", intro2ModelKey: "TD150-40/4" },
  "18800": { intro2SeriesName: "TD", intro2ModelKey: "TD150-50/4" },
  "18803": { intro2SeriesName: "TD", intro2ModelKey: "TD200-24/4" },
  "18807": { intro2SeriesName: "TD", intro2ModelKey: "TD200-53/4" },
  "18808": { intro2SeriesName: "TD", intro2ModelKey: "TD200-12.5/4" },
  "18809": { intro2SeriesName: "TD", intro2ModelKey: "TD200-20/4" },
  "18810": { intro2SeriesName: "TD", intro2ModelKey: "TD200-23/4" },
  "18811": { intro2SeriesName: "TD", intro2ModelKey: "TD200-27/4" },
  "18812": { intro2SeriesName: "TD", intro2ModelKey: "TD200-32/4" },
  "18813": { intro2SeriesName: "TD", intro2ModelKey: "TD200-43/4" },
  "18814": { intro2SeriesName: "TD", intro2ModelKey: "TD200-50/4" },
  "18819": { intro2SeriesName: "TD", intro2ModelKey: "TD250-36/4" },
  "18822": { intro2SeriesName: "TD", intro2ModelKey: "TD250-12.5/4" },
  "18823": { intro2SeriesName: "TD", intro2ModelKey: "TD250-14/4" },
  "18824": { intro2SeriesName: "TD", intro2ModelKey: "TD250-17/4" },
  "18825": { intro2SeriesName: "TD", intro2ModelKey: "TD250-20/4" },
  "18826": { intro2SeriesName: "TD", intro2ModelKey: "TD250-26/4" },
  "18827": { intro2SeriesName: "TD", intro2ModelKey: "TD250-32/4" },
  "18828": { intro2SeriesName: "TD", intro2ModelKey: "TD250-40/4" },
  "18829": { intro2SeriesName: "TD", intro2ModelKey: "TD250-50/4" },
  "18830": { intro2SeriesName: "TD", intro2ModelKey: "TD300-15/4" },
  "18831": { intro2SeriesName: "TD", intro2ModelKey: "TD300-20/4" },
  "18832": { intro2SeriesName: "TD", intro2ModelKey: "TD300-25/4" },
  "18833": { intro2SeriesName: "TD", intro2ModelKey: "TD300-30/4" },
  "18834": { intro2SeriesName: "TD", intro2ModelKey: "TD300-35/4" },
  "18835": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "18836": { intro2SeriesName: "TD", intro2ModelKey: "TD300-55/4" },
  "20096": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x3" },
  "20097": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x4" },
  "20098": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x5" },
  "20099": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x6" },
  "20100": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x7" },
  "20101": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x8" },
  "20102": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x9" },
  "20103": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x10" },
  "20104": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x11" },
  "20105": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x12" },
  "20106": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x3" },
  "20107": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x4" },
  "20108": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x5" },
  "20109": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x6" },
  "20110": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x7" },
  "20111": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x8" },
  "20112": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x9" },
  "20113": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x10" },
  "20114": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x11" },
  "20115": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x12" },
  "20116": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x2" },
  "20117": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x3" },
  "20118": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x4" },
  "20119": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x5" },
  "20120": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x6" },
  "20121": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x7" },
  "20122": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x8" },
  "20123": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x9" },
  "20124": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x10" },
  "20125": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x11" },
  "20126": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x12" },
  "20127": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x3" },
  "20128": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x4" },
  "20129": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x5" },
  "20130": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x6" },
  "20131": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x7" },
  "20132": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x8" },
  "20133": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x9" },
  "20134": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x10" },
  "20135": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x3" },
  "20136": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x4" },
  "20137": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x5" },
  "20138": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x6" },
  "20139": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x7" },
  "20140": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x8" },
  "20141": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x9" },
  "20142": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x10" },
  "20143": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x11" },
  "20144": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x12" },
  "20145": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x3" },
  "20146": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x4" },
  "20147": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x5" },
  "20148": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x6" },
  "20149": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x7" },
  "20150": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x8" },
  "20151": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x9" },
  "20152": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x10" },
  "20153": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x11" },
  "20154": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x12" },
  "20155": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x3" },
  "20156": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x4" },
  "20157": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x5" },
  "20158": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x6" },
  "20159": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x7" },
  "20160": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x8" },
  "20161": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x9" },
  "20162": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x10" },
  "20163": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x3" },
  "20164": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x4" },
  "20165": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x5" },
  "20166": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x6" },
  "20167": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x7" },
  "20168": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x8" },
  "20169": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x9" },
  "20170": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x3" },
  "20171": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x4" },
  "20172": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x5" },
  "20173": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x6" },
  "20174": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x7" },
  "20175": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x8" },
  "20176": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x9" },
  "20177": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x2" },
  "20178": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x3" },
  "20179": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x4" },
  "20180": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x5" },
  "20181": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x6" },
  "20182": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x7" },
  "20183": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x8" },
  "20184": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x9" },
  "20186": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x2" },
  "20187": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x3" },
  "20188": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x4" },
  "20189": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x5" },
  "20190": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x6" },
  "20191": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x7" },
  "20192": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x8" },
  "20193": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x9" },
  "20194": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x10" },
  "20195": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x2" },
  "20196": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x3" },
  "20197": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x4" },
  "20198": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x5" },
  "20199": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x6" },
  "20200": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x7" },
  "20201": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x8" },
  "20202": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x9" },
  "20203": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x3" },
  "20204": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x4" },
  "20205": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x5" },
  "20206": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x6" },
  "20207": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x7" },
  "20208": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x8" },
  "20209": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x9" },
  "20210": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x2" },
  "20211": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x3" },
  "20212": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x4" },
  "20213": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x5" },
  "20214": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x6" },
  "20215": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x7" },
  "20216": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x8" },
  "20217": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x9" },
  "20218": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x10" },
  "20219": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x2" },
  "20220": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x3" },
  "20221": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x4" },
  "20222": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x5" },
  "20223": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x6" },
  "20224": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x7" },
  "20225": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x8" },
  "20226": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x9" },
  "20227": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x10" },
  "20238": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x3" },
  "20239": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x4" },
  "20240": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x5" },
  "20241": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x6" },
  "20242": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x7" },
  "20243": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x2" },
  "20244": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x3" },
  "20245": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x4" },
  "20246": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x5" },
  "20247": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x6" },
  "20248": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x7" },
  "20249": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x8" },
  "21684": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-90-4" },
  "21685": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-75-4" },
  "21767": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "21775": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "21776": { intro2SeriesName: "TD", intro2ModelKey: "TD40-18/2" },
  "21777": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-250/25（60Hz）" },
  "21798": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-20/2（60Hz）" },
  "21799": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-30/3（60Hz）" },
  "21800": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-40/4（60Hz）" },
  "21801": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-50/5（60Hz）" },
  "21802": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-60/6（60Hz）" },
  "21803": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-70/7（60Hz）" },
  "21804": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-80/8（60Hz）" },
  "21805": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-90/9（60Hz）" },
  "21806": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-100/10（60Hz）" },
  "21807": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-110/11（60Hz）" },
  "21808": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-120/12（60Hz）" },
  "21809": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-130/13（60Hz）" },
  "21811": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-150/15（60Hz）" },
  "21813": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-170/17（60Hz）" },
  "21815": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-190/19（60Hz）" },
  "21817": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-210/21（60Hz）" },
  "21819": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-230/23（60Hz）" },
  "21822": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-270/27" },
  "21825": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-300/30" },
  "21828": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-330/33" },
  "21831": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-360/36" },
  "21832": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-20/2（60Hz）" },
  "21833": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-30/3（60Hz）" },
  "21834": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-40/4（60Hz）" },
  "21835": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-50/5（60Hz）" },
  "21836": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-60/6（60Hz）" },
  "21837": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-70/7（60Hz）" },
  "21839": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-90/9（60Hz）" },
  "21841": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-110/11（60Hz）" },
  "21843": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-130/13（60Hz）" },
  "21845": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-150/15（60Hz）" },
  "21848": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-180/18（60Hz）" },
  "21852": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-220/22" },
  "21856": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-260/26" },
  "21857": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-20/2（60Hz）" },
  "21858": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-30/3（60Hz）" },
  "21859": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-40/4（60Hz）" },
  "21860": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-50/5（60Hz）" },
  "21861": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-60/6（60Hz）" },
  "21862": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-70/7（60Hz）" },
  "21863": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-80/8（60Hz）" },
  "21864": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-90/9（60Hz）" },
  "21865": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-100/10（60Hz）" },
  "21866": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-110/11（60Hz）" },
  "21867": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-120/12（60Hz）" },
  "21868": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-130/13（60Hz）" },
  "21870": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-150/15（60Hz）" },
  "21872": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-170/17（60Hz）" },
  "21874": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-190/19（60Hz）" },
  "21876": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-210/21（60Hz）" },
  "21877": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "21878": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-230/23（60Hz）" },
  "21880": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-250/25（60Hz）" },
  "21882": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-270/27" },
  "21884": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-290/29" },
  "21886": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-310/31" },
  "21888": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-330/33" },
  "21891": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-360/36" },
  "21892": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-20/2（60Hz）" },
  "21893": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-30/3（60Hz）" },
  "21894": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-40/4（60Hz）" },
  "21895": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-50/5（60Hz）" },
  "21896": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-60/6（60Hz）" },
  "21897": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-70/7（60Hz）" },
  "21898": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-80/8（60Hz）" },
  "21900": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-100/10（60Hz）" },
  "21902": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-120/12（60Hz）" },
  "21904": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-140/14（60Hz）" },
  "21906": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-160/16（60Hz）" },
  "21909": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-190/19" },
  "21912": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "21913": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-20/2（60Hz）" },
  "21914": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-30/3（60Hz）" },
  "21915": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-40/4（60Hz）" },
  "21916": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-50/5（60Hz）" },
  "21917": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-60/6（60Hz）" },
  "21919": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-80/8（60Hz）" },
  "21921": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-100/10（60Hz）" },
  "21923": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-120/12（60Hz）" },
  "21925": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-140/14（60Hz）" },
  "21927": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-160/16" },
  "21929": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-180/18" },
  "21931": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-200/20" },
  "21932": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-20/2（60Hz）" },
  "21933": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-30/3（60Hz）" },
  "21934": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-40/4（60Hz）" },
  "21935": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-50/5（60Hz）" },
  "21936": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-60/6（60Hz）" },
  "21937": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-70/7（60Hz）" },
  "21938": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-80/8（60Hz）" },
  "21940": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-100/10（60Hz）" },
  "21942": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-120/12" },
  "21944": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-140/14" },
  "21946": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-160/16" },
  "21947": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-20/2（60Hz）" },
  "21948": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-30/3（60Hz）" },
  "21949": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-40/4（60Hz）" },
  "21950": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-50/5（60Hz）" },
  "21951": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-60/6（60Hz）" },
  "21952": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-70/7（60Hz）" },
  "21953": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-80/8（60Hz）" },
  "21955": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-100/10（60Hz）" },
  "21957": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-120/12" },
  "21959": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-140/14" },
  "21962": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-170/17" },
  "21964": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-10/1（60Hz）" },
  "21965": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "21966": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2（60Hz）" },
  "21967": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-30/3（60Hz）" },
  "21968": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-40/4（60Hz）" },
  "21969": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-50/5（60Hz）" },
  "21970": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-60/6（60Hz）" },
  "21971": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-70/7（60Hz）" },
  "21972": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-80/8（60Hz）" },
  "21973": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-90/9（60Hz）" },
  "21979": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1-1" },
  "21980": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1（60Hz）" },
  "21981": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "21982": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2（60Hz）" },
  "21983": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3-2" },
  "21984": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "21985": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4-2" },
  "21987": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5-2" },
  "21988": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5（60Hz）" },
  "21989": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6-2" },
  "21990": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6（60Hz）" },
  "21991": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7-2" },
  "21992": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7（60Hz）" },
  "21993": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8-2" },
  "21994": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8" },
  "21995": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9-2" },
  "21996": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9" },
  "21997": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10-2" },
  "21998": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10" },
  "21999": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-110/11-2" },
  "22000": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK 42-110/11" },
  "22001": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12-2" },
  "22002": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12" },
  "22003": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-130/13-2" },
  "22210": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "22211": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4（60Hz）" },
  "23237": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "23238": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "23303": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-70-2" },
  "23323": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-A" },
  "23440": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60-2" },
  "23484": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-1.1-2" },
  "23485": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-1.5-2" },
  "23486": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-2.2-2" },
  "23488": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-2.2-2" },
  "23489": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-3-2" },
  "23490": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-4-2" },
  "23491": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-5.5-2" },
  "23492": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-5.5-2" },
  "23493": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-7.5-2" },
  "23494": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-11-2" },
  "23495": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-11-2" },
  "23496": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-15-2" },
  "23497": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-18.5-2" },
  "23498": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-1.5-2" },
  "23499": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-2.2-2" },
  "23500": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-3-2" },
  "23501": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-4-2" },
  "23502": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-3-2" },
  "23503": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-4-2" },
  "23504": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-5.5-2" },
  "23505": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-7.5-2" },
  "23506": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-5.5-2" },
  "23507": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-7.5-2" },
  "23508": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-11-2" },
  "23509": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-15-2" },
  "23510": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-18.5-2" },
  "23511": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-22-2" },
  "23512": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-22-2" },
  "23513": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-15-2" },
  "23514": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-30-2" },
  "23515": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-18.5-2" },
  "23516": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-37-2" },
  "23517": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-45-2" },
  "23518": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-22-2" },
  "23519": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-30-2" },
  "23521": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-3-2" },
  "23522": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-4-2" },
  "23523": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-37-2" },
  "23524": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-5.5-2" },
  "23525": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-7.5-2" },
  "23526": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-45-2" },
  "23527": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-55-2" },
  "23528": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-75-2" },
  "23531": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-7.5-2" },
  "23532": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-11-2" },
  "23538": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-11-2" },
  "23539": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-15-2" },
  "23541": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-18.5-2" },
  "23543": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-22-2" },
  "23545": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-30-2" },
  "23547": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-55-2" },
  "23553": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-75-2" },
  "23556": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-4-2" },
  "23558": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-7.5-2" },
  "23560": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-15-2" },
  "23561": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-18.5-2" },
  "23563": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-11-2" },
  "23564": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-15-2" },
  "23565": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-22-2" },
  "23566": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-18.5-2" },
  "23572": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200H-30-2" },
  "23573": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-30-2" },
  "23574": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-37-2" },
  "23576": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-37-2" },
  "23577": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-45-2" },
  "23578": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-45-2" },
  "23579": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-55-2" },
  "23580": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-45-2" },
  "23581": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-55-2" },
  "23582": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-75-2" },
  "23586": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320H-90-2" },
  "23587": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-75-2" },
  "23588": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-90-2" },
  "23589": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-0.55-4" },
  "23590": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-0.55-4" },
  "23591": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-0.75-4" },
  "23592": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-1.1-4" },
  "23593": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-2.2-4" },
  "23594": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-0.55-4" },
  "23595": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.55-4" },
  "23596": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.75-4" },
  "23597": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-1.1-4" },
  "23598": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-0.75-4" },
  "23599": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-75-4" },
  "23600": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-11-4" },
  "23601": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.1-4" },
  "23602": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-15-4" },
  "23603": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-18.5-4" },
  "23604": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-18.5-4" },
  "23605": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.5-4" },
  "23606": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-22-4" },
  "23607": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-30-4" },
  "23608": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-30-4" },
  "23609": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-37-4" },
  "23610": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-45-4" },
  "23611": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-3-4" },
  "23612": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-2.2-4" },
  "23613": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-2.2-4" },
  "23614": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.1-4" },
  "23615": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-3-4" },
  "23616": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.5-4" },
  "23617": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-1.5-4" },
  "23618": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-2.2-4" },
  "23619": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-4-4" },
  "23620": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-3-4" },
  "23621": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-3-4" },
  "23622": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-4-4" },
  "23623": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-4-4" },
  "23624": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-5.5-4" },
  "23625": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-5.5-4" },
  "23626": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-7.5-4" },
  "23627": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-7.5-4" },
  "23628": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-7.5-4" },
  "23629": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-11-4" },
  "23630": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-15-4" },
  "23631": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-1.5-4" },
  "23632": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-2.2-4" },
  "23633": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-3-4" },
  "23634": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-3-4" },
  "23635": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-55-4" },
  "23636": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-45-4" },
  "23637": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-55-4" },
  "23638": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-75-4" },
  "23639": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-90-4" },
  "23640": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-22-4" },
  "23641": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-30-4" },
  "23642": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-37-4" },
  "23643": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-45-4" },
  "23644": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-55-4" },
  "23645": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-75-4" },
  "23646": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-55-4" },
  "23647": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-75-4" },
  "23648": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-90-4" },
  "23649": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-110-4" },
  "23650": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-55-4" },
  "23651": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-75-4" },
  "23652": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-90-4" },
  "23653": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-110-4" },
  "23654": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-132-4" },
  "23655": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-4-4" },
  "23656": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-5.5-4" },
  "23657": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-7.5-4" },
  "23658": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-11-4" },
  "23659": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-11-4" },
  "23660": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-15-4" },
  "23661": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-18.5-4" },
  "23662": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-22-4" },
  "23663": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-30-4" },
  "23664": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-2.2-4" },
  "23665": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-3-4" },
  "23666": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-5.5-4" },
  "23667": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-7.5-4" },
  "23668": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-11-4" },
  "23669": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-15-4" },
  "23670": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-15-4" },
  "23671": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-18.5-4" },
  "23672": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-22-4" },
  "23673": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-30-4" },
  "23674": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-22-4" },
  "23675": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-30-4" },
  "23676": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-37-4" },
  "23677": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-7.5-4" },
  "23678": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-11-4" },
  "23679": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-15-4" },
  "23680": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-18.5-4" },
  "23681": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.55-4" },
  "23682": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-22-4" },
  "23683": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.75-4" },
  "23684": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-30-4" },
  "23685": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-18.5-4" },
  "23686": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-1.1-4" },
  "23687": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-22-4" },
  "23688": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-30-4" },
  "23689": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-37-4" },
  "23690": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-0.75-4" },
  "23691": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-45-4" },
  "23692": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.1-4" },
  "23693": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.5-4" },
  "23694": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-55-4" },
  "23695": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.1-4" },
  "23696": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.5-4" },
  "23697": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-2.2-4" },
  "23698": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-3-4" },
  "23699": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-4-4" },
  "23700": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-5.5-4" },
  "23701": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-5.5-4" },
  "23702": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-7.5-4" },
  "23703": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-11-4" },
  "23704": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-0.75-4" },
  "23705": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-1.1-4" },
  "24225": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-2(60hz)" },
  "24226": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-3(60hz)" },
  "24227": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-4(60hz)" },
  "24228": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-5(60hz)" },
  "24229": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-6(60hz)" },
  "24230": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-7(60hz)" },
  "24231": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-8(60hz)" },
  "24232": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-9(60hz)" },
  "24233": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-10(60hz)" },
  "24234": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-11(60hz)" },
  "24235": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-12(60hz)" },
  "24236": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-13(60hz)" },
  "24238": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-15(60hz)" },
  "24240": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-17(60hz)" },
  "24242": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-19(60hz)" },
  "24243": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-20" },
  "24244": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-21(60hz)" },
  "24245": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-2(60hz)" },
  "24246": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-23(60hz)" },
  "24247": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-4(60hz)" },
  "24248": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-25(60hz)" },
  "24249": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-6(60hz)" },
  "24250": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-7(60hz)" },
  "24251": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-8(60hz)" },
  "24253": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-30" },
  "24260": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-2(60hz)" },
  "24261": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-3(60hz)" },
  "24262": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-4(60hz)" },
  "24263": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-5(60hz)" },
  "24264": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "24265": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-7(60hz)" },
  "24267": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-9(60hz)" },
  "24269": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-11(60hz)" },
  "24271": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-13(60hz)" },
  "24273": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-15(60hz)" },
  "24276": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-18(60hz)" },
  "24278": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-20" },
  "24285": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-2(60hz)" },
  "24286": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-3(60hz)" },
  "24287": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-4(60hz)" },
  "24288": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-5(60hz)" },
  "24289": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-6(60hz)" },
  "24290": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-7(60hz)" },
  "24291": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-8(60hz)" },
  "24292": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-9(60hz)" },
  "24293": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-10(60hz)" },
  "24294": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-11(60hz)" },
  "24295": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-12(60hz)" },
  "24296": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-13(60hz)" },
  "24298": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-15(60hz)" },
  "24300": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-17(60hz)" },
  "24302": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-19(60hz)" },
  "24303": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-20" },
  "24304": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-21(60hz)" },
  "24306": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-23(60hz)" },
  "24308": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-25(60hz)" },
  "24313": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-30" },
  "24320": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-2(60hz)" },
  "24321": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-3(60hz)" },
  "24322": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-4(60hz)" },
  "24323": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-5(60hz)" },
  "24324": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-6(60hz)" },
  "24325": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-7(60hz)" },
  "24326": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-8(60hz)" },
  "24328": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-10(60hz)" },
  "24330": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-12(60hz)" },
  "24332": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-14(60hz)" },
  "24334": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-16(60hz)" },
  "24338": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-20" },
  "24341": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-2/1(60hz)" },
  "24342": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-2(60hz)" },
  "24343": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-3(60hz)" },
  "24344": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-4(60hz)" },
  "24345": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-5(60hz)" },
  "24346": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-6(60hz)" },
  "24348": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-8(60hz)" },
  "24350": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-10(60hz)" },
  "24352": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-12(60hz)" },
  "24354": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-14(60hz)" },
  "24360": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-20" },
  "24361": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-1(60hz)" },
  "24362": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-2(60hz)" },
  "24363": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-3(60hz)" },
  "24364": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-4(60hz)" },
  "24365": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-5(60hz)" },
  "24366": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-6(60hz)" },
  "24367": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-7(60hz)" },
  "24368": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-8(60hz)" },
  "24369": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-9(60hz)" },
  "24370": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-10" },
  "24372": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-12(60hz)" },
  "24374": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-14(60hz)" },
  "24376": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-16(60hz)" },
  "24377": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-17(60hz)" },
  "24380": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-20" },
  "24383": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-2(60hz)" },
  "24384": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-23(60hz)" },
  "24385": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-4(60hz)" },
  "24386": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-25(60hz)" },
  "24387": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-6(60hz)" },
  "24388": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-7(60hz)" },
  "24389": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-8(60hz)" },
  "24391": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-210" },
  "24393": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-12(60hz)" },
  "24395": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-14(60hz)" },
  "24400": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-1(60hz)" },
  "24401": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-2(60hz)" },
  "24402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-3(60hz)" },
  "24403": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-4(60hz)" },
  "24404": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-5(60hz)" },
  "24405": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-6(60hz)" },
  "24406": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-7(60hz)" },
  "24407": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-8(60hz)" },
  "24408": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-9(60hz)" },
  "24409": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-10(60hz)" },
  "24411": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-12(60hz)" },
  "24417": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-2/1(60hz)" },
  "24418": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-2(60hz)" },
  "24419": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-3(60hz)" },
  "24420": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-4(60hz)" },
  "24421": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-5(60hz)" },
  "24422": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-6(60hz)" },
  "24423": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-7(60hz)" },
  "24424": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-8(60hz)" },
  "24426": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-10(60hz)" },
  "24433": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-1(60hz)" },
  "24434": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-2(60hz)" },
  "24435": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-3(60hz)" },
  "24436": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-4(60hz)" },
  "24437": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-5(60hz)" },
  "24438": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-6(60hz)" },
  "24439": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-7(60hz)" },
  "24440": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-8(60hz)" },
  "24442": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-10" },
  "24450": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-10-1" },
  "24451": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-210" },
  "24452": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20-2" },
  "24453": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20" },
  "24454": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-230" },
  "24455": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-40" },
  "24456": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-250" },
  "24457": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60" },
  "24458": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-270" },
  "24459": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-80" },
  "24460": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-290" },
  "24461": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-100" },
  "24462": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-110" },
  "24463": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-120" },
  "24464": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-130" },
  "24465": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-140" },
  "24466": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150-2" },
  "24467": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150" },
  "24468": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160-2" },
  "24469": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160" },
  "24470": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10-1(60hz)" },
  "24471": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10(60hz)" },
  "24472": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-20-2(60hz)" },
  "24473": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-220" },
  "24474": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30-2(60hz)" },
  "24475": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30(60hz)" },
  "24476": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40-2(60hz)" },
  "24477": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40(60hz)" },
  "24478": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50-2(60hz)" },
  "24479": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50(60hz)" },
  "24480": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60-2(60hz)" },
  "24481": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60(60hz)" },
  "24482": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70-2(60hz)" },
  "24483": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70(60hz)" },
  "24495": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-10-1(60hz)" },
  "24496": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-10(60hz)" },
  "24497": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-20-2(60hz)" },
  "24499": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-20(60hz)" },
  "24500": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-30-2(60hz)" },
  "24502": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-30(60hz)" },
  "24503": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-40-2(60hz)" },
  "24505": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-40(60hz)" },
  "24506": { intro2SeriesName: "CDL", intro2ModelKey: "CDL65-50-2(60hz)" },
  "24529": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-10" },
  "24530": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-2" },
  "24531": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-1" },
  "24532": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20" },
  "24533": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-2" },
  "24534": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-1" },
  "24535": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30" },
  "24536": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-2" },
  "24537": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-1" },
  "24538": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40" },
  "24539": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-2" },
  "24540": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-1" },
  "24541": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50" },
  "24542": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-2" },
  "24543": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-1" },
  "24544": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60" },
  "24545": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-2" },
  "24546": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-1" },
  "24547": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70" },
  "24548": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10-1" },
  "24549": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10" },
  "24550": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-2" },
  "24551": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-1" },
  "24552": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20" },
  "24553": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-2" },
  "24554": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-1" },
  "24555": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30" },
  "24556": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-2" },
  "24557": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-1" },
  "24558": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40" },
  "24559": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-2" },
  "24560": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-1" },
  "24561": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50" },
  "24562": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-2" },
  "24563": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-1" },
  "24564": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60" },
  "24565": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-B" },
  "24566": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-A" },
  "24567": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10" },
  "24568": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2B" },
  "24569": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2A" },
  "24570": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20" },
  "24571": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2B" },
  "24572": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A-B" },
  "24573": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2A" },
  "24574": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-B" },
  "24575": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A" },
  "24576": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30" },
  "24577": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2B" },
  "24578": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2A" },
  "24579": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-A" },
  "24580": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40" },
  "24585": { intro2SeriesName: "TD", intro2ModelKey: "TD32-18/2" },
  "24586": { intro2SeriesName: "TD", intro2ModelKey: "TD32-21/2" },
  "24587": { intro2SeriesName: "TD", intro2ModelKey: "TD32-25/2" },
  "24588": { intro2SeriesName: "TD", intro2ModelKey: "TD32-32/2" },
  "24589": { intro2SeriesName: "TD", intro2ModelKey: "TD32-38/2" },
  "24590": { intro2SeriesName: "TD", intro2ModelKey: "TD32-50/2" },
  "24591": { intro2SeriesName: "TD", intro2ModelKey: "TD40-16/2" },
  "24592": { intro2SeriesName: "TD", intro2ModelKey: "TD40-20/2" },
  "24593": { intro2SeriesName: "TD", intro2ModelKey: "TD40-18/2" },
  "24594": { intro2SeriesName: "TD", intro2ModelKey: "TD40-25/2" },
  "24595": { intro2SeriesName: "TD", intro2ModelKey: "TD40-30/2" },
  "24596": { intro2SeriesName: "TD", intro2ModelKey: "TD40-36/2" },
  "24597": { intro2SeriesName: "TD", intro2ModelKey: "TD40-48/2" },
  "24598": { intro2SeriesName: "TD", intro2ModelKey: "TD50-12/2" },
  "24599": { intro2SeriesName: "TD", intro2ModelKey: "TD50-15/2" },
  "24600": { intro2SeriesName: "TD", intro2ModelKey: "TD50-18/2" },
  "24601": { intro2SeriesName: "TD", intro2ModelKey: "TD50-24/2" },
  "24602": { intro2SeriesName: "TD", intro2ModelKey: "TD50-28/2" },
  "24603": { intro2SeriesName: "TD", intro2ModelKey: "TD50-32/2" },
  "24604": { intro2SeriesName: "TD", intro2ModelKey: "TD50-38/2" },
  "24605": { intro2SeriesName: "TD", intro2ModelKey: "TD50-48/2" },
  "24608": { intro2SeriesName: "TD", intro2ModelKey: "TD50-35/2" },
  "24609": { intro2SeriesName: "TD", intro2ModelKey: "TD50-40/2" },
  "24610": { intro2SeriesName: "TD", intro2ModelKey: "TD50-50/2" },
  "24611": { intro2SeriesName: "TD", intro2ModelKey: "TD50-60/2" },
  "24612": { intro2SeriesName: "TD", intro2ModelKey: "TD50-70/2" },
  "24613": { intro2SeriesName: "TD", intro2ModelKey: "TD50-81/2" },
  "24614": { intro2SeriesName: "TD", intro2ModelKey: "TD65-15/2" },
  "24615": { intro2SeriesName: "TD", intro2ModelKey: "TD65-19/2" },
  "24616": { intro2SeriesName: "TD", intro2ModelKey: "TD65-22/2" },
  "24617": { intro2SeriesName: "TD", intro2ModelKey: "TD65-30/2" },
  "24618": { intro2SeriesName: "TD", intro2ModelKey: "TD65-36/2" },
  "24619": { intro2SeriesName: "TD", intro2ModelKey: "TD65-34/2" },
  "24620": { intro2SeriesName: "TD", intro2ModelKey: "TD65-40/2" },
  "24621": { intro2SeriesName: "TD", intro2ModelKey: "TD65-48/2" },
  "24622": { intro2SeriesName: "TD", intro2ModelKey: "TD65-50/2" },
  "24623": { intro2SeriesName: "TD", intro2ModelKey: "TD65-61/2" },
  "24624": { intro2SeriesName: "TD", intro2ModelKey: "TD65-67/2" },
  "24625": { intro2SeriesName: "TD", intro2ModelKey: "TD65-83/2" },
  "24626": { intro2SeriesName: "TD", intro2ModelKey: "TD80-13/2" },
  "24627": { intro2SeriesName: "TD", intro2ModelKey: "TD80-18/2" },
  "24628": { intro2SeriesName: "TD", intro2ModelKey: "TD80-22/2" },
  "24629": { intro2SeriesName: "TD", intro2ModelKey: "TD80-28/2" },
  "24630": { intro2SeriesName: "TD", intro2ModelKey: "TD80-30/2" },
  "24631": { intro2SeriesName: "TD", intro2ModelKey: "TD80-38/2" },
  "24632": { intro2SeriesName: "TD", intro2ModelKey: "TD80-40/2" },
  "24633": { intro2SeriesName: "TD", intro2ModelKey: "TD80-48/2" },
  "24634": { intro2SeriesName: "TD", intro2ModelKey: "TD80-47/2" },
  "24635": { intro2SeriesName: "TD", intro2ModelKey: "TD80-54/2" },
  "24636": { intro2SeriesName: "TD", intro2ModelKey: "TD80-67/2" },
  "24637": { intro2SeriesName: "TD", intro2ModelKey: "TD100-9/2" },
  "24638": { intro2SeriesName: "TD", intro2ModelKey: "TD100-15/2" },
  "24639": { intro2SeriesName: "TD", intro2ModelKey: "TD100-17/2" },
  "24640": { intro2SeriesName: "TD", intro2ModelKey: "TD100-22/2" },
  "24641": { intro2SeriesName: "TD", intro2ModelKey: "TD100-27/2" },
  "24642": { intro2SeriesName: "TD", intro2ModelKey: "TD100-33/2" },
  "24643": { intro2SeriesName: "TD", intro2ModelKey: "TD100-40/2" },
  "24644": { intro2SeriesName: "TD", intro2ModelKey: "TD100-48/2" },
  "24645": { intro2SeriesName: "TD", intro2ModelKey: "TD100-52/2" },
  "24646": { intro2SeriesName: "TD", intro2ModelKey: "TD125-11/4" },
  "24647": { intro2SeriesName: "TD", intro2ModelKey: "TD125-14/4" },
  "24648": { intro2SeriesName: "TD", intro2ModelKey: "TD125-18/4" },
  "24649": { intro2SeriesName: "TD", intro2ModelKey: "TD125-22/4" },
  "24650": { intro2SeriesName: "TD", intro2ModelKey: "TD125-28/4" },
  "24651": { intro2SeriesName: "TD", intro2ModelKey: "TD125-32/4" },
  "24652": { intro2SeriesName: "TD", intro2ModelKey: "TD125-40/4" },
  "24653": { intro2SeriesName: "TD", intro2ModelKey: "TD125-48/4" },
  "24654": { intro2SeriesName: "TD", intro2ModelKey: "TD150-12.5/4" },
  "24655": { intro2SeriesName: "TD", intro2ModelKey: "TD150-17/4" },
  "24656": { intro2SeriesName: "TD", intro2ModelKey: "TD150-21/4" },
  "24657": { intro2SeriesName: "TD", intro2ModelKey: "TD150-25/4" },
  "24658": { intro2SeriesName: "TD", intro2ModelKey: "TD150-33/4" },
  "24659": { intro2SeriesName: "TD", intro2ModelKey: "TD150-40/4" },
  "24660": { intro2SeriesName: "TD", intro2ModelKey: "TD150-50/4" },
  "24663": { intro2SeriesName: "TD", intro2ModelKey: "TD200-24/4" },
  "24667": { intro2SeriesName: "TD", intro2ModelKey: "TD200-53/4" },
  "24668": { intro2SeriesName: "TD", intro2ModelKey: "TD200-12.5/4" },
  "24669": { intro2SeriesName: "TD", intro2ModelKey: "TD200-20/4" },
  "24670": { intro2SeriesName: "TD", intro2ModelKey: "TD200-23/4" },
  "24671": { intro2SeriesName: "TD", intro2ModelKey: "TD200-27/4" },
  "24672": { intro2SeriesName: "TD", intro2ModelKey: "TD200-32/4" },
  "24673": { intro2SeriesName: "TD", intro2ModelKey: "TD200-43/4" },
  "24674": { intro2SeriesName: "TD", intro2ModelKey: "TD200-50/4" },
  "24679": { intro2SeriesName: "TD", intro2ModelKey: "TD250-36/4" },
  "24682": { intro2SeriesName: "TD", intro2ModelKey: "TD250-12.5/4" },
  "24683": { intro2SeriesName: "TD", intro2ModelKey: "TD250-14/4" },
  "24684": { intro2SeriesName: "TD", intro2ModelKey: "TD250-17/4" },
  "24685": { intro2SeriesName: "TD", intro2ModelKey: "TD250-20/4" },
  "24686": { intro2SeriesName: "TD", intro2ModelKey: "TD250-26/4" },
  "24687": { intro2SeriesName: "TD", intro2ModelKey: "TD250-32/4" },
  "24688": { intro2SeriesName: "TD", intro2ModelKey: "TD250-40/4" },
  "24689": { intro2SeriesName: "TD", intro2ModelKey: "TD250-50/4" },
  "24690": { intro2SeriesName: "TD", intro2ModelKey: "TD300-15/4" },
  "24691": { intro2SeriesName: "TD", intro2ModelKey: "TD300-20/4" },
  "24692": { intro2SeriesName: "TD", intro2ModelKey: "TD300-25/4" },
  "24693": { intro2SeriesName: "TD", intro2ModelKey: "TD300-30/4" },
  "24694": { intro2SeriesName: "TD", intro2ModelKey: "TD300-35/4" },
  "24695": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "24696": { intro2SeriesName: "TD", intro2ModelKey: "TD300-55/4" },
  "25956": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x3" },
  "25957": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x4" },
  "25958": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x5" },
  "25959": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x6" },
  "25960": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x7" },
  "25961": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x8" },
  "25962": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x9" },
  "25963": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x10" },
  "25964": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x11" },
  "25965": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x12" },
  "25966": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x3" },
  "25967": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x4" },
  "25968": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x5" },
  "25969": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x6" },
  "25970": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x7" },
  "25971": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x8" },
  "25972": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x9" },
  "25973": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x10" },
  "25974": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x11" },
  "25975": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x12" },
  "25976": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x2" },
  "25977": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x3" },
  "25978": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x4" },
  "25979": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x5" },
  "25980": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x6" },
  "25981": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x7" },
  "25982": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x8" },
  "25983": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x9" },
  "25984": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x10" },
  "25985": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x11" },
  "25986": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x12" },
  "25987": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x3" },
  "25988": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x4" },
  "25989": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x5" },
  "25990": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x6" },
  "25991": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x7" },
  "25992": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x8" },
  "25993": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x9" },
  "25994": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x10" },
  "25995": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x3" },
  "25996": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x4" },
  "25997": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x5" },
  "25998": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x6" },
  "25999": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x7" },
  "26000": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x8" },
  "26001": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x9" },
  "26002": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x10" },
  "26003": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x11" },
  "26004": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x12" },
  "26005": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x3" },
  "26006": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x4" },
  "26007": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x5" },
  "26008": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x6" },
  "26009": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x7" },
  "26010": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x8" },
  "26011": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x9" },
  "26012": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x10" },
  "26013": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x11" },
  "26014": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x12" },
  "26015": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x3" },
  "26016": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x4" },
  "26017": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x5" },
  "26018": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x6" },
  "26019": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x7" },
  "26020": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x8" },
  "26021": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x9" },
  "26022": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x10" },
  "26023": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x3" },
  "26024": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x4" },
  "26025": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x5" },
  "26026": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x6" },
  "26027": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x7" },
  "26028": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x8" },
  "26029": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x9" },
  "26030": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x3" },
  "26031": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x4" },
  "26032": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x5" },
  "26033": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x6" },
  "26034": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x7" },
  "26035": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x8" },
  "26036": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x9" },
  "26037": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x2" },
  "26038": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x3" },
  "26039": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x4" },
  "26040": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x5" },
  "26041": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x6" },
  "26042": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x7" },
  "26043": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x8" },
  "26044": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x9" },
  "26046": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x2" },
  "26047": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x3" },
  "26048": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x4" },
  "26049": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x5" },
  "26050": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x6" },
  "26051": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x7" },
  "26052": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x8" },
  "26053": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x9" },
  "26054": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x10" },
  "26055": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x2" },
  "26056": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x3" },
  "26057": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x4" },
  "26058": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x5" },
  "26059": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x6" },
  "26060": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x7" },
  "26061": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x8" },
  "26062": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x9" },
  "26063": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x3" },
  "26064": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x4" },
  "26065": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x5" },
  "26066": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x6" },
  "26067": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x7" },
  "26068": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x8" },
  "26069": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x9" },
  "26070": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x2" },
  "26071": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x3" },
  "26072": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x4" },
  "26073": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x5" },
  "26074": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x6" },
  "26075": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x7" },
  "26076": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x8" },
  "26077": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x9" },
  "26078": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x10" },
  "26079": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x2" },
  "26080": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x3" },
  "26081": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x4" },
  "26082": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x5" },
  "26083": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x6" },
  "26084": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x7" },
  "26085": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x8" },
  "26086": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x9" },
  "26087": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x10" },
  "26098": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x3" },
  "26099": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x4" },
  "26100": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x5" },
  "26101": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x6" },
  "26102": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x7" },
  "26103": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x2" },
  "26104": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x3" },
  "26105": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x4" },
  "26106": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x5" },
  "26107": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x6" },
  "26108": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x7" },
  "26109": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x8" },
  "27544": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-90-4" },
  "27545": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-75-4" },
  "27627": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "27635": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-6(60hz)" },
  "27636": { intro2SeriesName: "TD", intro2ModelKey: "TD40-18/2" },
  "27637": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-250/25（60Hz）" },
  "27658": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-20/2（60Hz）" },
  "27659": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-30/3（60Hz）" },
  "27660": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-40/4（60Hz）" },
  "27661": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-50/5（60Hz）" },
  "27662": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-60/6（60Hz）" },
  "27663": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-70/7（60Hz）" },
  "27664": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-80/8（60Hz）" },
  "27665": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-90/9（60Hz）" },
  "27666": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-100/10（60Hz）" },
  "27667": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-110/11（60Hz）" },
  "27668": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-120/12（60Hz）" },
  "27669": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-130/13（60Hz）" },
  "27671": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-150/15（60Hz）" },
  "27673": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-170/17（60Hz）" },
  "27675": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-190/19（60Hz）" },
  "27677": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-210/21（60Hz）" },
  "27679": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-230/23（60Hz）" },
  "27682": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-270/27" },
  "27685": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-300/30" },
  "27688": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-330/33" },
  "27691": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-360/36" },
  "27692": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-20/2（60Hz）" },
  "27693": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-30/3（60Hz）" },
  "27694": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-40/4（60Hz）" },
  "27695": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-50/5（60Hz）" },
  "27696": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-60/6（60Hz）" },
  "27697": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-70/7（60Hz）" },
  "27699": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-90/9（60Hz）" },
  "27701": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-110/11（60Hz）" },
  "27703": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-130/13（60Hz）" },
  "27705": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-150/15（60Hz）" },
  "27708": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-180/18（60Hz）" },
  "27712": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-220/22" },
  "27716": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-260/26" },
  "27717": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-20/2（60Hz）" },
  "27718": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-30/3（60Hz）" },
  "27719": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-40/4（60Hz）" },
  "27720": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-50/5（60Hz）" },
  "27721": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-60/6（60Hz）" },
  "27722": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-70/7（60Hz）" },
  "27723": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-80/8（60Hz）" },
  "27724": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-90/9（60Hz）" },
  "27725": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-100/10（60Hz）" },
  "27726": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-110/11（60Hz）" },
  "27727": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-120/12（60Hz）" },
  "27728": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-130/13（60Hz）" },
  "27730": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-150/15（60Hz）" },
  "27732": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-170/17（60Hz）" },
  "27734": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-190/19（60Hz）" },
  "27736": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-210/21（60Hz）" },
  "27737": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "27738": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-230/23（60Hz）" },
  "27740": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-250/25（60Hz）" },
  "27742": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-270/27" },
  "27744": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-290/29" },
  "27746": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-310/31" },
  "27748": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-330/33" },
  "27751": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-360/36" },
  "27752": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-20/2（60Hz）" },
  "27753": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-30/3（60Hz）" },
  "27754": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-40/4（60Hz）" },
  "27755": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-50/5（60Hz）" },
  "27756": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-60/6（60Hz）" },
  "27757": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-70/7（60Hz）" },
  "27758": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-80/8（60Hz）" },
  "27760": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-100/10（60Hz）" },
  "27762": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-120/12（60Hz）" },
  "27764": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-140/14（60Hz）" },
  "27766": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-160/16（60Hz）" },
  "27769": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-190/19" },
  "27772": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "27773": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-20/2（60Hz）" },
  "27774": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-30/3（60Hz）" },
  "27775": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-40/4（60Hz）" },
  "27776": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-50/5（60Hz）" },
  "27777": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-60/6（60Hz）" },
  "27779": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-80/8（60Hz）" },
  "27781": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-100/10（60Hz）" },
  "27783": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-120/12（60Hz）" },
  "27785": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-140/14（60Hz）" },
  "27787": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-160/16" },
  "27789": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-180/18" },
  "27791": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-200/20" },
  "27792": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-20/2（60Hz）" },
  "27793": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-30/3（60Hz）" },
  "27794": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-40/4（60Hz）" },
  "27795": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-50/5（60Hz）" },
  "27796": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-60/6（60Hz）" },
  "27797": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-70/7（60Hz）" },
  "27798": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-80/8（60Hz）" },
  "27800": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-100/10（60Hz）" },
  "27802": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-120/12" },
  "27804": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-140/14" },
  "27806": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-160/16" },
  "27807": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-20/2（60Hz）" },
  "27808": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-30/3（60Hz）" },
  "27809": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-40/4（60Hz）" },
  "27810": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-50/5（60Hz）" },
  "27811": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-60/6（60Hz）" },
  "27812": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-70/7（60Hz）" },
  "27813": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-80/8（60Hz）" },
  "27815": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-100/10（60Hz）" },
  "27817": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-120/12" },
  "27819": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-140/14" },
  "27822": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-170/17" },
  "27824": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-10/1（60Hz）" },
  "27825": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "27826": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2（60Hz）" },
  "27827": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-30/3（60Hz）" },
  "27828": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-40/4（60Hz）" },
  "27829": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-50/5（60Hz）" },
  "27830": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-60/6（60Hz）" },
  "27831": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-70/7（60Hz）" },
  "27832": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-80/8（60Hz）" },
  "27833": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-90/9（60Hz）" },
  "27839": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1-1" },
  "27840": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1（60Hz）" },
  "27841": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "27842": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2（60Hz）" },
  "27843": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3-2" },
  "27844": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "27845": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4-2" },
  "27847": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5-2" },
  "27848": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5（60Hz）" },
  "27849": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6-2" },
  "27850": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6（60Hz）" },
  "27851": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7-2" },
  "27852": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7（60Hz）" },
  "27853": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8-2" },
  "27854": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8" },
  "27855": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9-2" },
  "27856": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9" },
  "27857": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10-2" },
  "27858": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10" },
  "27859": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-110/11-2" },
  "27860": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK 42-110/11" },
  "27861": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12-2" },
  "27862": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12" },
  "27863": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-130/13-2" },
  "28070": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "28071": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4（60Hz）" },
  "29097": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "29098": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "29163": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-70-2" },
  "29183": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-A" },
  "29300": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60-2" },
  "29352": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-5.5-2" },
  "29353": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-7.5-2" },
  "29354": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-11-2" },
  "29355": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-11-2" },
  "29356": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-15-2" },
  "29357": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-18.5-2" },
  "29358": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-1.5-2" },
  "29359": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-2.2-2" },
  "29360": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-3-2" },
  "29361": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-4-2" },
  "29362": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-3-2" },
  "29363": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-4-2" },
  "29364": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-5.5-2" },
  "29365": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-7.5-2" },
  "29366": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-5.5-2" },
  "29367": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-7.5-2" },
  "29368": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-11-2" },
  "29369": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-15-2" },
  "29370": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-18.5-2" },
  "29371": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-22-2" },
  "29372": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-22-2" },
  "29373": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-15-2" },
  "29374": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-30-2" },
  "29375": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-18.5-2" },
  "29376": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-37-2" },
  "29377": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-45-2" },
  "29378": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-22-2" },
  "29379": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-30-2" },
  "29381": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-3-2" },
  "29382": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-4-2" },
  "29383": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-37-2" },
  "29384": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-5.5-2" },
  "29385": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-7.5-2" },
  "29386": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-45-2" },
  "29387": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-55-2" },
  "29388": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-75-2" },
  "29391": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-7.5-2" },
  "29392": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-11-2" },
  "29398": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-11-2" },
  "29399": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-15-2" },
  "29401": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-18.5-2" },
  "29403": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-22-2" },
  "29405": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260H-30-2" },
  "29413": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-75-2" },
  "29418": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-7.5-2" },
  "29420": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-15-2" },
  "29421": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-18.5-2" },
  "29423": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-11-2" },
  "29424": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-15-2" },
  "29425": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-22-2" },
  "29426": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-18.5-2" },
  "29432": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200H-30-2" },
  "29433": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-30-2" },
  "29434": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-37-2" },
  "29436": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-37-2" },
  "29437": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-45-2" },
  "29438": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-45-2" },
  "29439": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-55-2" },
  "29440": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-45-2" },
  "29441": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-55-2" },
  "29442": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-75-2" },
  "29446": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320H-90-2" },
  "29447": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-75-2" },
  "29448": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320H-90-2" },
  "29449": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-130-0.55-4" },
  "29450": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-160-0.55-4" },
  "29451": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-0.75-4" },
  "29452": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-200-1.1-4" },
  "29453": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-2.2-4" },
  "29454": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-130-0.55-4" },
  "29455": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.55-4" },
  "29456": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-0.75-4" },
  "29457": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-160-1.1-4" },
  "29458": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-0.75-4" },
  "29459": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-75-4" },
  "29460": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-11-4" },
  "29461": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.1-4" },
  "29462": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-15-4" },
  "29463": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-200-18.5-4" },
  "29464": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-18.5-4" },
  "29465": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-1.5-4" },
  "29466": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-22-4" },
  "29467": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-260-30-4" },
  "29468": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-30-4" },
  "29469": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-37-4" },
  "29470": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-45-4" },
  "29471": { intro2SeriesName: "NESO", intro2ModelKey: "NES50-32-260-3-4" },
  "29472": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-160-2.2-4" },
  "29473": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-2.2-4" },
  "29474": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.1-4" },
  "29475": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-3-4" },
  "29476": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-200-1.5-4" },
  "29477": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-1.5-4" },
  "29478": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-2.2-4" },
  "29479": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-4-4" },
  "29480": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-260-3-4" },
  "29481": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-3-4" },
  "29482": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-4-4" },
  "29483": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-4-4" },
  "29484": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-5.5-4" },
  "29485": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-5.5-4" },
  "29486": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-40-320-7.5-4" },
  "29487": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-7.5-4" },
  "29488": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-7.5-4" },
  "29489": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-11-4" },
  "29490": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-320-15-4" },
  "29491": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-1.5-4" },
  "29492": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-2.2-4" },
  "29493": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-160-3-4" },
  "29494": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-3-4" },
  "29495": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-320-55-4" },
  "29496": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-45-4" },
  "29497": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-55-4" },
  "29498": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-75-4" },
  "29499": { intro2SeriesName: "NESO", intro2ModelKey: "NES200-150-400-90-4" },
  "29500": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-22-4" },
  "29501": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-260-30-4" },
  "29502": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-37-4" },
  "29503": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-45-4" },
  "29504": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-55-4" },
  "29505": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-320-75-4" },
  "29506": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-55-4" },
  "29507": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-75-4" },
  "29508": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-90-4" },
  "29509": { intro2SeriesName: "NESO", intro2ModelKey: "NES250-200-400-110-4" },
  "29510": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-55-4" },
  "29511": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-75-4" },
  "29512": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-90-4" },
  "29513": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-110-4" },
  "29514": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-400-132-4" },
  "29515": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-4-4" },
  "29516": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-200-5.5-4" },
  "29517": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-7.5-4" },
  "29518": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-260-11-4" },
  "29519": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-11-4" },
  "29520": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-320-15-4" },
  "29521": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-18.5-4" },
  "29522": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-22-4" },
  "29523": { intro2SeriesName: "NESO", intro2ModelKey: "NES100-80-400-30-4" },
  "29524": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-2.2-4" },
  "29525": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-160-3-4" },
  "29526": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-5.5-4" },
  "29527": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-200-7.5-4" },
  "29528": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-11-4" },
  "29529": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-260-15-4" },
  "29530": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-15-4" },
  "29531": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-18.5-4" },
  "29532": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-22-4" },
  "29533": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-320-30-4" },
  "29534": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-22-4" },
  "29535": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-30-4" },
  "29536": { intro2SeriesName: "NESO", intro2ModelKey: "NES125-100-400-37-4" },
  "29537": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-7.5-4" },
  "29538": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-200-11-4" },
  "29539": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-15-4" },
  "29540": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-18.5-4" },
  "29541": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.55-4" },
  "29542": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-22-4" },
  "29543": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-0.75-4" },
  "29544": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-260-30-4" },
  "29545": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-18.5-4" },
  "29546": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-130-1.1-4" },
  "29547": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-22-4" },
  "29548": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-320-30-4" },
  "29549": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-37-4" },
  "29550": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-0.75-4" },
  "29551": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-45-4" },
  "29552": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.1-4" },
  "29553": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-160-1.5-4" },
  "29554": { intro2SeriesName: "NESO", intro2ModelKey: "NES150-125-400-55-4" },
  "29555": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.1-4" },
  "29556": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-1.5-4" },
  "29557": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-200-2.2-4" },
  "29558": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-3-4" },
  "29559": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-4-4" },
  "29560": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-5.5-4" },
  "29561": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-5.5-4" },
  "29562": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-7.5-4" },
  "29563": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-320-11-4" },
  "29564": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-0.75-4" },
  "29565": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-130-1.1-4" },
  "30103": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-20" },
  "30113": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-30" },
  "30138": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-20" },
  "30163": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-20" },
  "30173": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-30" },
  "30198": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-20" },
  "30220": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-20" },
  "30221": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-1(60hz)" },
  "30222": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-2(60hz)" },
  "30223": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-3(60hz)" },
  "30224": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-4(60hz)" },
  "30225": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-5(60hz)" },
  "30226": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-6(60hz)" },
  "30227": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-7(60hz)" },
  "30228": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-8(60hz)" },
  "30229": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-9(60hz)" },
  "30230": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-10" },
  "30232": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-12(60hz)" },
  "30234": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-14(60hz)" },
  "30236": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-16(60hz)" },
  "30240": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-20" },
  "30260": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-1(60hz)" },
  "30261": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-2(60hz)" },
  "30262": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-3(60hz)" },
  "30263": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-4(60hz)" },
  "30264": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-5(60hz)" },
  "30265": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-6(60hz)" },
  "30266": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-7(60hz)" },
  "30267": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-8(60hz)" },
  "30268": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-9(60hz)" },
  "30269": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-10(60hz)" },
  "30271": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-12(60hz)" },
  "30302": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-100" },
  "30310": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-10-1" },
  "30311": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-210" },
  "30312": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20-2" },
  "30313": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20" },
  "30314": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-230" },
  "30315": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-40" },
  "30316": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-250" },
  "30317": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60" },
  "30318": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-270" },
  "30319": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-80" },
  "30320": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-290" },
  "30321": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-100" },
  "30322": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-110" },
  "30323": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-120" },
  "30324": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-130" },
  "30325": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-140" },
  "30326": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150-2" },
  "30327": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-150" },
  "30328": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160-2" },
  "30329": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-160" },
  "30330": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10-1(60hz)" },
  "30331": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-10(60hz)" },
  "30332": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-20-2(60hz)" },
  "30333": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-220" },
  "30334": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30-2(60hz)" },
  "30335": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-30(60hz)" },
  "30336": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40-2(60hz)" },
  "30337": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-40(60hz)" },
  "30338": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50-2(60hz)" },
  "30339": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-50(60hz)" },
  "30340": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60-2(60hz)" },
  "30341": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-60(60hz)" },
  "30342": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70-2(60hz)" },
  "30343": { intro2SeriesName: "CDL", intro2ModelKey: "CDL42-70(60hz)" },
  "30389": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-10" },
  "30390": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-2" },
  "30391": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-1" },
  "30392": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20" },
  "30393": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-2" },
  "30394": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-1" },
  "30395": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30" },
  "30396": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-2" },
  "30397": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-1" },
  "30398": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40" },
  "30399": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-2" },
  "30400": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-1" },
  "30401": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50" },
  "30402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-2" },
  "30403": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60-1" },
  "30404": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-60" },
  "30405": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-2" },
  "30406": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70-1" },
  "30407": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-70" },
  "30408": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10-1" },
  "30409": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10" },
  "30410": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-2" },
  "30411": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-1" },
  "30412": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20" },
  "30413": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-2" },
  "30414": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-1" },
  "30415": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30" },
  "30416": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-2" },
  "30417": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-1" },
  "30418": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40" },
  "30419": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-2" },
  "30420": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50-1" },
  "30421": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-50" },
  "30422": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-2" },
  "30423": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60-1" },
  "30424": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-60" },
  "30425": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-B" },
  "30426": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-A" },
  "30427": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10" },
  "30428": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2B" },
  "30429": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2A" },
  "30430": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20" },
  "30431": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2B" },
  "30432": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A-B" },
  "30433": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2A" },
  "30434": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-B" },
  "30435": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A" },
  "30436": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30" },
  "30437": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2B" },
  "30438": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-2A" },
  "30439": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40-A" },
  "30440": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-40" },
  "30445": { intro2SeriesName: "TD", intro2ModelKey: "TD32-18/2" },
  "30446": { intro2SeriesName: "TD", intro2ModelKey: "TD32-21/2" },
  "30447": { intro2SeriesName: "TD", intro2ModelKey: "TD32-25/2" },
  "30448": { intro2SeriesName: "TD", intro2ModelKey: "TD32-32/2" },
  "30449": { intro2SeriesName: "TD", intro2ModelKey: "TD32-38/2" },
  "30450": { intro2SeriesName: "TD", intro2ModelKey: "TD32-50/2" },
  "30451": { intro2SeriesName: "TD", intro2ModelKey: "TD40-16/2" },
  "30452": { intro2SeriesName: "TD", intro2ModelKey: "TD40-20/2" },
  "30453": { intro2SeriesName: "TD", intro2ModelKey: "TD40-18/2" },
  "30454": { intro2SeriesName: "TD", intro2ModelKey: "TD40-25/2" },
  "30455": { intro2SeriesName: "TD", intro2ModelKey: "TD40-30/2" },
  "30456": { intro2SeriesName: "TD", intro2ModelKey: "TD40-36/2" },
  "30457": { intro2SeriesName: "TD", intro2ModelKey: "TD40-48/2" },
  "30458": { intro2SeriesName: "TD", intro2ModelKey: "TD50-12/2" },
  "30459": { intro2SeriesName: "TD", intro2ModelKey: "TD50-15/2" },
  "30460": { intro2SeriesName: "TD", intro2ModelKey: "TD50-18/2" },
  "30461": { intro2SeriesName: "TD", intro2ModelKey: "TD50-24/2" },
  "30462": { intro2SeriesName: "TD", intro2ModelKey: "TD50-28/2" },
  "30463": { intro2SeriesName: "TD", intro2ModelKey: "TD50-32/2" },
  "30464": { intro2SeriesName: "TD", intro2ModelKey: "TD50-38/2" },
  "30465": { intro2SeriesName: "TD", intro2ModelKey: "TD50-48/2" },
  "30468": { intro2SeriesName: "TD", intro2ModelKey: "TD50-35/2" },
  "30469": { intro2SeriesName: "TD", intro2ModelKey: "TD50-40/2" },
  "30470": { intro2SeriesName: "TD", intro2ModelKey: "TD50-50/2" },
  "30471": { intro2SeriesName: "TD", intro2ModelKey: "TD50-60/2" },
  "30472": { intro2SeriesName: "TD", intro2ModelKey: "TD50-70/2" },
  "30473": { intro2SeriesName: "TD", intro2ModelKey: "TD50-81/2" },
  "30474": { intro2SeriesName: "TD", intro2ModelKey: "TD65-15/2" },
  "30475": { intro2SeriesName: "TD", intro2ModelKey: "TD65-19/2" },
  "30476": { intro2SeriesName: "TD", intro2ModelKey: "TD65-22/2" },
  "30477": { intro2SeriesName: "TD", intro2ModelKey: "TD65-30/2" },
  "30478": { intro2SeriesName: "TD", intro2ModelKey: "TD65-36/2" },
  "30479": { intro2SeriesName: "TD", intro2ModelKey: "TD65-34/2" },
  "30480": { intro2SeriesName: "TD", intro2ModelKey: "TD65-40/2" },
  "30481": { intro2SeriesName: "TD", intro2ModelKey: "TD65-48/2" },
  "30482": { intro2SeriesName: "TD", intro2ModelKey: "TD65-50/2" },
  "30483": { intro2SeriesName: "TD", intro2ModelKey: "TD65-61/2" },
  "30484": { intro2SeriesName: "TD", intro2ModelKey: "TD65-67/2" },
  "30485": { intro2SeriesName: "TD", intro2ModelKey: "TD65-83/2" },
  "30486": { intro2SeriesName: "TD", intro2ModelKey: "TD80-13/2" },
  "30487": { intro2SeriesName: "TD", intro2ModelKey: "TD80-18/2" },
  "30488": { intro2SeriesName: "TD", intro2ModelKey: "TD80-22/2" },
  "30489": { intro2SeriesName: "TD", intro2ModelKey: "TD80-28/2" },
  "30490": { intro2SeriesName: "TD", intro2ModelKey: "TD80-30/2" },
  "30491": { intro2SeriesName: "TD", intro2ModelKey: "TD80-38/2" },
  "30492": { intro2SeriesName: "TD", intro2ModelKey: "TD80-40/2" },
  "30493": { intro2SeriesName: "TD", intro2ModelKey: "TD80-48/2" },
  "30494": { intro2SeriesName: "TD", intro2ModelKey: "TD80-47/2" },
  "30495": { intro2SeriesName: "TD", intro2ModelKey: "TD80-54/2" },
  "30496": { intro2SeriesName: "TD", intro2ModelKey: "TD80-67/2" },
  "30497": { intro2SeriesName: "TD", intro2ModelKey: "TD100-9/2" },
  "30498": { intro2SeriesName: "TD", intro2ModelKey: "TD100-15/2" },
  "30499": { intro2SeriesName: "TD", intro2ModelKey: "TD100-17/2" },
  "30500": { intro2SeriesName: "TD", intro2ModelKey: "TD100-22/2" },
  "30501": { intro2SeriesName: "TD", intro2ModelKey: "TD100-27/2" },
  "30502": { intro2SeriesName: "TD", intro2ModelKey: "TD100-33/2" },
  "30503": { intro2SeriesName: "TD", intro2ModelKey: "TD100-40/2" },
  "30504": { intro2SeriesName: "TD", intro2ModelKey: "TD100-48/2" },
  "30505": { intro2SeriesName: "TD", intro2ModelKey: "TD100-52/2" },
  "30506": { intro2SeriesName: "TD", intro2ModelKey: "TD125-11/4" },
  "30507": { intro2SeriesName: "TD", intro2ModelKey: "TD125-14/4" },
  "30508": { intro2SeriesName: "TD", intro2ModelKey: "TD125-18/4" },
  "30509": { intro2SeriesName: "TD", intro2ModelKey: "TD125-22/4" },
  "30510": { intro2SeriesName: "TD", intro2ModelKey: "TD125-28/4" },
  "30511": { intro2SeriesName: "TD", intro2ModelKey: "TD125-32/4" },
  "30512": { intro2SeriesName: "TD", intro2ModelKey: "TD125-40/4" },
  "30513": { intro2SeriesName: "TD", intro2ModelKey: "TD125-48/4" },
  "30514": { intro2SeriesName: "TD", intro2ModelKey: "TD150-12.5/4" },
  "30515": { intro2SeriesName: "TD", intro2ModelKey: "TD150-17/4" },
  "30516": { intro2SeriesName: "TD", intro2ModelKey: "TD150-21/4" },
  "30517": { intro2SeriesName: "TD", intro2ModelKey: "TD150-25/4" },
  "30518": { intro2SeriesName: "TD", intro2ModelKey: "TD150-33/4" },
  "30519": { intro2SeriesName: "TD", intro2ModelKey: "TD150-40/4" },
  "30520": { intro2SeriesName: "TD", intro2ModelKey: "TD150-50/4" },
  "30523": { intro2SeriesName: "TD", intro2ModelKey: "TD200-24/4" },
  "30527": { intro2SeriesName: "TD", intro2ModelKey: "TD200-53/4" },
  "30528": { intro2SeriesName: "TD", intro2ModelKey: "TD200-12.5/4" },
  "30529": { intro2SeriesName: "TD", intro2ModelKey: "TD200-20/4" },
  "30530": { intro2SeriesName: "TD", intro2ModelKey: "TD200-23/4" },
  "30531": { intro2SeriesName: "TD", intro2ModelKey: "TD200-27/4" },
  "30532": { intro2SeriesName: "TD", intro2ModelKey: "TD200-32/4" },
  "30533": { intro2SeriesName: "TD", intro2ModelKey: "TD200-43/4" },
  "30534": { intro2SeriesName: "TD", intro2ModelKey: "TD200-50/4" },
  "30539": { intro2SeriesName: "TD", intro2ModelKey: "TD250-36/4" },
  "30542": { intro2SeriesName: "TD", intro2ModelKey: "TD250-12.5/4" },
  "30543": { intro2SeriesName: "TD", intro2ModelKey: "TD250-14/4" },
  "30544": { intro2SeriesName: "TD", intro2ModelKey: "TD250-17/4" },
  "30545": { intro2SeriesName: "TD", intro2ModelKey: "TD250-20/4" },
  "30546": { intro2SeriesName: "TD", intro2ModelKey: "TD250-26/4" },
  "30547": { intro2SeriesName: "TD", intro2ModelKey: "TD250-32/4" },
  "30548": { intro2SeriesName: "TD", intro2ModelKey: "TD250-40/4" },
  "30549": { intro2SeriesName: "TD", intro2ModelKey: "TD250-50/4" },
  "30550": { intro2SeriesName: "TD", intro2ModelKey: "TD300-15/4" },
  "30551": { intro2SeriesName: "TD", intro2ModelKey: "TD300-20/4" },
  "30552": { intro2SeriesName: "TD", intro2ModelKey: "TD300-25/4" },
  "30553": { intro2SeriesName: "TD", intro2ModelKey: "TD300-30/4" },
  "30554": { intro2SeriesName: "TD", intro2ModelKey: "TD300-35/4" },
  "30555": { intro2SeriesName: "TD", intro2ModelKey: "TD300-44/4" },
  "30556": { intro2SeriesName: "TD", intro2ModelKey: "TD300-55/4" },
  "31076": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-11/2" },
  "31816": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x3" },
  "31817": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x4" },
  "31818": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x5" },
  "31819": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x6" },
  "31820": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x7" },
  "31821": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x8" },
  "31822": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x9" },
  "31823": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x10" },
  "31824": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x11" },
  "31825": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x12" },
  "31826": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x3" },
  "31827": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x4" },
  "31828": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x5" },
  "31829": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x6" },
  "31830": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x7" },
  "31831": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x8" },
  "31832": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x9" },
  "31833": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x10" },
  "31834": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x11" },
  "31835": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x12" },
  "31836": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x2" },
  "31837": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x3" },
  "31838": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x4" },
  "31839": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x5" },
  "31840": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x6" },
  "31841": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x7" },
  "31842": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x8" },
  "31843": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x9" },
  "31844": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x10" },
  "31845": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x11" },
  "31846": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x12" },
  "31847": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x3" },
  "31848": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x4" },
  "31849": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x5" },
  "31850": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x6" },
  "31851": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x7" },
  "31852": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x8" },
  "31853": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x9" },
  "31854": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x10" },
  "31855": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x3" },
  "31856": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x4" },
  "31857": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x5" },
  "31858": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x6" },
  "31859": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x7" },
  "31860": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x8" },
  "31861": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x9" },
  "31862": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x10" },
  "31863": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x11" },
  "31864": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x12" },
  "31865": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x3" },
  "31866": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x4" },
  "31867": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x5" },
  "31868": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x6" },
  "31869": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x7" },
  "31870": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x8" },
  "31871": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x9" },
  "31872": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x10" },
  "31873": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x11" },
  "31874": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x12" },
  "31875": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x3" },
  "31876": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x4" },
  "31877": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x5" },
  "31878": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x6" },
  "31879": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x7" },
  "31880": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x8" },
  "31881": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x9" },
  "31882": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x10" },
  "31883": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x3" },
  "31884": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x4" },
  "31885": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x5" },
  "31886": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x6" },
  "31887": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x7" },
  "31888": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x8" },
  "31889": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x9" },
  "31890": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x3" },
  "31891": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x4" },
  "31892": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x5" },
  "31893": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x6" },
  "31894": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x7" },
  "31895": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x8" },
  "31896": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x9" },
  "31897": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x2" },
  "31898": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x3" },
  "31899": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x4" },
  "31900": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x5" },
  "31901": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x6" },
  "31902": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x7" },
  "31903": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x8" },
  "31904": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x9" },
  "31906": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x2" },
  "31907": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x3" },
  "31908": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x4" },
  "31909": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x5" },
  "31910": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x6" },
  "31911": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x7" },
  "31912": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x8" },
  "31913": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x9" },
  "31914": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x10" },
  "31915": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x2" },
  "31916": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x3" },
  "31917": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x4" },
  "31918": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x5" },
  "31919": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x6" },
  "31920": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x7" },
  "31921": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x8" },
  "31922": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x9" },
  "31923": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x3" },
  "31924": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x4" },
  "31925": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x5" },
  "31926": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x6" },
  "31927": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x7" },
  "31928": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x8" },
  "31929": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x9" },
  "31930": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x2" },
  "31931": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x3" },
  "31932": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x4" },
  "31933": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x5" },
  "31934": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x6" },
  "31935": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x7" },
  "31936": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x8" },
  "31937": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x9" },
  "31938": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x10" },
  "31939": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x2" },
  "31940": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x3" },
  "31941": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x4" },
  "31942": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x5" },
  "31943": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x6" },
  "31944": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x7" },
  "31945": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x8" },
  "31946": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x9" },
  "31947": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x10" },
  "31958": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x3" },
  "31959": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x4" },
  "31960": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x5" },
  "31961": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x6" },
  "31962": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x7" },
  "31963": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x2" },
  "31964": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x3" },
  "31965": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x4" },
  "31966": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x5" },
  "31967": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x6" },
  "31968": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x7" },
  "31969": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x8" },
  "33404": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-90-4" },
  "33405": { intro2SeriesName: "NESO", intro2ModelKey: "NES300-250-320-75-4" },
  "33471": { intro2SeriesName: "SMA", intro2ModelKey: "350x300-400-250/4" },
  "33497": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-250/25（60Hz）" },
  "33518": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-20/2（60Hz）" },
  "33519": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-30/3（60Hz）" },
  "33520": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-40/4（60Hz）" },
  "33521": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-50/5（60Hz）" },
  "33522": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-60/6（60Hz）" },
  "33523": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-70/7（60Hz）" },
  "33524": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-80/8（60Hz）" },
  "33525": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-90/9（60Hz）" },
  "33526": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-100/10（60Hz）" },
  "33527": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-110/11（60Hz）" },
  "33528": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-120/12（60Hz）" },
  "33529": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-130/13（60Hz）" },
  "33531": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-150/15（60Hz）" },
  "33533": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-170/17（60Hz）" },
  "33535": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-190/19（60Hz）" },
  "33537": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-210/21（60Hz）" },
  "33539": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-230/23（60Hz）" },
  "33542": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-270/27" },
  "33545": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-300/30" },
  "33548": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-330/33" },
  "33551": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK1-360/36" },
  "33552": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-20/2（60Hz）" },
  "33553": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-30/3（60Hz）" },
  "33554": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-40/4（60Hz）" },
  "33555": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-50/5（60Hz）" },
  "33556": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-60/6（60Hz）" },
  "33557": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-70/7（60Hz）" },
  "33559": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-90/9（60Hz）" },
  "33561": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-110/11（60Hz）" },
  "33563": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-130/13（60Hz）" },
  "33565": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-150/15（60Hz）" },
  "33568": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-180/18（60Hz）" },
  "33572": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-220/22" },
  "33576": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK2-260/26" },
  "33577": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-20/2（60Hz）" },
  "33578": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-30/3（60Hz）" },
  "33579": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-40/4（60Hz）" },
  "33580": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-50/5（60Hz）" },
  "33581": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-60/6（60Hz）" },
  "33582": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-70/7（60Hz）" },
  "33583": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-80/8（60Hz）" },
  "33584": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-90/9（60Hz）" },
  "33585": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-100/10（60Hz）" },
  "33586": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-110/11（60Hz）" },
  "33587": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-120/12（60Hz）" },
  "33588": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-130/13（60Hz）" },
  "33590": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-150/15（60Hz）" },
  "33592": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-170/17（60Hz）" },
  "33594": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-190/19（60Hz）" },
  "33596": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-210/21（60Hz）" },
  "33597": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "33598": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-230/23（60Hz）" },
  "33600": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-250/25（60Hz）" },
  "33602": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-270/27" },
  "33604": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-290/29" },
  "33606": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-310/31" },
  "33608": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-330/33" },
  "33611": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK3-360/36" },
  "33612": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-20/2（60Hz）" },
  "33613": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-30/3（60Hz）" },
  "33614": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-40/4（60Hz）" },
  "33615": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-50/5（60Hz）" },
  "33616": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-60/6（60Hz）" },
  "33617": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-70/7（60Hz）" },
  "33618": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-80/8（60Hz）" },
  "33620": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-100/10（60Hz）" },
  "33622": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-120/12（60Hz）" },
  "33624": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-140/14（60Hz）" },
  "33626": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-160/16（60Hz）" },
  "33629": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK4-190/19" },
  "33632": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "33633": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-20/2（60Hz）" },
  "33634": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-30/3（60Hz）" },
  "33635": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-40/4（60Hz）" },
  "33636": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-50/5（60Hz）" },
  "33637": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-60/6（60Hz）" },
  "33639": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-80/8（60Hz）" },
  "33641": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-100/10（60Hz）" },
  "33643": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-120/12（60Hz）" },
  "33645": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-140/14（60Hz）" },
  "33647": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-160/16" },
  "33649": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-180/18" },
  "33651": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK8-200/20" },
  "33652": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-20/2（60Hz）" },
  "33653": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-30/3（60Hz）" },
  "33654": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-40/4（60Hz）" },
  "33655": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-50/5（60Hz）" },
  "33656": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-60/6（60Hz）" },
  "33657": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-70/7（60Hz）" },
  "33658": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-80/8（60Hz）" },
  "33660": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-100/10（60Hz）" },
  "33662": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-120/12" },
  "33664": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-140/14" },
  "33666": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK16-160/16" },
  "33667": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-20/2（60Hz）" },
  "33668": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-30/3（60Hz）" },
  "33669": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-40/4（60Hz）" },
  "33670": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-50/5（60Hz）" },
  "33671": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-60/6（60Hz）" },
  "33672": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-70/7（60Hz）" },
  "33673": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-80/8（60Hz）" },
  "33675": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-100/10（60Hz）" },
  "33677": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-120/12" },
  "33679": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-140/14" },
  "33682": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK20-170/17" },
  "33684": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-10/1（60Hz）" },
  "33685": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2-2" },
  "33686": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-20/2（60Hz）" },
  "33687": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-30/3（60Hz）" },
  "33688": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-40/4（60Hz）" },
  "33689": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-50/5（60Hz）" },
  "33690": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-60/6（60Hz）" },
  "33691": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-70/7（60Hz）" },
  "33692": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-80/8（60Hz）" },
  "33693": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK32-90/9（60Hz）" },
  "33699": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1-1" },
  "33700": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-10/1（60Hz）" },
  "33701": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2-2（60Hz）" },
  "33702": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-20/2（60Hz）" },
  "33703": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3-2" },
  "33704": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "33705": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4-2" },
  "33707": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5-2" },
  "33708": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-50/5（60Hz）" },
  "33709": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6-2" },
  "33710": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-60/6（60Hz）" },
  "33711": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7-2" },
  "33712": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-70/7（60Hz）" },
  "33713": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8-2" },
  "33714": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-80/8" },
  "33715": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9-2" },
  "33716": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-90/9" },
  "33717": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10-2" },
  "33718": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-100/10" },
  "33719": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-110/11-2" },
  "33720": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK 42-110/11" },
  "33721": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12-2" },
  "33722": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-120/12" },
  "33723": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-130/13-2" },
  "33930": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-30/3（60Hz）" },
  "33931": { intro2SeriesName: "CDLK", intro2ModelKey: "CDLK42-40/4（60Hz）" },
  "35023": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-70-2" },
  "35043": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-A" },
  "35160": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60-2" },
  "35171": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-90-2" },
  "35174": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-200-2.2/4" },
  "35182": { intro2SeriesName: "SMA", intro2ModelKey: "80x65-160-7.5/2" },
  "35183": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-4/4" },
  "35195": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-3/4" },
  "35196": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-22/2" },
  "35197": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-110/2" },
  "35198": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-1.5/4" },
  "35199": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-22/2" },
  "35204": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-37/2" },
  "35230": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-132/2" },
  "35261": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-200-2.2/4" },
  "35325": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-8(60hz)" },
  "35381": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-200/2" },
  "35387": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-80-2" },
  "35400": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-200-7.5/2" },
  "35401": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-200-11/2" },
  "35407": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-200-37/4" },
  "35417": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-132/2" },
  "35419": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-200-18.5/4" },
  "35436": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-110/2" },
  "35448": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-30/2" },
  "35479": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-250-75/4" },
  "35500": { intro2SeriesName: "SMA", intro2ModelKey: "350x300-400-160/4" },
  "35502": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-250-22/2" },
  "35516": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-8(60hz)" },
  "35524": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-5.5/2" },
  "35525": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-11/4" },
  "35529": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-160-0.55/4" },
  "35540": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-2.2/4" },
  "35550": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-500-90/4" },
  "35558": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-7.5/4" },
  "35569": { intro2SeriesName: "SMA", intro2ModelKey: "80x50-315-5.5/4" },
  "35574": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-160/2" },
  "35579": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-0.75/4" },
  "35585": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x10" },
  "35593": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-200-18.5/2" },
  "35679": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-0.75/4" },
  "35949": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-500-250/4" },
  "35973": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-30-2" },
  "36107": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-220/4" },
  "36251": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-400-185/4" },
  "36270": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x2" },
  "36271": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x3" },
  "36272": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x4" },
  "36273": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x5" },
  "36274": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x6" },
  "36275": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x7" },
  "36276": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x8" },
  "36277": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x9" },
  "36278": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x10" },
  "36279": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x11" },
  "36280": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x12" },
  "36281": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x9" },
  "36282": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x8" },
  "36283": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x9" },
  "36284": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x10" },
  "36285": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x10" },
  "36292": { intro2SeriesName: "AS", intro2ModelKey: "1-20" },
  "36293": { intro2SeriesName: "AS", intro2ModelKey: "1-30" },
  "36294": { intro2SeriesName: "AS", intro2ModelKey: "1-40" },
  "36295": { intro2SeriesName: "AS", intro2ModelKey: "1-50" },
  "36296": { intro2SeriesName: "AS", intro2ModelKey: "1-60" },
  "36297": { intro2SeriesName: "AS", intro2ModelKey: "1-70" },
  "36298": { intro2SeriesName: "AS", intro2ModelKey: "1-80" },
  "36299": { intro2SeriesName: "AS", intro2ModelKey: "1-90" },
  "36300": { intro2SeriesName: "AS", intro2ModelKey: "1-100" },
  "36301": { intro2SeriesName: "AS", intro2ModelKey: "1-110" },
  "36302": { intro2SeriesName: "AS", intro2ModelKey: "1-120" },
  "36303": { intro2SeriesName: "AS", intro2ModelKey: "1-130" },
  "36305": { intro2SeriesName: "AS", intro2ModelKey: "1-150" },
  "36307": { intro2SeriesName: "AS", intro2ModelKey: "1-170" },
  "36311": { intro2SeriesName: "AS", intro2ModelKey: "1-210" },
  "36312": { intro2SeriesName: "AS", intro2ModelKey: "12-20" },
  "36313": { intro2SeriesName: "AS", intro2ModelKey: "1-230" },
  "36314": { intro2SeriesName: "AS", intro2ModelKey: "12-40" },
  "36315": { intro2SeriesName: "AS", intro2ModelKey: "1-250" },
  "36316": { intro2SeriesName: "AS", intro2ModelKey: "12-60" },
  "36317": { intro2SeriesName: "AS", intro2ModelKey: "1-270" },
  "36318": { intro2SeriesName: "AS", intro2ModelKey: "12-80" },
  "36319": { intro2SeriesName: "AS", intro2ModelKey: "12-90" },
  "36320": { intro2SeriesName: "AS", intro2ModelKey: "1-300" },
  "36323": { intro2SeriesName: "AS", intro2ModelKey: "1-330" },
  "36325": { intro2SeriesName: "AS", intro2ModelKey: "1-350" },
  "36326": { intro2SeriesName: "AS", intro2ModelKey: "1-360" },
  "36327": { intro2SeriesName: "AS", intro2ModelKey: "2-20" },
  "36328": { intro2SeriesName: "AS", intro2ModelKey: "2-30" },
  "36329": { intro2SeriesName: "AS", intro2ModelKey: "2-40" },
  "36330": { intro2SeriesName: "AS", intro2ModelKey: "2-50" },
  "36331": { intro2SeriesName: "AS", intro2ModelKey: "2-60" },
  "36332": { intro2SeriesName: "AS", intro2ModelKey: "2-70" },
  "36333": { intro2SeriesName: "AS", intro2ModelKey: "2-80" },
  "36334": { intro2SeriesName: "AS", intro2ModelKey: "2-90" },
  "36335": { intro2SeriesName: "AS", intro2ModelKey: "2-100" },
  "36336": { intro2SeriesName: "AS", intro2ModelKey: "2-110" },
  "36337": { intro2SeriesName: "AS", intro2ModelKey: "2-120" },
  "36338": { intro2SeriesName: "AS", intro2ModelKey: "2-130" },
  "36339": { intro2SeriesName: "AS", intro2ModelKey: "2-140" },
  "36340": { intro2SeriesName: "AS", intro2ModelKey: "2-150" },
  "36341": { intro2SeriesName: "AS", intro2ModelKey: "2-160" },
  "36342": { intro2SeriesName: "AS", intro2ModelKey: "2-170" },
  "36343": { intro2SeriesName: "AS", intro2ModelKey: "2-180" },
  "36344": { intro2SeriesName: "AS", intro2ModelKey: "2-190" },
  "36345": { intro2SeriesName: "AS", intro2ModelKey: "2-200" },
  "36346": { intro2SeriesName: "AS", intro2ModelKey: "2-210" },
  "36347": { intro2SeriesName: "AS", intro2ModelKey: "2-220" },
  "36348": { intro2SeriesName: "AS", intro2ModelKey: "2-230" },
  "36349": { intro2SeriesName: "AS", intro2ModelKey: "2-240" },
  "36350": { intro2SeriesName: "AS", intro2ModelKey: "2-250" },
  "36351": { intro2SeriesName: "AS", intro2ModelKey: "2-260" },
  "36352": { intro2SeriesName: "AS", intro2ModelKey: "2-270" },
  "36353": { intro2SeriesName: "AS", intro2ModelKey: "2-280" },
  "36354": { intro2SeriesName: "AS", intro2ModelKey: "2-290" },
  "36355": { intro2SeriesName: "AS", intro2ModelKey: "2-300" },
  "36356": { intro2SeriesName: "AS", intro2ModelKey: "2-310" },
  "36357": { intro2SeriesName: "AS", intro2ModelKey: "2-320" },
  "36358": { intro2SeriesName: "AS", intro2ModelKey: "3-20" },
  "36359": { intro2SeriesName: "AS", intro2ModelKey: "3-30" },
  "36360": { intro2SeriesName: "AS", intro2ModelKey: "3-40" },
  "36361": { intro2SeriesName: "AS", intro2ModelKey: "3-50" },
  "36362": { intro2SeriesName: "AS", intro2ModelKey: "3-60" },
  "36363": { intro2SeriesName: "AS", intro2ModelKey: "3-70" },
  "36364": { intro2SeriesName: "AS", intro2ModelKey: "3-80" },
  "36365": { intro2SeriesName: "AS", intro2ModelKey: "3-90" },
  "36366": { intro2SeriesName: "AS", intro2ModelKey: "3-100" },
  "36367": { intro2SeriesName: "AS", intro2ModelKey: "3-110" },
  "36368": { intro2SeriesName: "AS", intro2ModelKey: "3-120" },
  "36370": { intro2SeriesName: "AS", intro2ModelKey: "3-140" },
  "36372": { intro2SeriesName: "AS", intro2ModelKey: "3-160" },
  "36374": { intro2SeriesName: "AS", intro2ModelKey: "3-180" },
  "36376": { intro2SeriesName: "AS", intro2ModelKey: "3-200" },
  "36377": { intro2SeriesName: "AS", intro2ModelKey: "32-10" },
  "36378": { intro2SeriesName: "AS", intro2ModelKey: "3-220" },
  "36379": { intro2SeriesName: "AS", intro2ModelKey: "32-30" },
  "36380": { intro2SeriesName: "AS", intro2ModelKey: "3-240" },
  "36381": { intro2SeriesName: "AS", intro2ModelKey: "3-250" },
  "36382": { intro2SeriesName: "AS", intro2ModelKey: "3-260" },
  "36383": { intro2SeriesName: "AS", intro2ModelKey: "32-70" },
  "36384": { intro2SeriesName: "AS", intro2ModelKey: "3-280" },
  "36385": { intro2SeriesName: "AS", intro2ModelKey: "32-90" },
  "36386": { intro2SeriesName: "AS", intro2ModelKey: "3-300" },
  "36388": { intro2SeriesName: "AS", intro2ModelKey: "3-320" },
  "36390": { intro2SeriesName: "AS", intro2ModelKey: "3-340" },
  "36392": { intro2SeriesName: "AS", intro2ModelKey: "3-360" },
  "36393": { intro2SeriesName: "AS", intro2ModelKey: "4-20" },
  "36394": { intro2SeriesName: "AS", intro2ModelKey: "4-30" },
  "36395": { intro2SeriesName: "AS", intro2ModelKey: "4-40" },
  "36396": { intro2SeriesName: "AS", intro2ModelKey: "4-50" },
  "36397": { intro2SeriesName: "AS", intro2ModelKey: "4-60" },
  "36398": { intro2SeriesName: "AS", intro2ModelKey: "4-70" },
  "36399": { intro2SeriesName: "AS", intro2ModelKey: "4-80" },
  "36400": { intro2SeriesName: "AS", intro2ModelKey: "4-90" },
  "36401": { intro2SeriesName: "AS", intro2ModelKey: "4-100" },
  "36402": { intro2SeriesName: "AS", intro2ModelKey: "4-110" },
  "36403": { intro2SeriesName: "AS", intro2ModelKey: "4-120" },
  "36404": { intro2SeriesName: "AS", intro2ModelKey: "4-130" },
  "36405": { intro2SeriesName: "AS", intro2ModelKey: "4-140" },
  "36406": { intro2SeriesName: "AS", intro2ModelKey: "4-150" },
  "36407": { intro2SeriesName: "AS", intro2ModelKey: "4-160" },
  "36408": { intro2SeriesName: "AS", intro2ModelKey: "4-170" },
  "36409": { intro2SeriesName: "AS", intro2ModelKey: "4-180" },
  "36410": { intro2SeriesName: "AS", intro2ModelKey: "4-190" },
  "36411": { intro2SeriesName: "AS", intro2ModelKey: "4-200" },
  "36412": { intro2SeriesName: "AS", intro2ModelKey: "4-210" },
  "36413": { intro2SeriesName: "AS", intro2ModelKey: "4-220" },
  "36414": { intro2SeriesName: "AS", intro2ModelKey: "4-230" },
  "36415": { intro2SeriesName: "AS", intro2ModelKey: "4-240" },
  "36416": { intro2SeriesName: "AS", intro2ModelKey: "4-250" },
  "36417": { intro2SeriesName: "AS", intro2ModelKey: "4-260" },
  "36418": { intro2SeriesName: "AS", intro2ModelKey: "4-270" },
  "36419": { intro2SeriesName: "AS", intro2ModelKey: "4-280" },
  "36420": { intro2SeriesName: "AS", intro2ModelKey: "4-290" },
  "36421": { intro2SeriesName: "AS", intro2ModelKey: "4-300" },
  "36425": { intro2SeriesName: "AS", intro2ModelKey: "5-20-2" },
  "36426": { intro2SeriesName: "AS", intro2ModelKey: "5-20" },
  "36429": { intro2SeriesName: "AS", intro2ModelKey: "5-50" },
  "36430": { intro2SeriesName: "AS", intro2ModelKey: "5-60" },
  "36431": { intro2SeriesName: "AS", intro2ModelKey: "5-70" },
  "36433": { intro2SeriesName: "AS", intro2ModelKey: "5-90" },
  "36435": { intro2SeriesName: "AS", intro2ModelKey: "5-110" },
  "36436": { intro2SeriesName: "AS", intro2ModelKey: "5-120" },
  "36438": { intro2SeriesName: "AS", intro2ModelKey: "5-140" },
  "36440": { intro2SeriesName: "AS", intro2ModelKey: "5-160" },
  "36443": { intro2SeriesName: "AS", intro2ModelKey: "5-190" },
  "36445": { intro2SeriesName: "AS", intro2ModelKey: "5-210" },
  "36447": { intro2SeriesName: "AS", intro2ModelKey: "5-230" },
  "36449": { intro2SeriesName: "AS", intro2ModelKey: "5-250" },
  "36450": { intro2SeriesName: "AS", intro2ModelKey: "5-260" },
  "36453": { intro2SeriesName: "AS", intro2ModelKey: "5-290" },
  "36456": { intro2SeriesName: "AS", intro2ModelKey: "5-320" },
  "36460": { intro2SeriesName: "AS", intro2ModelKey: "5-360" },
  "36461": { intro2SeriesName: "AS", intro2ModelKey: "8-20" },
  "36462": { intro2SeriesName: "AS", intro2ModelKey: "8-30" },
  "36463": { intro2SeriesName: "AS", intro2ModelKey: "8-40" },
  "36464": { intro2SeriesName: "AS", intro2ModelKey: "8-50" },
  "36465": { intro2SeriesName: "AS", intro2ModelKey: "8-60" },
  "36466": { intro2SeriesName: "AS", intro2ModelKey: "8-70" },
  "36467": { intro2SeriesName: "AS", intro2ModelKey: "8-80" },
  "36468": { intro2SeriesName: "AS", intro2ModelKey: "8-90" },
  "36469": { intro2SeriesName: "AS", intro2ModelKey: "8-100" },
  "36470": { intro2SeriesName: "AS", intro2ModelKey: "8-110" },
  "36471": { intro2SeriesName: "AS", intro2ModelKey: "8-120" },
  "36472": { intro2SeriesName: "AS", intro2ModelKey: "8-130" },
  "36473": { intro2SeriesName: "AS", intro2ModelKey: "8-140" },
  "36474": { intro2SeriesName: "AS", intro2ModelKey: "8-150" },
  "36475": { intro2SeriesName: "AS", intro2ModelKey: "8-160" },
  "36476": { intro2SeriesName: "AS", intro2ModelKey: "8-170" },
  "36477": { intro2SeriesName: "AS", intro2ModelKey: "8-180" },
  "36478": { intro2SeriesName: "AS", intro2ModelKey: "8-190" },
  "36479": { intro2SeriesName: "AS", intro2ModelKey: "8-200" },
  "36480": { intro2SeriesName: "AS", intro2ModelKey: "8-210" },
  "36481": { intro2SeriesName: "AS", intro2ModelKey: "8-220" },
  "36482": { intro2SeriesName: "AS", intro2ModelKey: "10-20" },
  "36483": { intro2SeriesName: "AS", intro2ModelKey: "10-30" },
  "36484": { intro2SeriesName: "AS", intro2ModelKey: "10-40" },
  "36485": { intro2SeriesName: "AS", intro2ModelKey: "10-50" },
  "36486": { intro2SeriesName: "AS", intro2ModelKey: "10-60" },
  "36487": { intro2SeriesName: "AS", intro2ModelKey: "10-70" },
  "36488": { intro2SeriesName: "AS", intro2ModelKey: "10-80" },
  "36489": { intro2SeriesName: "AS", intro2ModelKey: "10-90" },
  "36490": { intro2SeriesName: "AS", intro2ModelKey: "10-100" },
  "36491": { intro2SeriesName: "AS", intro2ModelKey: "10-110" },
  "36492": { intro2SeriesName: "AS", intro2ModelKey: "10-120" },
  "36493": { intro2SeriesName: "AS", intro2ModelKey: "10-130" },
  "36494": { intro2SeriesName: "AS", intro2ModelKey: "10-140" },
  "36495": { intro2SeriesName: "AS", intro2ModelKey: "10-150" },
  "36496": { intro2SeriesName: "AS", intro2ModelKey: "10-160" },
  "36497": { intro2SeriesName: "AS", intro2ModelKey: "10-170" },
  "36498": { intro2SeriesName: "AS", intro2ModelKey: "10-180" },
  "36499": { intro2SeriesName: "AS", intro2ModelKey: "10-190" },
  "36500": { intro2SeriesName: "AS", intro2ModelKey: "10-200" },
  "36501": { intro2SeriesName: "AS", intro2ModelKey: "10-210" },
  "36502": { intro2SeriesName: "AS", intro2ModelKey: "10-220" },
  "36503": { intro2SeriesName: "AS", intro2ModelKey: "10-230" },
  "36504": { intro2SeriesName: "AS", intro2ModelKey: "10-240" },
  "36505": { intro2SeriesName: "AS", intro2ModelKey: "10-250" },
  "36506": { intro2SeriesName: "AS", intro2ModelKey: "12-20" },
  "36507": { intro2SeriesName: "AS", intro2ModelKey: "1-230" },
  "36508": { intro2SeriesName: "AS", intro2ModelKey: "12-40" },
  "36509": { intro2SeriesName: "AS", intro2ModelKey: "1-250" },
  "36510": { intro2SeriesName: "AS", intro2ModelKey: "12-60" },
  "36511": { intro2SeriesName: "AS", intro2ModelKey: "1-270" },
  "36512": { intro2SeriesName: "AS", intro2ModelKey: "12-80" },
  "36513": { intro2SeriesName: "AS", intro2ModelKey: "12-90" },
  "36514": { intro2SeriesName: "AS", intro2ModelKey: "12-100" },
  "36515": { intro2SeriesName: "AS", intro2ModelKey: "12-110" },
  "36516": { intro2SeriesName: "AS", intro2ModelKey: "12-120" },
  "36517": { intro2SeriesName: "AS", intro2ModelKey: "12-130" },
  "36518": { intro2SeriesName: "AS", intro2ModelKey: "12-140" },
  "36519": { intro2SeriesName: "AS", intro2ModelKey: "12-150" },
  "36520": { intro2SeriesName: "AS", intro2ModelKey: "12-160" },
  "36521": { intro2SeriesName: "AS", intro2ModelKey: "12-170" },
  "36522": { intro2SeriesName: "AS", intro2ModelKey: "12-180" },
  "36523": { intro2SeriesName: "AS", intro2ModelKey: "12-190" },
  "36524": { intro2SeriesName: "AS", intro2ModelKey: "12-200" },
  "36525": { intro2SeriesName: "AS", intro2ModelKey: "AS15-10" },
  "36526": { intro2SeriesName: "AS", intro2ModelKey: "AS15-20" },
  "36527": { intro2SeriesName: "AS", intro2ModelKey: "AS15-30" },
  "36528": { intro2SeriesName: "AS", intro2ModelKey: "AS15-40" },
  "36529": { intro2SeriesName: "AS", intro2ModelKey: "AS15-50" },
  "36530": { intro2SeriesName: "AS", intro2ModelKey: "AS15-60" },
  "36531": { intro2SeriesName: "AS", intro2ModelKey: "AS15-70" },
  "36532": { intro2SeriesName: "AS", intro2ModelKey: "AS15-80" },
  "36533": { intro2SeriesName: "AS", intro2ModelKey: "AS15-90" },
  "36534": { intro2SeriesName: "AS", intro2ModelKey: "AS15-100" },
  "36535": { intro2SeriesName: "AS", intro2ModelKey: "AS15-110" },
  "36536": { intro2SeriesName: "AS", intro2ModelKey: "AS15-120" },
  "36537": { intro2SeriesName: "AS", intro2ModelKey: "AS15-130" },
  "36538": { intro2SeriesName: "AS", intro2ModelKey: "AS15-140" },
  "36539": { intro2SeriesName: "AS", intro2ModelKey: "AS15-150" },
  "36540": { intro2SeriesName: "AS", intro2ModelKey: "AS15-160" },
  "36541": { intro2SeriesName: "AS", intro2ModelKey: "AS15-170" },
  "36542": { intro2SeriesName: "AS", intro2ModelKey: "AS15-180" },
  "36543": { intro2SeriesName: "AS", intro2ModelKey: "AS16-20" },
  "36544": { intro2SeriesName: "AS", intro2ModelKey: "AS16-30" },
  "36545": { intro2SeriesName: "AS", intro2ModelKey: "AS16-40" },
  "36546": { intro2SeriesName: "AS", intro2ModelKey: "AS16-50" },
  "36547": { intro2SeriesName: "AS", intro2ModelKey: "AS16-60" },
  "36548": { intro2SeriesName: "AS", intro2ModelKey: "AS16-70" },
  "36549": { intro2SeriesName: "AS", intro2ModelKey: "AS16-80" },
  "36550": { intro2SeriesName: "AS", intro2ModelKey: "AS16-90" },
  "36551": { intro2SeriesName: "AS", intro2ModelKey: "AS16-100" },
  "36552": { intro2SeriesName: "AS", intro2ModelKey: "AS16-110" },
  "36553": { intro2SeriesName: "AS", intro2ModelKey: "AS16-120" },
  "36554": { intro2SeriesName: "AS", intro2ModelKey: "AS16-130" },
  "36555": { intro2SeriesName: "AS", intro2ModelKey: "AS16-140" },
  "36556": { intro2SeriesName: "AS", intro2ModelKey: "AS16-150" },
  "36557": { intro2SeriesName: "AS", intro2ModelKey: "AS16-160" },
  "36558": { intro2SeriesName: "AS", intro2ModelKey: "AS16-170" },
  "36560": { intro2SeriesName: "AS", intro2ModelKey: "AS20-10" },
  "36561": { intro2SeriesName: "AS", intro2ModelKey: "AS20-20" },
  "36562": { intro2SeriesName: "AS", intro2ModelKey: "AS20-30" },
  "36563": { intro2SeriesName: "AS", intro2ModelKey: "AS20-40" },
  "36564": { intro2SeriesName: "AS", intro2ModelKey: "AS20-50" },
  "36565": { intro2SeriesName: "AS", intro2ModelKey: "AS20-60" },
  "36566": { intro2SeriesName: "AS", intro2ModelKey: "AS20-70" },
  "36567": { intro2SeriesName: "AS", intro2ModelKey: "AS20-80" },
  "36568": { intro2SeriesName: "AS", intro2ModelKey: "AS20-90" },
  "36569": { intro2SeriesName: "AS", intro2ModelKey: "AS20-100" },
  "36570": { intro2SeriesName: "AS", intro2ModelKey: "AS20-110" },
  "36571": { intro2SeriesName: "AS", intro2ModelKey: "AS20-120" },
  "36573": { intro2SeriesName: "AS", intro2ModelKey: "AS20-140" },
  "36574": { intro2SeriesName: "AS", intro2ModelKey: "32-10" },
  "36575": { intro2SeriesName: "AS", intro2ModelKey: "3-220" },
  "36576": { intro2SeriesName: "AS", intro2ModelKey: "32-30" },
  "36577": { intro2SeriesName: "AS", intro2ModelKey: "3-240" },
  "36578": { intro2SeriesName: "AS", intro2ModelKey: "3-250" },
  "36579": { intro2SeriesName: "AS", intro2ModelKey: "3-260" },
  "36580": { intro2SeriesName: "AS", intro2ModelKey: "32-70" },
  "36581": { intro2SeriesName: "AS", intro2ModelKey: "3-280" },
  "36582": { intro2SeriesName: "AS", intro2ModelKey: "32-90" },
  "36583": { intro2SeriesName: "AS", intro2ModelKey: "32-100" },
  "36584": { intro2SeriesName: "AS", intro2ModelKey: "32-110" },
  "36585": { intro2SeriesName: "AS", intro2ModelKey: "32-120" },
  "36586": { intro2SeriesName: "AS", intro2ModelKey: "32-130" },
  "36587": { intro2SeriesName: "AS", intro2ModelKey: "32-140" },
  "36588": { intro2SeriesName: "AS", intro2ModelKey: "32-150" },
  "36589": { intro2SeriesName: "AS", intro2ModelKey: "32-160" },
  "36590": { intro2SeriesName: "AS", intro2ModelKey: "32-170" },
  "36591": { intro2SeriesName: "AS", intro2ModelKey: "45-10" },
  "36592": { intro2SeriesName: "AS", intro2ModelKey: "45-20" },
  "36593": { intro2SeriesName: "AS", intro2ModelKey: "45-30" },
  "36594": { intro2SeriesName: "AS", intro2ModelKey: "45-40" },
  "36595": { intro2SeriesName: "AS", intro2ModelKey: "45-50" },
  "36596": { intro2SeriesName: "AS", intro2ModelKey: "45-60" },
  "36597": { intro2SeriesName: "AS", intro2ModelKey: "45-70" },
  "36598": { intro2SeriesName: "AS", intro2ModelKey: "45-80" },
  "36599": { intro2SeriesName: "AS", intro2ModelKey: "45-90" },
  "36600": { intro2SeriesName: "AS", intro2ModelKey: "45-100" },
  "36601": { intro2SeriesName: "AS", intro2ModelKey: "45-110" },
  "36602": { intro2SeriesName: "AS", intro2ModelKey: "45-120" },
  "36603": { intro2SeriesName: "AS", intro2ModelKey: "45-130" },
  "36605": { intro2SeriesName: "AS", intro2ModelKey: "64-10" },
  "36606": { intro2SeriesName: "AS", intro2ModelKey: "64-20" },
  "36607": { intro2SeriesName: "AS", intro2ModelKey: "64-30" },
  "36608": { intro2SeriesName: "AS", intro2ModelKey: "64-40" },
  "36609": { intro2SeriesName: "AS", intro2ModelKey: "64-50" },
  "36610": { intro2SeriesName: "AS", intro2ModelKey: "64-60" },
  "36611": { intro2SeriesName: "AS", intro2ModelKey: "64-70" },
  "36612": { intro2SeriesName: "AS", intro2ModelKey: "64-80" },
  "36613": { intro2SeriesName: "AS", intro2ModelKey: "90-10" },
  "36614": { intro2SeriesName: "AS", intro2ModelKey: "90-20" },
  "36615": { intro2SeriesName: "AS", intro2ModelKey: "90-30" },
  "36616": { intro2SeriesName: "AS", intro2ModelKey: "90-40" },
  "36617": { intro2SeriesName: "AS", intro2ModelKey: "90-50" },
  "36618": { intro2SeriesName: "AS", intro2ModelKey: "90-60" },
  "36619": { intro2SeriesName: "AS", intro2ModelKey: "90-70" },
  "36620": { intro2SeriesName: "AS", intro2ModelKey: "100-10" },
  "36621": { intro2SeriesName: "AS", intro2ModelKey: "100-20" },
  "36622": { intro2SeriesName: "AS", intro2ModelKey: "100-30" },
  "36623": { intro2SeriesName: "AS", intro2ModelKey: "100-40" },
  "36624": { intro2SeriesName: "AS", intro2ModelKey: "100-50" },
  "36625": { intro2SeriesName: "AS", intro2ModelKey: "100-60" },
  "36626": { intro2SeriesName: "AS", intro2ModelKey: "100-70" },
  "36627": { intro2SeriesName: "AS", intro2ModelKey: "100-80" },
  "36628": { intro2SeriesName: "AS", intro2ModelKey: "100-90" },
  "36629": { intro2SeriesName: "AS", intro2ModelKey: "100-100" },
  "36630": { intro2SeriesName: "AS", intro2ModelKey: "130-10" },
  "36631": { intro2SeriesName: "AS", intro2ModelKey: "130-20" },
  "36632": { intro2SeriesName: "AS", intro2ModelKey: "130-30" },
  "36633": { intro2SeriesName: "AS", intro2ModelKey: "130-40" },
  "36634": { intro2SeriesName: "AS", intro2ModelKey: "130-50" },
  "36635": { intro2SeriesName: "AS", intro2ModelKey: "130-60" },
  "36636": { intro2SeriesName: "AS", intro2ModelKey: "130-70" },
  "36637": { intro2SeriesName: "AS", intro2ModelKey: "130-80" },
  "36638": { intro2SeriesName: "AS", intro2ModelKey: "130-90" },
  "36639": { intro2SeriesName: "AS", intro2ModelKey: "130-100" },
  "36640": { intro2SeriesName: "AS", intro2ModelKey: "160-10" },
  "36641": { intro2SeriesName: "AS", intro2ModelKey: "160-20" },
  "36642": { intro2SeriesName: "AS", intro2ModelKey: "160-30" },
  "36643": { intro2SeriesName: "AS", intro2ModelKey: "160-40" },
  "36644": { intro2SeriesName: "AS", intro2ModelKey: "160-50" },
  "36645": { intro2SeriesName: "AS", intro2ModelKey: "160-60" },
  "36646": { intro2SeriesName: "AS", intro2ModelKey: "160-70" },
  "36648": { intro2SeriesName: "AS", intro2ModelKey: "190-10" },
  "36649": { intro2SeriesName: "AS", intro2ModelKey: "190-20" },
  "36650": { intro2SeriesName: "AS", intro2ModelKey: "190-30" },
  "36651": { intro2SeriesName: "AS", intro2ModelKey: "190-40" },
  "36652": { intro2SeriesName: "AS", intro2ModelKey: "190-50" },
  "36653": { intro2SeriesName: "AS", intro2ModelKey: "190-60" },
  "36654": { intro2SeriesName: "AS", intro2ModelKey: "190-70" },
  "36655": { intro2SeriesName: "AS", intro2ModelKey: "190-80" },
  "37018": { intro2SeriesName: "AS", intro2ModelKey: "130-80" },
  "37020": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-200/2" },
  "37021": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x8" },
  "37160": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-280/4" },
  "37174": { intro2SeriesName: "SMA", intro2ModelKey: "300x250-500-220/4" },
  "37462": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-40-2" },
  "37536": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x4" },
  "37537": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x5" },
  "37538": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x6" },
  "37539": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x7" },
  "37540": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x8" },
  "37541": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x9" },
  "37542": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x10" },
  "37543": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x11" },
  "37544": { intro2SeriesName: "CMB", intro2ModelKey: "6-25x12" },
  "37545": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x2" },
  "37546": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x3" },
  "37547": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x4" },
  "37548": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x5" },
  "37549": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x6" },
  "37550": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x7" },
  "37551": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x8" },
  "37552": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x9" },
  "37553": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x10" },
  "37554": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x11" },
  "37555": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x12" },
  "37556": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x2" },
  "37557": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x3" },
  "37558": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x4" },
  "37559": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x5" },
  "37560": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x6" },
  "37561": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x7" },
  "37562": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x8" },
  "37563": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x9" },
  "37564": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x10" },
  "37565": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x11" },
  "37566": { intro2SeriesName: "CMB", intro2ModelKey: "12-25x12" },
  "37567": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x2" },
  "37568": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x3" },
  "37569": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x4" },
  "37570": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x5" },
  "37571": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x6" },
  "37572": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x7" },
  "37573": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x8" },
  "37574": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x9" },
  "37575": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x10" },
  "37576": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x11" },
  "37577": { intro2SeriesName: "CMB", intro2ModelKey: "12-50x12" },
  "37578": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x2" },
  "37579": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x3" },
  "37580": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x4" },
  "37581": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x5" },
  "37582": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x6" },
  "37583": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x7" },
  "37584": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x8" },
  "37585": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x9" },
  "37586": { intro2SeriesName: "CMB", intro2ModelKey: "25-30x10" },
  "37588": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x3" },
  "37589": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x4" },
  "37590": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x5" },
  "37591": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x6" },
  "37592": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x7" },
  "37593": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x8" },
  "37594": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x9" },
  "37595": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x10" },
  "37596": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x11" },
  "37597": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x12" },
  "37598": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x2" },
  "37599": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x3" },
  "37600": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x4" },
  "37601": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x5" },
  "37602": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x6" },
  "37603": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x7" },
  "37604": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x8" },
  "37605": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x9" },
  "37606": { intro2SeriesName: "CMB", intro2ModelKey: "46-30x10" },
  "37607": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x2" },
  "37608": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x3" },
  "37609": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x4" },
  "37610": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x5" },
  "37611": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x6" },
  "37612": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x7" },
  "37613": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x8" },
  "37614": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x9" },
  "37616": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x3" },
  "37617": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x4" },
  "37618": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x5" },
  "37619": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x6" },
  "37620": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x7" },
  "37621": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x8" },
  "37622": { intro2SeriesName: "CMB", intro2ModelKey: "85-67x9" },
  "37623": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x2" },
  "37624": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x3" },
  "37625": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x4" },
  "37626": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x5" },
  "37627": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x6" },
  "37628": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x7" },
  "37629": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x8" },
  "37630": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x9" },
  "37631": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x2" },
  "37632": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x3" },
  "37633": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x4" },
  "37634": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x5" },
  "37635": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x6" },
  "37636": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x7" },
  "37637": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x8" },
  "37638": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x9" },
  "37639": { intro2SeriesName: "CMB", intro2ModelKey: "155-30x10" },
  "37640": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x2" },
  "37641": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x3" },
  "37642": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x4" },
  "37643": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x5" },
  "37644": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x6" },
  "37645": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x7" },
  "37646": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x8" },
  "37647": { intro2SeriesName: "CMB", intro2ModelKey: "155-67x9" },
  "37648": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x2" },
  "37649": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x3" },
  "37650": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x4" },
  "37651": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x5" },
  "37652": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x6" },
  "37653": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x7" },
  "37654": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x8" },
  "37655": { intro2SeriesName: "CMB", intro2ModelKey: "280-43x9" },
  "37657": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x3" },
  "37658": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x4" },
  "37659": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x5" },
  "37660": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x6" },
  "37661": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x7" },
  "37662": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x8" },
  "37663": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x9" },
  "37664": { intro2SeriesName: "CMB", intro2ModelKey: "280-65x10" },
  "37665": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x2" },
  "37666": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x3" },
  "37667": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x4" },
  "37668": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x5" },
  "37669": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x6" },
  "37670": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x7" },
  "37671": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x8" },
  "37672": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x9" },
  "37673": { intro2SeriesName: "CMB", intro2ModelKey: "360-40x10" },
  "37674": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x2" },
  "37675": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x3" },
  "37676": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x4" },
  "37677": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x5" },
  "37678": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x6" },
  "37679": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x7" },
  "37680": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x8" },
  "37681": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x9" },
  "37682": { intro2SeriesName: "CMB", intro2ModelKey: "450-60x10" },
  "37683": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x2" },
  "37684": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x3" },
  "37685": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x4" },
  "37686": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x5" },
  "37687": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x6" },
  "37688": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x7" },
  "37689": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x8" },
  "37690": { intro2SeriesName: "CMB", intro2ModelKey: "550-50x9" },
  "37692": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x3" },
  "37693": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x4" },
  "37694": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x5" },
  "37695": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x6" },
  "37696": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x7" },
  "37697": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x8" },
  "37698": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x9" },
  "37699": { intro2SeriesName: "CMB", intro2ModelKey: "580-70x10" },
  "37701": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x3" },
  "37702": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x4" },
  "37703": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x5" },
  "37704": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x6" },
  "37705": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x7" },
  "37706": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x8" },
  "37707": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x9" },
  "37708": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x10" },
  "37709": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x2" },
  "37710": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x3" },
  "37711": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x4" },
  "37712": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x5" },
  "37713": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x6" },
  "37714": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x7" },
  "37715": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x8" },
  "37716": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x9" },
  "37735": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x2" },
  "37736": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x3" },
  "37737": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x4" },
  "37738": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x5" },
  "37739": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x6" },
  "37740": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x7" },
  "37741": { intro2SeriesName: "CMB", intro2ModelKey: "46-50x8" },
  "37984": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-160/2" },
  "38246": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x2" },
  "38247": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x3" },
  "38248": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x4" },
  "38249": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x5" },
  "38250": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x6" },
  "38251": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x7" },
  "38252": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x8" },
  "38253": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x9" },
  "38254": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x10" },
  "38255": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x11" },
  "38256": { intro2SeriesName: "CMB", intro2ModelKey: "6-50x12" },
  "38259": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x3" },
  "38260": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x4" },
  "38261": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x5" },
  "38262": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x6" },
  "38263": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x7" },
  "38264": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x8" },
  "38265": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x9" },
  "38266": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x10" },
  "38267": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x11" },
  "38268": { intro2SeriesName: "CMB", intro2ModelKey: "25-50x12" },
  "38271": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x2" },
  "38272": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x3" },
  "38273": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x4" },
  "38316": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x5" },
  "38317": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x6" },
  "38318": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x7" },
  "38319": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x8" },
  "38320": { intro2SeriesName: "CMB", intro2ModelKey: "85-45x9" },
  "38329": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x8" },
  "38330": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x9" },
  "38331": { intro2SeriesName: "CMB", intro2ModelKey: "600-60x10" },
  "38332": { intro2SeriesName: "CMB", intro2ModelKey: "720-60x9" },
  "39402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-80-2" },
  "39833": { intro2SeriesName: "SMA", intro2ModelKey: "100x80-160-11/2" },
  "39988": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-250-55/2" },
  "40584": { intro2SeriesName: "AS", intro2ModelKey: "32-20-2" },
  "40654": { intro2SeriesName: "AS", intro2ModelKey: "32-50-2" },
  "40683": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-20" },
  "40684": { intro2SeriesName: "AS", intro2ModelKey: "AS20-60" },
  "40691": { intro2SeriesName: "AS", intro2ModelKey: "1-20" },
  "40692": { intro2SeriesName: "AS", intro2ModelKey: "1-30" },
  "40693": { intro2SeriesName: "AS", intro2ModelKey: "1-40" },
  "40694": { intro2SeriesName: "AS", intro2ModelKey: "1-50" },
  "40695": { intro2SeriesName: "AS", intro2ModelKey: "1-60" },
  "40696": { intro2SeriesName: "AS", intro2ModelKey: "1-70" },
  "40697": { intro2SeriesName: "AS", intro2ModelKey: "1-80" },
  "40698": { intro2SeriesName: "AS", intro2ModelKey: "1-90" },
  "40699": { intro2SeriesName: "AS", intro2ModelKey: "1-100" },
  "40700": { intro2SeriesName: "AS", intro2ModelKey: "1-110" },
  "40701": { intro2SeriesName: "AS", intro2ModelKey: "1-120" },
  "40702": { intro2SeriesName: "AS", intro2ModelKey: "1-130" },
  "40704": { intro2SeriesName: "AS", intro2ModelKey: "1-150" },
  "40706": { intro2SeriesName: "AS", intro2ModelKey: "1-170" },
  "40710": { intro2SeriesName: "AS", intro2ModelKey: "1-210" },
  "40711": { intro2SeriesName: "AS", intro2ModelKey: "12-20" },
  "40712": { intro2SeriesName: "AS", intro2ModelKey: "1-230" },
  "40713": { intro2SeriesName: "AS", intro2ModelKey: "12-40" },
  "40714": { intro2SeriesName: "AS", intro2ModelKey: "1-250" },
  "40715": { intro2SeriesName: "AS", intro2ModelKey: "12-60" },
  "40716": { intro2SeriesName: "AS", intro2ModelKey: "1-270" },
  "40717": { intro2SeriesName: "AS", intro2ModelKey: "12-80" },
  "40718": { intro2SeriesName: "AS", intro2ModelKey: "12-90" },
  "40719": { intro2SeriesName: "AS", intro2ModelKey: "1-300" },
  "40722": { intro2SeriesName: "AS", intro2ModelKey: "1-330" },
  "40724": { intro2SeriesName: "AS", intro2ModelKey: "1-350" },
  "40725": { intro2SeriesName: "AS", intro2ModelKey: "1-360" },
  "40726": { intro2SeriesName: "AS", intro2ModelKey: "2-20" },
  "40727": { intro2SeriesName: "AS", intro2ModelKey: "2-30" },
  "40728": { intro2SeriesName: "AS", intro2ModelKey: "2-40" },
  "40729": { intro2SeriesName: "AS", intro2ModelKey: "2-50" },
  "40730": { intro2SeriesName: "AS", intro2ModelKey: "2-60" },
  "40731": { intro2SeriesName: "AS", intro2ModelKey: "2-70" },
  "40732": { intro2SeriesName: "AS", intro2ModelKey: "2-80" },
  "40733": { intro2SeriesName: "AS", intro2ModelKey: "2-90" },
  "40734": { intro2SeriesName: "AS", intro2ModelKey: "2-100" },
  "40735": { intro2SeriesName: "AS", intro2ModelKey: "2-110" },
  "40736": { intro2SeriesName: "AS", intro2ModelKey: "2-120" },
  "40737": { intro2SeriesName: "AS", intro2ModelKey: "2-130" },
  "40738": { intro2SeriesName: "AS", intro2ModelKey: "2-140" },
  "40739": { intro2SeriesName: "AS", intro2ModelKey: "2-150" },
  "40740": { intro2SeriesName: "AS", intro2ModelKey: "2-160" },
  "40741": { intro2SeriesName: "AS", intro2ModelKey: "2-170" },
  "40742": { intro2SeriesName: "AS", intro2ModelKey: "2-180" },
  "40743": { intro2SeriesName: "AS", intro2ModelKey: "2-190" },
  "40744": { intro2SeriesName: "AS", intro2ModelKey: "2-200" },
  "40745": { intro2SeriesName: "AS", intro2ModelKey: "2-210" },
  "40746": { intro2SeriesName: "AS", intro2ModelKey: "2-220" },
  "40747": { intro2SeriesName: "AS", intro2ModelKey: "2-230" },
  "40748": { intro2SeriesName: "AS", intro2ModelKey: "2-240" },
  "40749": { intro2SeriesName: "AS", intro2ModelKey: "2-250" },
  "40750": { intro2SeriesName: "AS", intro2ModelKey: "2-260" },
  "40751": { intro2SeriesName: "AS", intro2ModelKey: "2-270" },
  "40752": { intro2SeriesName: "AS", intro2ModelKey: "2-280" },
  "40753": { intro2SeriesName: "AS", intro2ModelKey: "2-290" },
  "40754": { intro2SeriesName: "AS", intro2ModelKey: "2-300" },
  "40755": { intro2SeriesName: "AS", intro2ModelKey: "2-310" },
  "40756": { intro2SeriesName: "AS", intro2ModelKey: "2-320" },
  "40757": { intro2SeriesName: "AS", intro2ModelKey: "3-20" },
  "40758": { intro2SeriesName: "AS", intro2ModelKey: "3-30" },
  "40759": { intro2SeriesName: "AS", intro2ModelKey: "3-40" },
  "40760": { intro2SeriesName: "AS", intro2ModelKey: "3-50" },
  "40761": { intro2SeriesName: "AS", intro2ModelKey: "3-60" },
  "40762": { intro2SeriesName: "AS", intro2ModelKey: "3-70" },
  "40763": { intro2SeriesName: "AS", intro2ModelKey: "3-80" },
  "40764": { intro2SeriesName: "AS", intro2ModelKey: "3-90" },
  "40765": { intro2SeriesName: "AS", intro2ModelKey: "3-100" },
  "40766": { intro2SeriesName: "AS", intro2ModelKey: "3-110" },
  "40767": { intro2SeriesName: "AS", intro2ModelKey: "3-120" },
  "40769": { intro2SeriesName: "AS", intro2ModelKey: "3-140" },
  "40771": { intro2SeriesName: "AS", intro2ModelKey: "3-160" },
  "40773": { intro2SeriesName: "AS", intro2ModelKey: "3-180" },
  "40775": { intro2SeriesName: "AS", intro2ModelKey: "3-200" },
  "40776": { intro2SeriesName: "AS", intro2ModelKey: "32-10" },
  "40777": { intro2SeriesName: "AS", intro2ModelKey: "3-220" },
  "40778": { intro2SeriesName: "AS", intro2ModelKey: "32-30" },
  "40779": { intro2SeriesName: "AS", intro2ModelKey: "3-240" },
  "40780": { intro2SeriesName: "AS", intro2ModelKey: "3-250" },
  "40781": { intro2SeriesName: "AS", intro2ModelKey: "3-260" },
  "40782": { intro2SeriesName: "AS", intro2ModelKey: "32-70" },
  "40783": { intro2SeriesName: "AS", intro2ModelKey: "3-280" },
  "40784": { intro2SeriesName: "AS", intro2ModelKey: "32-90" },
  "40785": { intro2SeriesName: "AS", intro2ModelKey: "3-300" },
  "40787": { intro2SeriesName: "AS", intro2ModelKey: "3-320" },
  "40789": { intro2SeriesName: "AS", intro2ModelKey: "3-340" },
  "40791": { intro2SeriesName: "AS", intro2ModelKey: "3-360" },
  "40792": { intro2SeriesName: "AS", intro2ModelKey: "4-20" },
  "40793": { intro2SeriesName: "AS", intro2ModelKey: "4-30" },
  "40794": { intro2SeriesName: "AS", intro2ModelKey: "4-40" },
  "40795": { intro2SeriesName: "AS", intro2ModelKey: "4-50" },
  "40796": { intro2SeriesName: "AS", intro2ModelKey: "4-60" },
  "40797": { intro2SeriesName: "AS", intro2ModelKey: "4-70" },
  "40798": { intro2SeriesName: "AS", intro2ModelKey: "4-80" },
  "40799": { intro2SeriesName: "AS", intro2ModelKey: "4-90" },
  "40800": { intro2SeriesName: "AS", intro2ModelKey: "4-100" },
  "40801": { intro2SeriesName: "AS", intro2ModelKey: "4-110" },
  "40802": { intro2SeriesName: "AS", intro2ModelKey: "4-120" },
  "40803": { intro2SeriesName: "AS", intro2ModelKey: "4-130" },
  "40804": { intro2SeriesName: "AS", intro2ModelKey: "4-140" },
  "40805": { intro2SeriesName: "AS", intro2ModelKey: "4-150" },
  "40806": { intro2SeriesName: "AS", intro2ModelKey: "4-160" },
  "40807": { intro2SeriesName: "AS", intro2ModelKey: "4-170" },
  "40808": { intro2SeriesName: "AS", intro2ModelKey: "4-180" },
  "40809": { intro2SeriesName: "AS", intro2ModelKey: "4-190" },
  "40810": { intro2SeriesName: "AS", intro2ModelKey: "4-200" },
  "40811": { intro2SeriesName: "AS", intro2ModelKey: "4-210" },
  "40812": { intro2SeriesName: "AS", intro2ModelKey: "4-220" },
  "40813": { intro2SeriesName: "AS", intro2ModelKey: "4-230" },
  "40814": { intro2SeriesName: "AS", intro2ModelKey: "4-240" },
  "40815": { intro2SeriesName: "AS", intro2ModelKey: "4-250" },
  "40816": { intro2SeriesName: "AS", intro2ModelKey: "4-260" },
  "40817": { intro2SeriesName: "AS", intro2ModelKey: "4-270" },
  "40818": { intro2SeriesName: "AS", intro2ModelKey: "4-280" },
  "40819": { intro2SeriesName: "AS", intro2ModelKey: "4-290" },
  "40820": { intro2SeriesName: "AS", intro2ModelKey: "4-300" },
  "40824": { intro2SeriesName: "AS", intro2ModelKey: "5-20-2" },
  "40825": { intro2SeriesName: "AS", intro2ModelKey: "5-20" },
  "40828": { intro2SeriesName: "AS", intro2ModelKey: "5-50" },
  "40829": { intro2SeriesName: "AS", intro2ModelKey: "5-60" },
  "40830": { intro2SeriesName: "AS", intro2ModelKey: "5-70" },
  "40832": { intro2SeriesName: "AS", intro2ModelKey: "5-90" },
  "40834": { intro2SeriesName: "AS", intro2ModelKey: "5-110" },
  "40835": { intro2SeriesName: "AS", intro2ModelKey: "5-120" },
  "40837": { intro2SeriesName: "AS", intro2ModelKey: "5-140" },
  "40839": { intro2SeriesName: "AS", intro2ModelKey: "5-160" },
  "40842": { intro2SeriesName: "AS", intro2ModelKey: "5-190" },
  "40844": { intro2SeriesName: "AS", intro2ModelKey: "5-210" },
  "40846": { intro2SeriesName: "AS", intro2ModelKey: "5-230" },
  "40848": { intro2SeriesName: "AS", intro2ModelKey: "5-250" },
  "40849": { intro2SeriesName: "AS", intro2ModelKey: "5-260" },
  "40852": { intro2SeriesName: "AS", intro2ModelKey: "5-290" },
  "40855": { intro2SeriesName: "AS", intro2ModelKey: "5-320" },
  "40859": { intro2SeriesName: "AS", intro2ModelKey: "5-360" },
  "40860": { intro2SeriesName: "AS", intro2ModelKey: "8-20" },
  "40861": { intro2SeriesName: "AS", intro2ModelKey: "8-30" },
  "40862": { intro2SeriesName: "AS", intro2ModelKey: "8-40" },
  "40863": { intro2SeriesName: "AS", intro2ModelKey: "8-50" },
  "40864": { intro2SeriesName: "AS", intro2ModelKey: "8-60" },
  "40865": { intro2SeriesName: "AS", intro2ModelKey: "8-70" },
  "40866": { intro2SeriesName: "AS", intro2ModelKey: "8-80" },
  "40867": { intro2SeriesName: "AS", intro2ModelKey: "8-90" },
  "40868": { intro2SeriesName: "AS", intro2ModelKey: "8-100" },
  "40869": { intro2SeriesName: "AS", intro2ModelKey: "8-110" },
  "40870": { intro2SeriesName: "AS", intro2ModelKey: "8-120" },
  "40871": { intro2SeriesName: "AS", intro2ModelKey: "8-130" },
  "40872": { intro2SeriesName: "AS", intro2ModelKey: "8-140" },
  "40873": { intro2SeriesName: "AS", intro2ModelKey: "8-150" },
  "40874": { intro2SeriesName: "AS", intro2ModelKey: "8-160" },
  "40875": { intro2SeriesName: "AS", intro2ModelKey: "8-170" },
  "40876": { intro2SeriesName: "AS", intro2ModelKey: "8-180" },
  "40877": { intro2SeriesName: "AS", intro2ModelKey: "8-190" },
  "40878": { intro2SeriesName: "AS", intro2ModelKey: "8-200" },
  "40879": { intro2SeriesName: "AS", intro2ModelKey: "8-210" },
  "40880": { intro2SeriesName: "AS", intro2ModelKey: "8-220" },
  "40881": { intro2SeriesName: "AS", intro2ModelKey: "10-20" },
  "40882": { intro2SeriesName: "AS", intro2ModelKey: "10-30" },
  "40883": { intro2SeriesName: "AS", intro2ModelKey: "10-40" },
  "40884": { intro2SeriesName: "AS", intro2ModelKey: "10-50" },
  "40885": { intro2SeriesName: "AS", intro2ModelKey: "10-60" },
  "40886": { intro2SeriesName: "AS", intro2ModelKey: "10-70" },
  "40887": { intro2SeriesName: "AS", intro2ModelKey: "10-80" },
  "40888": { intro2SeriesName: "AS", intro2ModelKey: "10-90" },
  "40889": { intro2SeriesName: "AS", intro2ModelKey: "10-100" },
  "40890": { intro2SeriesName: "AS", intro2ModelKey: "10-110" },
  "40891": { intro2SeriesName: "AS", intro2ModelKey: "10-120" },
  "40892": { intro2SeriesName: "AS", intro2ModelKey: "10-130" },
  "40893": { intro2SeriesName: "AS", intro2ModelKey: "10-140" },
  "40894": { intro2SeriesName: "AS", intro2ModelKey: "10-150" },
  "40895": { intro2SeriesName: "AS", intro2ModelKey: "10-160" },
  "40896": { intro2SeriesName: "AS", intro2ModelKey: "10-170" },
  "40897": { intro2SeriesName: "AS", intro2ModelKey: "10-180" },
  "40898": { intro2SeriesName: "AS", intro2ModelKey: "10-190" },
  "40899": { intro2SeriesName: "AS", intro2ModelKey: "10-200" },
  "40900": { intro2SeriesName: "AS", intro2ModelKey: "10-210" },
  "40901": { intro2SeriesName: "AS", intro2ModelKey: "10-220" },
  "40902": { intro2SeriesName: "AS", intro2ModelKey: "10-230" },
  "40903": { intro2SeriesName: "AS", intro2ModelKey: "10-240" },
  "40904": { intro2SeriesName: "AS", intro2ModelKey: "10-250" },
  "40905": { intro2SeriesName: "AS", intro2ModelKey: "12-20" },
  "40906": { intro2SeriesName: "AS", intro2ModelKey: "1-230" },
  "40907": { intro2SeriesName: "AS", intro2ModelKey: "12-40" },
  "40908": { intro2SeriesName: "AS", intro2ModelKey: "1-250" },
  "40909": { intro2SeriesName: "AS", intro2ModelKey: "12-60" },
  "40910": { intro2SeriesName: "AS", intro2ModelKey: "1-270" },
  "40911": { intro2SeriesName: "AS", intro2ModelKey: "12-80" },
  "40912": { intro2SeriesName: "AS", intro2ModelKey: "12-90" },
  "40913": { intro2SeriesName: "AS", intro2ModelKey: "12-100" },
  "40914": { intro2SeriesName: "AS", intro2ModelKey: "12-110" },
  "40915": { intro2SeriesName: "AS", intro2ModelKey: "12-120" },
  "40916": { intro2SeriesName: "AS", intro2ModelKey: "12-130" },
  "40917": { intro2SeriesName: "AS", intro2ModelKey: "12-140" },
  "40918": { intro2SeriesName: "AS", intro2ModelKey: "12-150" },
  "40919": { intro2SeriesName: "AS", intro2ModelKey: "12-160" },
  "40920": { intro2SeriesName: "AS", intro2ModelKey: "12-170" },
  "40921": { intro2SeriesName: "AS", intro2ModelKey: "12-180" },
  "40922": { intro2SeriesName: "AS", intro2ModelKey: "12-190" },
  "40923": { intro2SeriesName: "AS", intro2ModelKey: "12-200" },
  "40924": { intro2SeriesName: "AS", intro2ModelKey: "AS15-10" },
  "40925": { intro2SeriesName: "AS", intro2ModelKey: "AS15-20" },
  "40926": { intro2SeriesName: "AS", intro2ModelKey: "AS15-30" },
  "40927": { intro2SeriesName: "AS", intro2ModelKey: "AS15-40" },
  "40928": { intro2SeriesName: "AS", intro2ModelKey: "AS15-50" },
  "40929": { intro2SeriesName: "AS", intro2ModelKey: "AS15-60" },
  "40930": { intro2SeriesName: "AS", intro2ModelKey: "AS15-70" },
  "40931": { intro2SeriesName: "AS", intro2ModelKey: "AS15-80" },
  "40932": { intro2SeriesName: "AS", intro2ModelKey: "AS15-90" },
  "40933": { intro2SeriesName: "AS", intro2ModelKey: "AS15-100" },
  "40934": { intro2SeriesName: "AS", intro2ModelKey: "AS15-110" },
  "40935": { intro2SeriesName: "AS", intro2ModelKey: "AS15-120" },
  "40936": { intro2SeriesName: "AS", intro2ModelKey: "AS15-130" },
  "40937": { intro2SeriesName: "AS", intro2ModelKey: "AS15-140" },
  "40938": { intro2SeriesName: "AS", intro2ModelKey: "AS15-150" },
  "40939": { intro2SeriesName: "AS", intro2ModelKey: "AS15-160" },
  "40940": { intro2SeriesName: "AS", intro2ModelKey: "AS15-170" },
  "40941": { intro2SeriesName: "AS", intro2ModelKey: "AS15-180" },
  "40942": { intro2SeriesName: "AS", intro2ModelKey: "AS16-20" },
  "40943": { intro2SeriesName: "AS", intro2ModelKey: "AS16-30" },
  "40944": { intro2SeriesName: "AS", intro2ModelKey: "AS16-40" },
  "40945": { intro2SeriesName: "AS", intro2ModelKey: "AS16-50" },
  "40946": { intro2SeriesName: "AS", intro2ModelKey: "AS16-60" },
  "40947": { intro2SeriesName: "AS", intro2ModelKey: "AS16-70" },
  "40948": { intro2SeriesName: "AS", intro2ModelKey: "AS16-80" },
  "40949": { intro2SeriesName: "AS", intro2ModelKey: "AS16-90" },
  "40950": { intro2SeriesName: "AS", intro2ModelKey: "AS16-100" },
  "40951": { intro2SeriesName: "AS", intro2ModelKey: "AS16-110" },
  "40952": { intro2SeriesName: "AS", intro2ModelKey: "AS16-120" },
  "40953": { intro2SeriesName: "AS", intro2ModelKey: "AS16-130" },
  "40954": { intro2SeriesName: "AS", intro2ModelKey: "AS16-140" },
  "40955": { intro2SeriesName: "AS", intro2ModelKey: "AS16-150" },
  "40956": { intro2SeriesName: "AS", intro2ModelKey: "AS16-160" },
  "40957": { intro2SeriesName: "AS", intro2ModelKey: "AS16-170" },
  "40959": { intro2SeriesName: "AS", intro2ModelKey: "AS20-10" },
  "40960": { intro2SeriesName: "AS", intro2ModelKey: "AS20-20" },
  "40961": { intro2SeriesName: "AS", intro2ModelKey: "AS20-30" },
  "40962": { intro2SeriesName: "AS", intro2ModelKey: "AS20-40" },
  "40963": { intro2SeriesName: "AS", intro2ModelKey: "AS20-50" },
  "40964": { intro2SeriesName: "AS", intro2ModelKey: "AS20-70" },
  "40965": { intro2SeriesName: "AS", intro2ModelKey: "AS20-80" },
  "40966": { intro2SeriesName: "AS", intro2ModelKey: "AS20-90" },
  "40967": { intro2SeriesName: "AS", intro2ModelKey: "AS20-100" },
  "40968": { intro2SeriesName: "AS", intro2ModelKey: "AS20-110" },
  "40969": { intro2SeriesName: "AS", intro2ModelKey: "AS20-120" },
  "40971": { intro2SeriesName: "AS", intro2ModelKey: "AS20-140" },
  "40972": { intro2SeriesName: "AS", intro2ModelKey: "32-10" },
  "40973": { intro2SeriesName: "AS", intro2ModelKey: "3-220" },
  "40974": { intro2SeriesName: "AS", intro2ModelKey: "32-30" },
  "40975": { intro2SeriesName: "AS", intro2ModelKey: "3-240" },
  "40976": { intro2SeriesName: "AS", intro2ModelKey: "3-250" },
  "40977": { intro2SeriesName: "AS", intro2ModelKey: "3-260" },
  "40978": { intro2SeriesName: "AS", intro2ModelKey: "32-70" },
  "40979": { intro2SeriesName: "AS", intro2ModelKey: "3-280" },
  "40980": { intro2SeriesName: "AS", intro2ModelKey: "32-90" },
  "40981": { intro2SeriesName: "AS", intro2ModelKey: "32-100" },
  "40982": { intro2SeriesName: "AS", intro2ModelKey: "32-110" },
  "40983": { intro2SeriesName: "AS", intro2ModelKey: "32-120" },
  "40984": { intro2SeriesName: "AS", intro2ModelKey: "32-130" },
  "40985": { intro2SeriesName: "AS", intro2ModelKey: "32-140" },
  "40986": { intro2SeriesName: "AS", intro2ModelKey: "32-150" },
  "40987": { intro2SeriesName: "AS", intro2ModelKey: "32-160" },
  "40988": { intro2SeriesName: "AS", intro2ModelKey: "32-170" },
  "40989": { intro2SeriesName: "AS", intro2ModelKey: "45-10" },
  "40990": { intro2SeriesName: "AS", intro2ModelKey: "45-20" },
  "40991": { intro2SeriesName: "AS", intro2ModelKey: "45-30" },
  "40992": { intro2SeriesName: "AS", intro2ModelKey: "45-40" },
  "40993": { intro2SeriesName: "AS", intro2ModelKey: "45-50" },
  "40994": { intro2SeriesName: "AS", intro2ModelKey: "45-60" },
  "40995": { intro2SeriesName: "AS", intro2ModelKey: "45-70" },
  "40996": { intro2SeriesName: "AS", intro2ModelKey: "45-80" },
  "40997": { intro2SeriesName: "AS", intro2ModelKey: "45-90" },
  "40998": { intro2SeriesName: "AS", intro2ModelKey: "45-100" },
  "40999": { intro2SeriesName: "AS", intro2ModelKey: "45-110" },
  "41000": { intro2SeriesName: "AS", intro2ModelKey: "45-120" },
  "41001": { intro2SeriesName: "AS", intro2ModelKey: "45-130" },
  "41003": { intro2SeriesName: "AS", intro2ModelKey: "64-10" },
  "41004": { intro2SeriesName: "AS", intro2ModelKey: "64-20" },
  "41005": { intro2SeriesName: "AS", intro2ModelKey: "64-30" },
  "41006": { intro2SeriesName: "AS", intro2ModelKey: "64-40" },
  "41007": { intro2SeriesName: "AS", intro2ModelKey: "64-50" },
  "41008": { intro2SeriesName: "AS", intro2ModelKey: "64-60" },
  "41009": { intro2SeriesName: "AS", intro2ModelKey: "64-70" },
  "41010": { intro2SeriesName: "AS", intro2ModelKey: "64-80" },
  "41011": { intro2SeriesName: "AS", intro2ModelKey: "90-10" },
  "41012": { intro2SeriesName: "AS", intro2ModelKey: "90-20" },
  "41013": { intro2SeriesName: "AS", intro2ModelKey: "90-30" },
  "41014": { intro2SeriesName: "AS", intro2ModelKey: "90-40" },
  "41015": { intro2SeriesName: "AS", intro2ModelKey: "90-50" },
  "41016": { intro2SeriesName: "AS", intro2ModelKey: "90-60" },
  "41017": { intro2SeriesName: "AS", intro2ModelKey: "90-70" },
  "41018": { intro2SeriesName: "AS", intro2ModelKey: "100-10" },
  "41019": { intro2SeriesName: "AS", intro2ModelKey: "100-20" },
  "41020": { intro2SeriesName: "AS", intro2ModelKey: "100-30" },
  "41021": { intro2SeriesName: "AS", intro2ModelKey: "100-40" },
  "41022": { intro2SeriesName: "AS", intro2ModelKey: "100-50" },
  "41023": { intro2SeriesName: "AS", intro2ModelKey: "100-60" },
  "41024": { intro2SeriesName: "AS", intro2ModelKey: "100-70" },
  "41025": { intro2SeriesName: "AS", intro2ModelKey: "100-80" },
  "41026": { intro2SeriesName: "AS", intro2ModelKey: "100-90" },
  "41027": { intro2SeriesName: "AS", intro2ModelKey: "100-100" },
  "41028": { intro2SeriesName: "AS", intro2ModelKey: "130-10" },
  "41029": { intro2SeriesName: "AS", intro2ModelKey: "130-20" },
  "41030": { intro2SeriesName: "AS", intro2ModelKey: "130-30" },
  "41031": { intro2SeriesName: "AS", intro2ModelKey: "130-40" },
  "41032": { intro2SeriesName: "AS", intro2ModelKey: "130-50" },
  "41033": { intro2SeriesName: "AS", intro2ModelKey: "130-60" },
  "41034": { intro2SeriesName: "AS", intro2ModelKey: "130-70" },
  "41035": { intro2SeriesName: "AS", intro2ModelKey: "130-80" },
  "41036": { intro2SeriesName: "AS", intro2ModelKey: "130-90" },
  "41037": { intro2SeriesName: "AS", intro2ModelKey: "130-100" },
  "41038": { intro2SeriesName: "AS", intro2ModelKey: "160-10" },
  "41039": { intro2SeriesName: "AS", intro2ModelKey: "160-20" },
  "41040": { intro2SeriesName: "AS", intro2ModelKey: "160-30" },
  "41041": { intro2SeriesName: "AS", intro2ModelKey: "160-40" },
  "41042": { intro2SeriesName: "AS", intro2ModelKey: "160-50" },
  "41043": { intro2SeriesName: "AS", intro2ModelKey: "160-60" },
  "41044": { intro2SeriesName: "AS", intro2ModelKey: "160-70" },
  "41046": { intro2SeriesName: "AS", intro2ModelKey: "190-10" },
  "41047": { intro2SeriesName: "AS", intro2ModelKey: "190-20" },
  "41048": { intro2SeriesName: "AS", intro2ModelKey: "190-30" },
  "41049": { intro2SeriesName: "AS", intro2ModelKey: "190-40" },
  "41050": { intro2SeriesName: "AS", intro2ModelKey: "190-50" },
  "41051": { intro2SeriesName: "AS", intro2ModelKey: "190-60" },
  "41052": { intro2SeriesName: "AS", intro2ModelKey: "190-70" },
  "41053": { intro2SeriesName: "AS", intro2ModelKey: "190-80" },
  "41055": { intro2SeriesName: "AS", intro2ModelKey: "32-10-1" },
  "41056": { intro2SeriesName: "AS", intro2ModelKey: "32-20-2" },
  "41057": { intro2SeriesName: "AS", intro2ModelKey: "32-30-2" },
  "41058": { intro2SeriesName: "AS", intro2ModelKey: "32-40-2" },
  "41059": { intro2SeriesName: "AS", intro2ModelKey: "32-50-2" },
  "41060": { intro2SeriesName: "AS", intro2ModelKey: "32-60-2" },
  "41061": { intro2SeriesName: "AS", intro2ModelKey: "32-70-2" },
  "41062": { intro2SeriesName: "AS", intro2ModelKey: "32-80-2" },
  "41063": { intro2SeriesName: "AS", intro2ModelKey: "32-90-2" },
  "41064": { intro2SeriesName: "AS", intro2ModelKey: "32-100-2" },
  "41066": { intro2SeriesName: "AS", intro2ModelKey: "45-10-1" },
  "41067": { intro2SeriesName: "AS", intro2ModelKey: "45-20-2" },
  "41068": { intro2SeriesName: "AS", intro2ModelKey: "45-30-2" },
  "41069": { intro2SeriesName: "AS", intro2ModelKey: "45-40-2" },
  "41070": { intro2SeriesName: "AS", intro2ModelKey: "45-50-2" },
  "41071": { intro2SeriesName: "AS", intro2ModelKey: "45-60-2" },
  "41072": { intro2SeriesName: "AS", intro2ModelKey: "45-70-2" },
  "41073": { intro2SeriesName: "AS", intro2ModelKey: "45-80-2" },
  "41074": { intro2SeriesName: "AS", intro2ModelKey: "64-10-1" },
  "41075": { intro2SeriesName: "AS", intro2ModelKey: "64-20-2" },
  "41076": { intro2SeriesName: "AS", intro2ModelKey: "64-30-2" },
  "41077": { intro2SeriesName: "AS", intro2ModelKey: "64-40-2" },
  "41078": { intro2SeriesName: "AS", intro2ModelKey: "64-50-2" },
  "41079": { intro2SeriesName: "AS", intro2ModelKey: "90-10-1" },
  "41080": { intro2SeriesName: "AS", intro2ModelKey: "90-20-2" },
  "41081": { intro2SeriesName: "AS", intro2ModelKey: "90-30-2" },
  "41082": { intro2SeriesName: "AS", intro2ModelKey: "90-40-2" },
  "41083": { intro2SeriesName: "AS", intro2ModelKey: "100-20-2" },
  "41085": { intro2SeriesName: "AS", intro2ModelKey: "100-30-2" },
  "41087": { intro2SeriesName: "AS", intro2ModelKey: "100-40-2" },
  "41090": { intro2SeriesName: "AS", intro2ModelKey: "100-50-2" },
  "41094": { intro2SeriesName: "AS", intro2ModelKey: "100-60-2" },
  "41095": { intro2SeriesName: "AS", intro2ModelKey: "130-20-1" },
  "41097": { intro2SeriesName: "AS", intro2ModelKey: "130-30-1" },
  "41098": { intro2SeriesName: "AS", intro2ModelKey: "130-40-2" },
  "41104": { intro2SeriesName: "AS", intro2ModelKey: "160-10-1" },
  "41105": { intro2SeriesName: "AS", intro2ModelKey: "160-20-1" },
  "41106": { intro2SeriesName: "AS", intro2ModelKey: "160-20-2" },
  "41108": { intro2SeriesName: "AS", intro2ModelKey: "160-30-2" },
  "41109": { intro2SeriesName: "AS", intro2ModelKey: "160-30-1" },
  "41110": { intro2SeriesName: "AS", intro2ModelKey: "160-40-2" },
  "41111": { intro2SeriesName: "AS", intro2ModelKey: "160-40-1" },
  "41113": { intro2SeriesName: "AS", intro2ModelKey: "160-50-2" },
  "41126": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-200-15/4" },
  "41172": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-110/2" },
  "41181": { intro2SeriesName: "SMA", intro2ModelKey: "50x32-200-1.5/4" },
  "41182": { intro2SeriesName: "NESO", intro2ModelKey: "NES65-50-260-22-2" },
  "41191": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-160/4" },
  "41207": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-200-7.5/2" },
  "41225": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-250/2" },
  "41358": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-500-315/4" },
  "41385": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-500-132/4" },
  "41386": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-200-18.5-2" },
  "41394": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-200-4/4" },
  "41398": { intro2SeriesName: "SMA", intro2ModelKey: "350x300-400-200/4" },
  "41402": { intro2SeriesName: "CHL", intro2ModelKey: "4-5" },
  "41460": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-400-132/4" },
  "41478": { intro2SeriesName: "SMA", intro2ModelKey: "350x300-400-500/4" },
  "41483": { intro2SeriesName: "SMA", intro2ModelKey: "350x300-400-315/4" },
  "41497": { intro2SeriesName: "SMA", intro2ModelKey: "65x40-200-15/2" },
  "41527": { intro2SeriesName: "SMA", intro2ModelKey: "125x80-400-22/4" },
  "41548": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-315-160/2" },
  "41549": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-132/2" },
  "41559": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-250-90/2" },
  "41610": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-37/2" },
  "41612": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-13(60hz)" },
  "41621": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-70-1" },
  "41740": { intro2SeriesName: "SMA", intro2ModelKey: "125x100-400-22/4" },
  "41741": { intro2SeriesName: "SMA", intro2ModelKey: "200x150-400-45/4" },
  "41742": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-315-30/4" },
  "41744": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-220/2" },
  "42640": { intro2SeriesName: "SMA", intro2ModelKey: "250x200-200-30/4" },
  "42655": { intro2SeriesName: "SMA", intro2ModelKey: "100x65-250-37/2" },
  "42680": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-40" },
  "42755": { intro2SeriesName: "AS", intro2ModelKey: "AS20-20-2" },
  "43879": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30" },
  "43889": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-30" },
  "43890": { intro2SeriesName: "SMA", intro2ModelKey: "65x50-160-4/2" },
  "43892": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)80-12F3M-I" },
  "43893": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)20-4T1M-I" },
  "43894": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)20-6T1M-I" },
  "43895": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)20-12T1M-I" },
  "43896": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)25-4T1M-I" },
  "43897": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)25-6T1M-I" },
  "43898": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)25-8T1M-I" },
  "43899": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)25-12T1M-I" },
  "43900": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)32-4T1M-I" },
  "43901": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)32-6T1M-I" },
  "43902": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)32-8F1M-I" },
  "43903": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)32-8T1M-I" },
  "43904": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)25-16T3M-I" },
  "43905": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)25-20T3M-I" },
  "43906": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)32-12F1S-I" },
  "43907": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)40-6F1S-I" },
  "43908": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)40-12F3M-I" },
  "43909": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)40-16F3M-I" },
  "43910": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)50-12F3M-I" },
  "43911": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)50-16F3M-I" },
  "43912": { intro2SeriesName: "CMS", intro2ModelKey: "CMS(L)65-12F3M-I" },
  "44264": { intro2SeriesName: "CHL", intro2ModelKey: "2-2" },
  "44265": { intro2SeriesName: "CHL", intro2ModelKey: "2-3" },
  "44266": { intro2SeriesName: "CHL", intro2ModelKey: "2-4" },
  "44267": { intro2SeriesName: "CHL", intro2ModelKey: "2-5" },
  "44268": { intro2SeriesName: "CHL", intro2ModelKey: "2-6" },
  "44269": { intro2SeriesName: "CHL", intro2ModelKey: "4-2" },
  "44270": { intro2SeriesName: "CHL", intro2ModelKey: "4-3" },
  "44271": { intro2SeriesName: "CHL", intro2ModelKey: "4-4" },
  "44272": { intro2SeriesName: "CHL", intro2ModelKey: "4-6" },
  "44273": { intro2SeriesName: "CHL", intro2ModelKey: "8-1" },
  "44274": { intro2SeriesName: "CHL", intro2ModelKey: "8-2" },
  "44275": { intro2SeriesName: "CHL", intro2ModelKey: "8-3" },
  "44276": { intro2SeriesName: "CHL", intro2ModelKey: "8-4" },
  "44277": { intro2SeriesName: "CHL", intro2ModelKey: "8-5" },
  "44278": { intro2SeriesName: "CHL", intro2ModelKey: "12-1" },
  "44279": { intro2SeriesName: "CHL", intro2ModelKey: "12-2" },
  "44280": { intro2SeriesName: "CHL", intro2ModelKey: "12-3" },
  "44281": { intro2SeriesName: "CHL", intro2ModelKey: "12-4" },
  "44282": { intro2SeriesName: "CHL", intro2ModelKey: "12-5" },
  "44283": { intro2SeriesName: "CHL", intro2ModelKey: "16-1" },
  "44284": { intro2SeriesName: "CHL", intro2ModelKey: "16-2" },
  "44285": { intro2SeriesName: "CHL", intro2ModelKey: "16-3" },
  "44286": { intro2SeriesName: "CHL", intro2ModelKey: "16-4" },
  "44287": { intro2SeriesName: "CHL", intro2ModelKey: "20-1" },
  "44288": { intro2SeriesName: "CHL", intro2ModelKey: "20-2" },
  "44289": { intro2SeriesName: "CHL", intro2ModelKey: "20-3" },
  "44814": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-40" },
  "44815": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-50" },
  "44816": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-60" },
  "44817": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-70" },
  "44818": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-80" },
  "44819": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-90" },
  "44820": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-100" },
  "44821": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-110" },
  "44822": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-120" },
  "44823": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-130" },
  "44824": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-150" },
  "44825": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-170" },
  "44826": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-190" },
  "44827": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-210" },
  "44828": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-230" },
  "44829": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-250" },
  "44830": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-270" },
  "44831": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-300" },
  "44832": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-330" },
  "44833": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-360" },
  "44834": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-30" },
  "44835": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-40" },
  "44836": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-50" },
  "44837": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-60" },
  "44838": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-70" },
  "44839": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-90" },
  "44840": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-110" },
  "44841": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-130" },
  "44842": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-150" },
  "44843": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-180" },
  "44844": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-220" },
  "44845": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-260" },
  "44846": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-40" },
  "44847": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-50" },
  "44848": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-60" },
  "44849": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-70" },
  "44850": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-80" },
  "44851": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-90" },
  "44852": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-100" },
  "44853": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-110" },
  "44854": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-120" },
  "44855": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-130" },
  "44856": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-150" },
  "44857": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-170" },
  "44858": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-190" },
  "44859": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-210" },
  "44860": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-230" },
  "44861": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-250" },
  "44862": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-270" },
  "44863": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-290" },
  "44864": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-310" },
  "44865": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-330" },
  "44866": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-360" },
  "44867": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-30" },
  "44868": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-40" },
  "44869": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-50" },
  "44870": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-60" },
  "44871": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-70" },
  "44872": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-80" },
  "44873": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-100" },
  "44874": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-120" },
  "44875": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-140" },
  "44876": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-160" },
  "44877": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-190" },
  "44878": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-220" },
  "44879": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-2(60hz)" },
  "44880": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-3(60hz)" },
  "44881": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-4(60hz)" },
  "44882": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-5(60hz)" },
  "44883": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-6(60hz)" },
  "44884": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-7(60hz)" },
  "44885": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-8(60hz)" },
  "44886": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-9(60hz)" },
  "44887": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-10(60hz)" },
  "44888": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-11(60hz)" },
  "44889": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-12(60hz)" },
  "44890": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-14(60hz)" },
  "44891": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-15(60hz)" },
  "44892": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-16(60hz)" },
  "44893": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-18(60hz)" },
  "44894": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-20(60hz)" },
  "44895": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-22(60hz)" },
  "44896": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-24(60hz)" },
  "44901": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-30" },
  "44902": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-40" },
  "44903": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-50" },
  "44904": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-60" },
  "44905": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-80" },
  "44906": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-100" },
  "44907": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-120" },
  "44908": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-140" },
  "44909": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-160" },
  "44910": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-180" },
  "44911": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-200" },
  "44912": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-20" },
  "44913": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-230" },
  "44914": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-40" },
  "44915": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-250" },
  "44916": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-60" },
  "44917": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-270" },
  "44918": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-80" },
  "44919": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-90" },
  "44920": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-100" },
  "44921": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-120" },
  "44922": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-140" },
  "44923": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-160" },
  "44924": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-180" },
  "44925": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-20" },
  "44926": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-30" },
  "44927": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-40" },
  "44928": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-50" },
  "44929": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-60" },
  "44930": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-70" },
  "44931": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-80" },
  "44932": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-100" },
  "44933": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-120" },
  "44934": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-140" },
  "44935": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-160" },
  "44936": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-20" },
  "44937": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-30" },
  "44938": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-40" },
  "44939": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-50" },
  "44940": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-60" },
  "44941": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-70" },
  "44942": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-80" },
  "44943": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-120" },
  "44944": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-140" },
  "44945": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-170" },
  "44946": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-40-2" },
  "44947": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-50-2" },
  "44948": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-100-2" },
  "44949": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-110-2" },
  "44950": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-120-2" },
  "44951": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-130-2" },
  "44952": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-140-2" },
  "44953": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-10-1" },
  "44954": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-10" },
  "44955": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-20-2" },
  "44956": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-20" },
  "44957": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-30-2" },
  "44958": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-40-2" },
  "44959": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-40" },
  "44960": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-50-2" },
  "44961": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-50" },
  "44962": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-60-2" },
  "44963": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-60" },
  "44964": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-70-2" },
  "44965": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-70" },
  "44966": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-80-2" },
  "44967": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-80" },
  "44968": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-90-2" },
  "44969": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-90" },
  "44970": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-100-2" },
  "44971": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-100" },
  "44972": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-110-2" },
  "44973": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-110" },
  "44974": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-120-2" },
  "44975": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-120" },
  "44976": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-130-2" },
  "44977": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-10-1" },
  "44978": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-10" },
  "44979": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-20-2" },
  "44980": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-20-1" },
  "44981": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-30-2" },
  "44982": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-30-1" },
  "44983": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-30" },
  "44984": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-40-1" },
  "44985": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-50-2" },
  "44986": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-50-1" },
  "44987": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-50" },
  "44988": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-60-2" },
  "44989": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-60-1" },
  "44990": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-60" },
  "44991": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-70-2" },
  "44992": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-70" },
  "44993": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-80-2" },
  "44994": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-80-1" },
  "44995": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-10-1" },
  "44996": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-10" },
  "44997": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-20-2" },
  "44998": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-20" },
  "44999": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-30-2" },
  "45000": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-30" },
  "45001": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-40-2" },
  "45002": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-40" },
  "45003": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-50-2" },
  "45004": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-50" },
  "45005": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-60-2" },
  "45006": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-60" },
  "45024": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-30" },
  "45025": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-40" },
  "45026": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-50" },
  "45027": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-60" },
  "45028": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-70" },
  "45029": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-80" },
  "45030": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-90" },
  "45031": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-100" },
  "45033": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-120" },
  "45050": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-10-1(60hz)" },
  "45051": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-B(60hz)" },
  "45079": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-20-2" },
  "45336": { intro2SeriesName: "CMB", intro2ModelKey: "120-50x8" },
  "45341": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-10" },
  "45342": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-90-2" },
  "45343": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-20" },
  "45344": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-30" },
  "45345": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-40" },
  "45346": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-50" },
  "45347": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-60" },
  "45348": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-70" },
  "45349": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-80" },
  "45350": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-90" },
  "45351": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-100" },
  "45352": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-110" },
  "45353": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-120" },
  "45354": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-130" },
  "45355": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-150" },
  "45356": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-170" },
  "45357": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-190" },
  "45358": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-210" },
  "45359": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-230" },
  "45360": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-250" },
  "45361": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-20" },
  "45362": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-30" },
  "45363": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-40" },
  "45364": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-50" },
  "45365": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-60" },
  "45366": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-70" },
  "45367": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-90" },
  "45368": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-110" },
  "45369": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-130" },
  "45370": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-150" },
  "45371": { intro2SeriesName: "CDL", intro2ModelKey: "CDL2-180" },
  "45372": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-20" },
  "45373": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-30" },
  "45374": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-40" },
  "45375": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-50" },
  "45376": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-60" },
  "45377": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-70" },
  "45378": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-80" },
  "45379": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-90" },
  "45380": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-100" },
  "45381": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-110" },
  "45382": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-120" },
  "45383": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-130" },
  "45384": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-150" },
  "45385": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-170" },
  "45386": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-190" },
  "45387": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-210" },
  "45388": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-230" },
  "45389": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-250" },
  "45390": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-20" },
  "45391": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-30" },
  "45392": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-40" },
  "45393": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-50" },
  "45394": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-60" },
  "45395": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-70" },
  "45396": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-80" },
  "45397": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-100" },
  "45398": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-120" },
  "45399": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-140" },
  "45400": { intro2SeriesName: "CDL", intro2ModelKey: "CDL4-160" },
  "45401": { intro2SeriesName: "CDL", intro2ModelKey: "CDL5-20(60hz)" },
  "45402": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-10(60hz)" },
  "45403": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-20" },
  "45404": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-30" },
  "45405": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-40" },
  "45406": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-50" },
  "45407": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-60" },
  "45408": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-80" },
  "45409": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-100" },
  "45410": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-120" },
  "45411": { intro2SeriesName: "CDL", intro2ModelKey: "CDL8-140" },
  "45412": { intro2SeriesName: "CDL", intro2ModelKey: "CDL10-20" },
  "45413": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-210" },
  "45414": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-20" },
  "45415": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-230" },
  "45416": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-40" },
  "45417": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-250" },
  "45418": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-60" },
  "45419": { intro2SeriesName: "CDL", intro2ModelKey: "CDL1-270" },
  "45420": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-80" },
  "45421": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-100" },
  "45422": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-120" },
  "45423": { intro2SeriesName: "CDL", intro2ModelKey: "CDL12-140" },
  "45424": { intro2SeriesName: "CDL", intro2ModelKey: "CDL15-10(60hz)" },
  "45425": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-10(60hz)" },
  "45426": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-20" },
  "45427": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-30" },
  "45428": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-40" },
  "45429": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-50" },
  "45430": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-60" },
  "45431": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-70" },
  "45432": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-80" },
  "45433": { intro2SeriesName: "CDL", intro2ModelKey: "CDL16-100" },
  "45434": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-10" },
  "45435": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-20" },
  "45436": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-30" },
  "45437": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-40" },
  "45438": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-50" },
  "45439": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-60" },
  "45440": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-70" },
  "45441": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-80" },
  "45442": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-10-1" },
  "45443": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-210" },
  "45444": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20-2" },
  "45445": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-20" },
  "45446": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-230" },
  "45447": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-40-2" },
  "45448": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-40" },
  "45449": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-50-2" },
  "45450": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-250" },
  "45451": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60-2" },
  "45452": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-60" },
  "45453": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-70-2" },
  "45454": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-270" },
  "45455": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-80-2" },
  "45456": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-80" },
  "45457": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-90-2" },
  "45458": { intro2SeriesName: "CDL", intro2ModelKey: "CDL3-290" },
  "45459": { intro2SeriesName: "CDL", intro2ModelKey: "CDL32-100-2" },
  "45460": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-10-1" },
  "45461": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-10" },
  "45462": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-20-2" },
  "45463": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-20" },
  "45464": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-30-2" },
  "45465": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-40-2" },
  "45466": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-40" },
  "45467": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-50-2" },
  "45468": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-50" },
  "45469": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-60-2" },
  "45470": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-60" },
  "45471": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-70-2" },
  "45472": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-70" },
  "45473": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-10-1" },
  "45474": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-10" },
  "45475": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-20-2" },
  "45476": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-30-2" },
  "45477": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-30" },
  "45478": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-50-2" },
  "45479": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-10-1" },
  "45480": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-10" },
  "45481": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-20" },
  "45482": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-30-2" },
  "45483": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-30" },
  "45484": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-40-2" },
  "45485": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-10" },
  "45486": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-2" },
  "45487": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20-1" },
  "45488": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-20" },
  "45489": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-2" },
  "45490": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30-1" },
  "45491": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-30" },
  "45492": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-2" },
  "45493": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40-1" },
  "45494": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-40" },
  "45495": { intro2SeriesName: "CDL", intro2ModelKey: "CDL120-50-2" },
  "45496": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10-1" },
  "45497": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-10" },
  "45498": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-1" },
  "45499": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20" },
  "45500": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-2" },
  "45501": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-30-1" },
  "45502": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-40-2" },
  "45503": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-B" },
  "45504": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10-A" },
  "45505": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-10" },
  "45506": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2B" },
  "45507": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-2A" },
  "45508": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20-A" },
  "45509": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-20" },
  "45510": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2B" },
  "45511": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-A-B" },
  "45512": { intro2SeriesName: "CDL", intro2ModelKey: "CDL200-30-2A" },
  "45526": { intro2SeriesName: "SMA", intro2ModelKey: "150x125-315-22/4" },
  "45571": { intro2SeriesName: "TD", intro2ModelKey: "TD80-30/2" },
  "45605": { intro2SeriesName: "NESO", intro2ModelKey: "NES80-65-260-55-2" },
  "45622": { intro2SeriesName: "CDL", intro2ModelKey: "CDL150-20-2" },
  "45623": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-30-1(60hz)" },
  "45624": { intro2SeriesName: "CDL", intro2ModelKey: "CDL90-20-1(60hz)" },
  "45625": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-20" },
  "45626": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-40-2" },
  "45627": { intro2SeriesName: "CDL", intro2ModelKey: "CDL64-40" },
  "45628": { intro2SeriesName: "CDL", intro2ModelKey: "CDL45-30" },
  "45629": { intro2SeriesName: "CDL", intro2ModelKey: "CDL20-100" },
  "45632": { intro2SeriesName: "AS", intro2ModelKey: "100-90-2" },
};

export const normalizeParameterSheetModel = (value: unknown): string => {
  return String(value || "")
    .trim()
    .toUpperCase()
    .replace(/（/g, "(")
    .replace(/）/g, ")")
    .replace(/\b(50|60)\s*HZ\b/g, "")
    .replace(/(\d)[Xx](\d)/g, "$1$2")
    .replace(/[^A-Z0-9]+/g, "");
};

export const normalizeParameterSheetSpuId = (value: unknown): string => {
  if (value === undefined || value === null) return "";
  return String(value).trim();
};

export const resolveParameterSheetMapping = (
  spuId: unknown,
  model?: unknown
): ParameterSheetMappingEntry | null => {
  const normalizedId = normalizeParameterSheetSpuId(spuId);
  if (normalizedId && PARAMETER_SHEET_SPU_ID_MAPPING[normalizedId]) {
    return PARAMETER_SHEET_SPU_ID_MAPPING[normalizedId];
  }

  const normalizedModel = normalizeParameterSheetModel(model);
  if (!normalizedModel) return null;
  return PARAMETER_SHEET_MODEL_MAPPING[normalizedModel] || null;
};
